{
  "common": {
    "languageName": "English",
    "switchTo": "العربية",
    "locales": {
      "ar": "Arabic",
      "en": "English"
    }
  },
  "support": {
    "whatsapp": {
      "open": "Chat with us on WhatsApp"
    }
  },
  "providerSyncProgress": {
    "progressDeterminate": "Fetched {{fetched}} of {{total}} items across {{pages}} pages.",
    "progressIndeterminate": "Fetched {{fetched}} items across {{pages}} pages.",
    "rateLimited": "Provider rate limit reached. Tlaaq will retry automatically.",
    "rateLimitedWithTime": "Provider rate limit reached. Tlaaq will retry around {{retryAt}}.",
    "failed": "Sync failed with code {{code}}.",
    "unknownError": "UNKNOWN_ERROR",
    "status": {
      "QUEUED": "Queued",
      "RUNNING": "Running",
      "RATE_LIMITED": "Rate limited",
      "SUCCEEDED": "Succeeded",
      "SUCCEEDED_WITH_ISSUES": "Succeeded with issues",
      "FAILED": "Failed"
    }
  },
  "auth": {
    "google": {
      "title": "Google sign-in",
      "signUp": "Sign up with Google",
      "loading": "Loading Google sign-in…",
      "unavailable": "Google sign-in is unavailable. You can still use email and password.",
      "retry": "Try Google again",
      "failed": "Google sign-in could not be completed. Please try again.",
      "notLinked": "This Google account is not connected to Tlaaq. Create a workspace or connect your existing account.",
      "conflict": "This Google account cannot be connected. Try a different Google account, or continue without connecting.",
      "missingDetails": "Enter your name and organization to continue.",
      "create": "Create a new workspace",
      "connect": "Connect an existing account",
      "signupHint": "Create your workspace using your Google email. No password is needed. You can set one later using Forgot password.",
      "linkHint": "Confirm your existing Tlaaq email and password, then choose the Google account to connect. Forgot your password? Go back to email sign-in to request a reset link.",
      "continue": "Continue",
      "confirmSignup": "Choose your Google account to create {{organization}}. Your Google email will be your Tlaaq login email.",
      "confirmLink": "Choose the Google account you want to connect to {{email}}. Both login methods will open the same workspace.",
      "skipLink": "Continue without connecting Google",
      "back": "Back to email sign-in or signup",
      "orEmail": "Or use email and password"
    },
    "layout": {
      "backHome": "Back to home",
      "hero": {
        "title": "Sell across MENA marketplaces from one workspace you actually own.",
        "subtitle": "Connect ZID, Salla, Amazon and Trendyol. Tlaaq holds your products, warehouses and stock — Zoho is optional, never required.",
        "pills": {
          "channels": "Connect with most stores",
          "ownInventory": "Support for local and global inventory systems",
          "stockSplit": "Structured quantity distribution"
        }
      }
    },
    "login": {
      "eyebrow": "Welcome",
      "title": "Sign in to Tlaaq",
      "hero": {
        "title": "Distribute stock percentages across your stores",
        "subtitle": "Connect your stores to your warehouse, and Tlaaq keeps stock distributed according to the percentages you set—continuously."
      },
      "email": "Email",
      "emailPlaceholder": "you@company.com",
      "password": "Password",
      "passwordPlaceholder": "Enter your password",
      "forgot": "Forgot password?",
      "submit": "Sign in",
      "submitting": "Signing in…",
      "newToTlaaq": "New to Tlaaq?",
      "createAccount": "Create an account",
      "contexts": {
        "zidOAuth": "Sign in to finish connecting your Zid store. We saved the secure handoff from Zid and will continue automatically.",
        "sallaOAuth": "Sign in to finish connecting your Salla store. We saved the secure handoff from Salla and will continue automatically.",
        "amazonOAuth": "Sign in to finish connecting your Amazon seller account. We saved the secure handoff from Amazon and will continue automatically.",
        "zohoOAuth": "Sign in to finish connecting Zoho Inventory."
      },
      "errors": {
        "missingFields": "Enter your email and password to continue.",
        "expired": "Your password has expired. Request a reset link to choose a new one.",
        "invalidCredentials": "The email or password is incorrect. You can also continue with Google or use Forgot password to set a password.",
        "network": "We could not reach Tlaaq. Please try again.",
        "sendReset": "Send me a reset link"
      }
    },
    "register": {
      "title": "Start with your store",
      "subtitle": "Create the organization and owner account for your Tlaaq workspace.",
      "hero": {
        "title": "Sync your warehouse with your stores.\nManage store orders from one place.",
        "subtitle": "Connect your stores to your warehouse and manage stock distribution and orders from one place."
      },
      "fullName": "Full name",
      "fullNamePlaceholder": "Ahmed",
      "organizationName": "Organization or store name",
      "organizationPlaceholder": "Tlaaq",
      "email": "Email",
      "emailPlaceholder": "you@company.com",
      "password": "Password",
      "passwordPlaceholder": "Create a strong password",
      "submit": "Register",
      "submitting": "Registering…",
      "haveAccount": "Already have an account?",
      "signIn": "Sign in",
      "legal": {
        "prefix": "By creating an account, you agree to the",
        "terms": "Terms of Service",
        "middle": "and acknowledge the",
        "privacy": "Privacy Policy"
      },
      "contexts": {
        "zidOAuthSubtitle": "Create your workspace to finish installing Tlaaq from Zid.",
        "zidOAuth": "After you create the workspace, Tlaaq will return to Zid connection setup and start the first import.",
        "sallaOAuthSubtitle": "Create your workspace to finish connecting your Salla store.",
        "sallaOAuth": "After you create the workspace, Tlaaq will return to Salla connection setup and start the first import.",
        "amazonOAuthSubtitle": "Create your workspace to finish connecting your Amazon seller account.",
        "amazonOAuth": "After you create the workspace, Tlaaq will return to Amazon connection setup and start the first catalog and order import.",
        "zohoOAuth": "Create your account to finish connecting Zoho Inventory.",
        "zohoOAuthSubtitle": "Create your Tlaaq workspace first, then we will return to Zoho Inventory connection."
      },
      "errors": {
        "missingFields": "Complete all fields to create your workspace.",
        "policy": "Update your password so it matches the policy checklist.",
        "emailTaken": "An account already exists for this email. Sign in instead.",
        "policyServer": "Your password does not meet the policy requirements.",
        "network": "We could not create your workspace. Please try again."
      }
    },
    "forgot": {
      "eyebrow": "Password reset",
      "title": "Reset your password",
      "titleSent": "Check your inbox",
      "subtitle": "Enter your work email and we will send a secure reset link.",
      "subtitleSent": "If an account exists for that email, we sent reset instructions.",
      "email": "Work email",
      "emailPlaceholder": "you@company.com",
      "submit": "Send reset link",
      "submitting": "Sending…",
      "back": "Back to sign in",
      "afterNote": "You can safely close this screen or return to sign in after choosing your new password.",
      "returnToSignIn": "Return to sign in"
    },
    "reset": {
      "eyebrow": "Choose a new password",
      "title": "Reset your password",
      "subtitle": "Create a fresh password that follows the workspace security policy.",
      "newPassword": "New password",
      "newPasswordPlaceholder": "Create a strong password",
      "confirmPassword": "Confirm password",
      "confirmPasswordPlaceholder": "Repeat the new password",
      "submit": "Reset password",
      "submitting": "Resetting password…",
      "needNewLink": "Need a new link?",
      "invalidEyebrow": "Reset link",
      "invalidTitle": "This reset link is invalid",
      "invalidSubtitle": "The link may have expired or already been used. Request a new reset link to continue.",
      "requestNew": "Request a new link",
      "requestNewLong": "Request a new reset link",
      "errors": {
        "missingFields": "Enter and confirm your new password.",
        "mismatch": "The two password fields do not match.",
        "policy": "Update your password so it matches the policy checklist.",
        "policyServer": "Your password does not meet the policy requirements.",
        "network": "We could not reset your password. Please try again."
      }
    },
    "invite": {
      "eyebrow": "Team invitation",
      "loadingTitle": "Checking your invitation",
      "loadingSubtitle": "We are confirming that this secure invitation link is still valid.",
      "title": "Join {{organization}}",
      "subtitle": "Create your password to join the workspace with full store access.",
      "newPassword": "Password",
      "newPasswordPlaceholder": "Create a strong password",
      "confirmPassword": "Confirm password",
      "confirmPasswordPlaceholder": "Repeat your password",
      "submit": "Accept invitation",
      "submitting": "Joining workspace…",
      "backToLogin": "Back to sign in",
      "privacyPrefix": "Review how Tlaaq handles your personal data in the",
      "privacy": "Privacy Policy",
      "invalidEyebrow": "Invitation link",
      "invalidTitle": "This invitation is invalid",
      "invalidSubtitle": "The link may have expired, been cancelled, or already been used. Ask the workspace owner for a new invitation.",
      "details": {
        "organization": "Workspace",
        "invitee": "Invited teammate",
        "email": "Email",
        "expires": "Expires {{date}}"
      },
      "errors": {
        "missingFields": "Enter and confirm your new password.",
        "mismatch": "The two password fields do not match.",
        "policy": "Update your password so it matches the policy checklist.",
        "policyServer": "Your password does not meet the policy requirements.",
        "emailAlreadyUser": "This email already has an account. Sign in instead or ask the owner for a new invite.",
        "network": "We could not accept this invitation. Please try again."
      }
    },
    "policy": {
      "length": "12–128 characters",
      "lowercase": "One lowercase letter",
      "uppercase": "One uppercase letter",
      "number": "One number",
      "symbol": "One symbol",
      "noPersonal": "Does not contain your name or email"
    }
  },
  "localeSwitcher": {
    "label": "Language"
  },
  "imports": {
    "title": "Imports", "close": "Close imports", "back": "Back", "all": "All", "detailTitle": "Import details",
    "loading": "Loading imports…", "empty": "No imports yet.", "stale": "Updates are temporarily unavailable. Showing the latest saved jobs.", "retry": "Retry", "unavailable": "This import is currently unavailable.", "unknownChannel": "Unknown channel",
    "queued": "Import #{{id}} is queued.", "submit": "Start import", "submitting": "Starting…", "submitError": "The import could not be started. Try again.",
    "productsHint": "Import using your current catalog and stock sources. Source ownership will not change.", "ordersHint": "Optionally limit the order import to a date range.",
    "continue": "Continue working", "continueHint": "Started imports continue in the background. Open Imports on any page to see progress.",
    "setup": { "products": "Import products", "orders": "Import orders", "noon-catalog": "Import Noon catalog", "noon-sales": "Import Noon sales" },
    "kinds": { "products": "Products", "orders": "Orders", "onboarding": "Channel onboarding", "noon-catalog": "Noon catalog", "noon-sales": "Noon sales" },
    "status": { "QUEUED": "Queued", "RUNNING": "Running", "DEFERRED": "Deferred", "COMPLETED": "Completed", "COMPLETED_WITH_ISSUES": "Completed with issues", "FAILED": "Failed", "CANCELLED": "Cancelled" },
    "fields": { "fetched": "Fetched", "upserted": "Saved", "processedRowCount": "Processed", "totalIssueCount": "Issues", "errorCode": "Error", "rows": "Rows", "imported": "Imported", "mapped": "Matched", "unmapped": "Unmapped", "skipped": "Skipped", "productFetched": "Products fetched", "productUpserted": "Products saved", "orderFetched": "Orders fetched", "orderUpserted": "Orders saved", "orderSkipped": "Orders skipped", "dataRowCount": "Total rows", "matchedOrderUpdatedCount": "Orders updated", "standaloneCreatedCount": "Sales created", "skippedCount": "Skipped", "conflictCount": "Conflicts", "failedCount": "Failed", "productsCreated": "Products created", "productsUpdated": "Products updated", "issueCount": "Issues" }
  },
  "nav": {
    "groups": {
      "operate": "Operate",
      "connect": "Connect",
      "setup": "Setup"
    },
    "mobile": {
      "label": "Primary navigation"
    },
    "items": {
      "home": "Home",
      "analytics": "Analytics",
      "orders": "Orders",
      "products": "Products",
      "channels": "Channels",
      "inventory": "Inventory",
      "warehouses": "Warehouses",
      "team": "Team",
      "billing": "Billing",
      "settings": "Settings"
    },
    "topbar": {
      "signOut": "Sign out"
    },
    "demo": {
      "organization": "Fitneeds",
      "domain": "fitneeds.sa",
      "avatarName": "Lubna"
    }
  },
  "app": {
    "loading": {
      "eyebrow": "Secure session",
      "title": "Checking your session",
      "subtitle": "We are restoring your Tlaaq workspace if you already signed in.",
      "body": "Loading…"
    },
    "meta": {
      "home": {
        "title": "Home",
        "subtitle": "Live workspace overview"
      },
      "analytics": {
        "title": "Analytics",
        "subtitle": "Sales performance by period, currency, and channel"
      },
      "orders": {
        "title": "Orders",
        "newBadge": "{{count}} new"
      },
      "orderRouting": {
        "title": "Order Routing",
        "subtitle": "Route each order to the right Zoho values"
      },
      "products": {
        "title": "Products",
        "badge": "Phase 1"
      },
      "channels": {
        "title": "Channels"
      },
      "inventory": {
        "title": "Inventory"
      },
      "tlaaqInventoryDetail": {
        "title": "Tlaaq Inventory",
        "subtitle": "Local stock, allocation, and order deduction"
      },
      "warehouses": {
        "title": "Warehouses"
      },
      "team": {
        "title": "Team"
      },
      "billing": {
        "title": "Billing"
      },
      "settings": {
        "title": "Settings"
      },
      "zohoDetail": {
        "title": "Zoho Inventory",
        "subtitle": "Inventory source · connected"
      },
      "zohoOrderAudit": {
        "title": "Zoho order audit",
        "subtitle": "Inventory · Zoho Inventory · Read-only reconciliation"
      },
      "syncWizard": {
        "title": "Zoho order policy",
        "subtitle": "Inventory · Zoho Inventory · Order policy"
      },
      "productDetail": {
        "title": "Product detail"
      },
      "productsEmpty": {
        "title": "Products",
        "subtitle": "Get your catalog into Tlaaq"
      },
      "productNew": {
        "title": "New product",
        "subtitle": "Create master product data and images"
      },
      "productEdit": {
        "title": "Edit product",
        "subtitle": "Update master product data and images"
      },
      "channelDetail": {
        "title": "Channel connection",
        "subtitle": "Channels · connection settings"
      },
      "unmappedChannelListings": {
        "title": "Review unmapped listings",
        "subtitle": "Map channel products to their main Tlaaq product"
      },
      "channelInventoryVariance": {
        "title": "Channel inventory variance",
        "subtitle": "Channels · source availability vs channel snapshots"
      },
      "zohoPullRunDetail": {
        "title": "Zoho pull details",
        "subtitle": "Inventory · Zoho Inventory · Product pull"
      },
      "stockAllocationRules": {
        "title": "Stock allocation rules",
        "subtitle": "Choose warehouses, allocation percentages, branch targets, and product exclusions for each connected Zid, Salla, or Noon FBPI store. Manual product stock push stays available from Product Detail."
      },
      "stockAllocationActivity": {
        "title": "Stock allocation activity",
        "subtitle": "Review automated stock updates, rejected products, and retry results."
      }
    }
  },
  "home": {
    "stats": {
      "orders": "Orders last 24h",
      "ordersSub": "across {{count}} channels",
      "revenue": "Revenue last 24h",
      "revenueSub": "From persisted orders",
      "connectedChannels": "Connected channels",
      "connectedChannelsSub": "{{connected}} of {{total}} connected",
      "actionQueue": "Action queue",
      "actionQueueSub": "From live workspace data"
    },
    "channelHealth": {
      "title": "Channel health",
      "realtime": "Based on connected channels in this workspace.",
      "live": "LIVE DATA",
      "ordersToday": "{{count}} orders",
      "revenueToday": "{{amount}}",
      "lastSync": "Last sync {{value}}",
      "empty": {
        "title": "No channels connected yet",
        "body": "Connect a channel to start seeing order and sync health here.",
        "cta": "Open channels"
      }
    },
    "recent": {
      "title": "Recent orders",
      "subtitle": "Latest persisted orders across connected channels.",
      "viewAll": "View all →",
      "empty": {
        "title": "No orders yet",
        "body": "Orders will appear after a connected channel pulls or receives them."
      }
    },
    "quickActions": {
      "title": "Quick actions",
      "connectChannel": "Connect a new channel",
      "inviteTeam": "Invite team member",
      "subtitle": "Jump into the workflows store owners use most.",
      "connectChannelDesc": "Add Zid, Salla, Amazon, Noon, or Trendyol.",
      "addProduct": "Add product",
      "addProductDesc": "Create or review catalog entries.",
      "reviewOrders": "Review orders",
      "reviewOrdersDesc": "Check new and in-progress orders.",
      "inviteTeamDesc": "Bring an operator into this workspace."
    },
    "currency": "SAR",
    "emptyValue": "—",
    "hero": {
      "eyebrow": "Store command center",
      "title": "Your operations dashboard is backed by live workspace data.",
      "body": "Track persisted orders, connected-channel health, and inventory risk from one operational view.",
      "window": "Last 24 hours",
      "primaryAction": "Review channels",
      "secondaryAction": "Open products"
    },
    "loading": {
      "title": "Loading dashboard",
      "body": "We are reading your workspace data.",
      "badge": "Loading"
    },
    "errors": {
      "title": "Could not load dashboard",
      "retry": "Retry",
      "codes": {
        "REQUEST_FAILED": "We could not load the dashboard. Please try again.",
        "UNAUTHORIZED": "Your session expired. Sign in again to view the dashboard."
      }
    },
    "coverage": {
      "title": "Workspace coverage",
      "subtitle": "Factual coverage from products, stock, listings, and channels.",
      "totalProducts": "Total products",
      "listedProducts": "Products with channel listings",
      "stockCoveredProducts": "Products with available stock",
      "connectedChannels": "Connected channels"
    },
    "actionQueue": {
      "title": "Action queue",
      "subtitle": "Only real persisted conditions are shown here.",
      "empty": {
        "title": "No action items right now",
        "body": "Tlaaq did not find channel, listing, order, or low-stock issues in the current workspace data."
      },
      "items": {
        "CHANNEL_ATTENTION": {
          "title": "Channels needing attention: {{count}}",
          "body": "One or more connected channels is disconnected, expired, or reporting an error.",
          "badge": "Channels: {{count}}",
          "cta": "Review channels"
        },
        "LOW_STOCK": {
          "title": "Low-stock products: {{count}}",
          "body": "Available stock is at or below the operational low-stock threshold of 5 units.",
          "badge": "Products: {{count}}",
          "cta": "Open inventory"
        },
        "CHANNEL_INVENTORY_VARIANCE": {
          "title": "Inventory variances on channels: {{count}}",
          "body": "Mapped listings have channel stock snapshots that do not match source availability.",
          "badge": "Variances: {{count}}",
          "cta": "Review report"
        },
        "UNMAPPED_LISTINGS": {
          "title": "Unmapped listings needing review: {{count}}",
          "body": "A provider listing is stored but not linked to a Tlaaq product yet.",
          "badge": "Listings: {{count}}",
          "cta": "Open products"
        },
        "FAILED_ZOHO_SYNC": {
          "title": "Orders with failed Zoho sync: {{count}}",
          "body": "A persisted order has a failed Zoho handoff status and needs review.",
          "badge": "Orders: {{count}}",
          "cta": "Review orders"
        },
        "ZOHO_CONNECTION_ATTENTION": {
          "title": "Reconnect Zoho Inventory",
          "body": "Your Zoho connection is unavailable. Reconnect it from Inventory to resume order sending. Existing sync records are preserved.",
          "badge": "Connection unavailable",
          "cta": "Open inventory"
        }
      }
    },
    "trend": {
      "title": "Sales pulse",
      "subtitle": "Orders and revenue from persisted orders for the last 7 days.",
      "orders": "Orders",
      "revenue": "Revenue",
      "metricToggle": "Sales pulse metric",
      "metrics": {
        "revenue": "Revenue",
        "orders": "Orders"
      },
      "summaryRevenue": "7-day revenue: {{amount}}",
      "summaryOrders": "7-day orders: {{count}}",
      "bestDay": "Best day: {{day}}",
      "selectedDay": "Selected day: {{day}} · Orders: {{orders}} · Revenue: {{revenue}}",
      "dayAria": "{{day}} · Orders: {{orders}} · Revenue: {{revenue}}"
    },
    "inventoryWatchlist": {
      "title": "Inventory watchlist",
      "subtitle": "Active products at or below the low-stock threshold.",
      "available": "{{count}} available",
      "reserved": "{{count}} committed",
      "risk": {
        "HIGH": "High risk",
        "MEDIUM": "Medium risk"
      },
      "empty": {
        "title": "No low-stock products",
        "body": "No active products are currently at or below the low-stock threshold."
      },
      "cta": "Open inventory",
      "openProductAria": "Open product {{name}}"
    }
  },
  "channels": {
    "description": "Connecting a channel links the store; it does not import products by itself. Choose where products and stock are managed, then pull products when you are ready.",
    "noonRefresh": {
      "action": "Refresh all Noon listings",
      "active": "Noon refresh active",
      "title": "Listing refresh · {{name}}",
      "description": "Refresh titles, offer status, and warehouse stock for listings already imported into Tlaaq. Runs in the background; does not discover new products or change master inventory.",
      "retainedProgress": "Progress for {{count}} listings is saved. Retry continues from the last checkpoint.",
      "result": {
        "processed": "Listings processed",
        "refreshed": "Listings refreshed",
        "issues": "Listings with issues"
      },
      "issues": {
        "codes": {
          "NOON_LISTING_REFRESH_OFFER_REJECTED": "Noon rejected the offer lookup for {{sku}}. Previous data was preserved; other listings continued.",
          "NOON_LISTING_REFRESH_INVALID_RESPONSE": "Noon returned incomplete or invalid data for {{sku}}. Previous data was preserved.",
          "NOON_LISTING_REFRESH_CONFLICT": "Listing {{sku}} changed during refresh. Its newer data was preserved.",
          "CHANNEL_LISTING_SKU_REQUIRED": "A listing has no partner SKU and could not be refreshed."
        }
      }
    },
    "noonCatalogImport": {
      "action": "Import products from Excel",
      "title": "Import Noon products · {{name}}",
      "close": "Close",
      "description": "Match Noon partner SKUs to main or alternate SKUs in your inventory catalog, including products imported from Zoho. This does not change product names, stock quantities, or your inventory source. Unmatched listings remain available for review.",
      "fileLabel": "Noon catalog Excel file",
      "fileHint": "One sheet, .xlsx, up to 5 MB and 5,000 rows. Required column: partner_sku. Optional: noon_title. Keep identifiers as text to preserve leading zeros. The first valid row for each partner SKU is used; later duplicates are skipped. Reimporting updates existing listings.",
      "upload": "Import catalog",
      "uploading": "Importing…",
      "completed": "Imported {{imported}} listings from {{rows}} rows.",
      "counts": {
        "imported": "Listings imported",
        "mapped": "Matched",
        "unmapped": "Needs mapping",
        "skipped": "Rows skipped"
      },
      "issues": "Review row issues ({{count}})",
      "row": "Row {{row}}",
      "issueCodes": {
        "DUPLICATE_SKU": "Duplicate partner SKU; the first valid row was kept.",
        "MISSING_TITLE": "Imported without a title; partner SKU is available for matching.",
        "SKU_INVALID": "Partner SKU is missing, exceeds 64 characters, or is not a safe whole-number identifier. Store long identifiers as text.",
        "TITLE_TOO_LONG": "Title exceeds 512 characters; row skipped.",
        "CELL_TYPE_INVALID": "Formula, error, or unsupported cell type; row skipped. Use text identifiers and titles."
      },
      "errors": {
        "FILE_REQUIRED": "Choose an Excel file to import.",
        "FILE_TYPE_INVALID": "Choose a .xlsx Excel file.",
        "FILE_TOO_LARGE": "The file exceeds the 5 MB upload limit or 20 MB uncompressed limit.",
        "SHEET_INVALID": "Use a workbook containing exactly one sheet.",
        "HEADER_INVALID": "The first row must contain a unique partner_sku column. Use unique headers and no more than 32 columns.",
        "ROW_LIMIT": "The sheet exceeds 5,000 data rows. Split it into smaller files.",
        "EMPTY": "The sheet contains no product rows.",
        "WORKBOOK_INVALID": "The workbook could not be read safely. Save a new .xlsx file without macros or external links.",
        "CONNECTION_INVALID": "Choose a connected Noon channel.",
        "REQUEST_FAILED": "Import could not be completed. Check your connection and try again. Reimporting will not duplicate existing listings."
      }
    },
    "noonSalesImport": {
      "action": "Import Noon sales",
      "title": "Import Noon sales · {{name}}",
      "description": "Reconcile FBN and FBP item rows from a Noon CSV or Excel sales report.",
      "partnerLabel": "Noon partner ID (id_partner)",
      "partnerHint": "Enter the id_partner from your report for the first import. It is saved after the report is accepted. API credentials and webhooks are optional; you can set up FBPI later.",
      "excelOnly": "Excel imports only",
      "close": "Close",
      "fulfillmentTitle": "Accepted fulfillment labels",
      "fulfillment": {
        "fbn": "Fulfilled by Noon (FBN)",
        "supermall": "Supermall",
        "fbp": "Fulfilled by Partner (FBP)"
      },
      "matching": "A matching item_nr updates its existing order. An unmatched row creates a standalone item-level sale.",
      "chronologicalWarning": "Later uploads win for status and dates. Upload reports in chronological export order.",
      "fileLabel": "Noon sales report",
      "fileHint": "{{extensions}} · up to {{size}} MB and {{rows}} rows",
      "timeZoneLabel": "Source timezone",
      "timeZonePlaceholder": "Asia/Riyadh",
      "timeZoneHint": "Enter the IANA timezone used by timestamps without an offset.",
      "upload": "Upload report",
      "uploading": "Uploading…",
      "reupload": "Upload another report",
      "cancel": "Cancel import",
      "cancelling": "Cancelling…",
      "loadingLatest": "Loading the latest import…",
      "pollWarning": "Status refresh failed temporarily. Retrying automatically…",
      "jobTitle": "Import job #{{id}}",
      "counts": {
        "processed": "Rows processed",
        "matched": "Matched orders",
        "standalone": "Standalone items",
        "issues": "Issues"
      },
      "acceptedCounts": "Accepted FBN rows: {{fbn}} · Accepted FBP rows: {{fbp}}",
      "issueSummaryTitle": "Issue summary",
      "issueContext": "{{count}} occurrence(s), first at row {{row}}",
      "rowsTitle": "Row outcomes",
      "rowNumber": "Row {{row}}",
      "unknownItem": "Unknown item",
      "noRowIssues": "No row issues",
      "page": "Page {{page}} of {{pages}}",
      "previous": "Previous",
      "next": "Next",
      "status": {
        "QUEUED": "Queued",
        "RUNNING": "Running",
        "COMPLETED": "Completed",
        "COMPLETED_WITH_ISSUES": "Completed with issues",
        "FAILED": "Failed",
        "CANCELLED": "Cancelled"
      },
      "outcomes": {
        "PENDING": "Pending",
        "MATCHED_ORDER_UPDATED": "Matched order updated",
        "MATCHED_ORDER_UNCHANGED": "Matched order unchanged",
        "STANDALONE_CREATED": "Standalone item created",
        "STANDALONE_UPDATED": "Standalone item updated",
        "STANDALONE_UNCHANGED": "Standalone item unchanged",
        "SUPERSEDED": "Standalone item superseded",
        "SKIPPED": "Skipped",
        "CONFLICT": "Conflict",
        "FAILED": "Failed"
      },
      "issueCodes": {
        "UNKNOWN": "Unknown import issue",
        "NOON_SALES_IMPORT_ITEM_MATCH_AMBIGUOUS": "The item matches more than one order.",
        "NOON_SALES_IMPORT_PARENT_STATUS_CONFLICT": "Rows for the same order have conflicting status or dates.",
        "NOON_SALES_IMPORT_DUPLICATE_ITEM_CONFLICT": "Duplicate item rows conflict.",
        "NOON_SALES_IMPORT_DUPLICATE_IDENTICAL_ROW": "An identical duplicate row was skipped.",
        "NOON_SALES_IMPORT_IDENTITY_COLLISION": "The item identity conflicts with an existing record.",
        "NOON_SALES_IMPORT_FULFILLMENT_UNSUPPORTED": "The fulfillment label is not supported.",
        "NOON_SALES_IMPORT_FORMULA_CELL": "Formula cells are not accepted.",
        "NOON_SALES_IMPORT_ERROR_CELL": "The workbook contains an error cell.",
        "NOON_SALES_IMPORT_INVALID_TYPE": "A cell has an invalid type.",
        "NOON_SALES_IMPORT_DECIMAL_INVALID": "A decimal value is invalid.",
        "NOON_SALES_IMPORT_CURRENCY_INVALID": "The currency is invalid.",
        "NOON_SALES_IMPORT_DATE_CHRONOLOGY_INVALID": "Shipment or delivery dates are out of order.",
        "NOON_SALES_IMPORT_ROW_PROCESSING_FAILED": "The row could not be processed.",
        "NOON_SALES_IMPORT_SCHEDULE_FAILED": "The import could not be scheduled.",
        "NOON_SALES_IMPORT_STALLED": "The import stopped making progress."
      },
      "errors": {
        "REQUEST_FAILED": "The Noon sales import request failed. Try again.",
        "NOON_SALES_IMPORT_PARTNER_REQUIRED": "Enter a numeric Noon partner ID matching every row in the report.",
        "NOON_SALES_IMPORT_CONNECTION_PARTNER_UNRESOLVED": "Enter the Noon partner ID before the first Excel import.",
        "NOON_SALES_IMPORT_PARTNER_MISMATCH": "The report or API account belongs to a different Noon partner than this channel.",
        "NOON_SALES_IMPORT_MIXED_PARTNERS": "Upload a report containing only this channel's Noon partner ID.",
        "NOON_SALES_IMPORT_CONNECTION_INVALID": "This channel is disconnected or is not a Noon channel.",
        "NOON_SALES_IMPORT_CONFIGURATION_INVALID": "Noon sales import is not configured with accepted file types and fulfillment models.",
        "NOON_SALES_IMPORT_FILE_REQUIRED": "Choose a Noon .csv or .xlsx sales report.",
        "NOON_SALES_IMPORT_FILE_TYPE_INVALID": "Choose a valid .csv or .xlsx file.",
        "NOON_SALES_IMPORT_FILE_TOO_LARGE": "The report exceeds the allowed file size.",
        "NOON_SALES_IMPORT_TIMEZONE_REQUIRED": "Enter the report's source timezone.",
        "NOON_SALES_IMPORT_TIMEZONE_INVALID": "Enter a valid IANA timezone.",
        "NOON_SALES_IMPORT_ACTIVE_JOB": "Another import is already active for this Noon connection.",
        "NOON_SALES_IMPORT_DISABLED": "Noon sales import is currently disabled.",
        "NOON_SALES_IMPORT_JOB_NOT_FOUND": "The import job was not found.",
        "NOON_SALES_IMPORT_CANCELLATION_CONFLICT": "This import can no longer be cancelled.",
        "NOON_SALES_IMPORT_PARTNER_MISMATCH": "The report does not belong to this Noon connection.",
        "NOON_SALES_IMPORT_MIXED_PARTNERS": "The report contains more than one Noon partner.",
        "NOON_SALES_IMPORT_WORKBOOK_INVALID": "The workbook is invalid or unsafe.",
        "NOON_SALES_IMPORT_WORKBOOK_HEADER_INVALID": "The report columns do not match a supported Noon sales export.",
        "NOON_SALES_IMPORT_NO_ACCEPTED_ROWS": "The report contains no accepted sales rows."
      }
    },
    "connect": "Connect channel",
    "onboardingStockOwner": {
      "title": "Where will you manage stock?",
      "subtitle": "Products and stock are imported from {{store}} either way. This decides who owns stock after the import.",
      "recommended": "Recommended",
      "tlaaq": {
        "title": "Tlaaq",
        "body": "Use Tlaaq as your inventory system. You edit stock in Tlaaq and push it to {{store}}. {{store}} orders reduce Tlaaq stock."
      },
      "channel": {
        "body": "Keep managing stock in {{store}}. Tlaaq reads quantities from {{store}} and does not push stock back."
      },
      "hint": {
        "tlaaq": "Tlaaq takes over stock when the first import finishes. You can change this later in Inventory.",
        "channel": "{{store}} keeps managing stock. You can switch to Tlaaq later in Inventory."
      },
      "error": "Could not save your choice. Try again.",
      "applied": {
        "title": "Tlaaq now manages your stock",
        "body": "Quantities were imported from {{store}}. Edit stock in Tlaaq and push it to {{store}} from each product. {{store}} still owns product details."
      }
    },
    "providers": {
      "ZID": "Zid",
      "SALLA": "Salla",
      "AMAZON": "Amazon",
      "TRENDYOL": "Trendyol",
        "NOON": "Noon",
        "ZOHO": "Zoho"
      },
    "status": {
      "PENDING": "Pending setup",
      "CONNECTED": "Connected",
      "DISCONNECTED": "Disconnected",
      "AUTH_EXPIRED": "Auth expired",
      "ERROR": "Error"
    },
    "adapter": {
      "available": "Adapter available",
      "comingLater": "Adapter coming later"
    },
    "form": {
      "title": "Add channel connection",
      "provider": "Provider",
      "providerPlaceholder": "Select provider",
      "displayName": "Display name",
      "displayNamePlaceholder": "Fitneeds Zid",
      "helper": "This creates a pending connection placeholder. After the channel is connected, choose whether Tlaaq or that store owns products and stock.",
      "submit": "Add channel",
      "submitting": "Adding…"
    },
    "actions": {
      "refresh": "Refresh",
      "manage": "Manage",
      "delete": "Delete",
      "deleting": "Deleting…",
      "connect": "Connect",
      "connecting": "Connecting…",
      "pullProducts": "Pull products",
      "manageSource": "Manage source",
      "saveSource": "Save source choice",
      "savingSource": "Saving…",
      "pullAndImport": "Save and pull",
      "refreshListings": "Refresh listings",
      "importing": "Importing…",
      "queueingProducts": "Queueing…",
      "productPullActive": "Product pull active",
      "enterCredentials": "Enter credentials",
      "reconnectCredentials": "Reconnect",
      "updateCredentials": "Update credentials",
      "pullOrders": "Pull orders",
      "reviewUnmapped": "Review unmapped listings",
      "reviewUnmappedShort": "Review unmapped",
      "pullingOrders": "Pulling orders…",
      "stockAllocation": "Stock allocation"
    },
    "stockSyncAlert": {
      "title": "{{provider}} stock sync needs attention",
      "body": "{{pushed}} product stock requests were accepted and {{failed}} failed. Acceptance does not confirm remote stock. Review the exact item results before retrying.",
      "action": "Review activity"
    },
    "credentials": {
      "trendyolTitle": "Trendyol credentials for {{name}}",
      "trendyolSubtitle": "Enter the seller ID, API key, and API secret from your Trendyol merchant account. Credentials are write-only and are not shown after saving.",
      "amazonTitle": "Amazon SP-API beta credentials for {{name}}",
      "amazonSubtitle": "Use OAuth Connect for the normal flow, or paste a beta refresh token while the Amazon app is still in draft testing.",
      "noonTitle": "Noon manual setup for {{name}}",
      "noonSubtitle": "Paste the Noon service-account JSON key downloaded from Noon Access App and the FBPI warehouse code used for Noon order pulls. Tlaaq uses both for direct merchant service-account login and warehouse-scoped FBPI order ingestion.",
      "sellerId": "Seller ID",
      "externalAccountId": "External account ID",
      "trendyolSellerIdPlaceholder": "123456",
      "amazonSellerIdPlaceholder": "A1EXAMPLESELLER",
      "noonExternalAccountIdPlaceholder": "noon-seller-or-account-id",
      "noonWarehouseCode": "FBPI warehouse code",
      "noonWarehouseCodePlaceholder": "e.g. RUH-FBPI-001",
      "noonServiceAccountJson": "Service-account JSON",
      "noonServiceAccountJsonPlaceholder": "Paste the full Noon .json key here",
      "noonServiceAccountUpload": "Upload .json file (optional)",
      "noonServiceAccountRequiredFields": "Required JSON fields: private_key, key_id, project_code, channel_identifier.",
      "apiKey": "API key",
      "apiSecret": "API secret",
      "userAgent": "User agent (optional)",
      "userAgentPlaceholder": "Your merchant app name",
      "amazonMarketplaceIds": "Marketplace IDs",
      "amazonMarketplaceIdsPlaceholder": "A2VIGQ35RCS4UG",
      "amazonRegion": "SP-API region",
      "amazonRegions": {
        "EU": "Europe / Middle East (EU)",
        "NA": "North America (NA)",
        "FE": "Far East (FE)"
      },
      "amazonRefreshToken": "Refresh token",
      "amazonRefreshTokenPlaceholder": "Atzr|IwEB...",
      "trendyolHelper": "Saving credentials connects Trendyol and enables product and order pulls. Leave user agent blank to use Tlaaq's default.",
      "amazonHelper": "Saving credentials connects this Amazon seller account for catalog/listing and order polling. Amazon stock is not made authoritative in this beta slice.",
      "noonHelper": "Saving logs in to Noon with the service-account key, stores the FBPI warehouse code, and verifies the session before marking the channel connected. Once saved, Tlaaq can queue Noon FBPI order pulls for that warehouse. Webhook URL/API-key setup remains separate; catalog import, remote webhook registration, shipment creation, manifestation, stock, pricing, and Xborder pricing are not enabled yet.",
      "save": "Save credentials",
      "saving": "Saving…",
      "saved": "Credentials saved for {{name}}.",
      "cancel": "Close"
    },
    "ordersPull": {
      "title": "Orders pulled for {{name}}",
      "jobTitle": "Order pull queued for {{name}}",
      "fetched": "Fetched orders",
      "upserted": "Updated orders",
      "skipped": "Skipped orders",
      "hasMore": "More orders are available for this window. This screen starts a fresh pull next time.",
      "jobQueued": "This pull runs in the background and updates here until complete. You can keep working while it runs.",
      "jobsTitle": "Recent order pulls",
      "jobsSubtitle": "Latest background order pulls per channel. Multiple channels can run at the same time.",
      "activeJobs": "Active pulls",
      "dismiss": "Dismiss order pull for {{name}}",
      "jobIssue": "Order pull note: {{message}}",
      "issues": {
        "CHANNEL_AUTH_EXPIRED": "Channel authorization expired. Reconnect this channel and try again.",
        "CHANNEL_ORDER_PULL_FORBIDDEN": "The provider refused order access for this channel. Check that the merchant account authorized order access and that the configured account belongs to this store.",
        "CHANNEL_ORDER_PULL_RATE_LIMITED": "The provider rate-limited this pull. Wait a few minutes and try again.",
        "CHANNEL_ORDER_PULL_PROVIDER_REJECTED": "The provider rejected the order request. Check this channel's account/region settings and try again.",
        "CHANNEL_ORDER_PULL_PROVIDER_UNAVAILABLE": "Provider orders are temporarily unavailable. Try again later.",
        "CHANNEL_ORDER_PULL_FAILED": "The order pull failed before it could finish. Try again, or check backend logs for this channel.",
        "CHANNEL_ORDER_PULL_INCOMPLETE": "The order pull reached its page limit before finishing. Start another pull or narrow the date range.",
        "CHANNEL_ORDER_PULL_ACTIVE": "An order pull is already active for this channel. Wait for it to finish before starting another one.",
        "CHANNEL_ORDER_PULL_SCHEDULE_FAILED": "We could not schedule the background order pull. Try again in a moment.",
        "CHANNEL_CONNECT_FAILED": "The channel is not connected anymore. Reconnect it and try again."
      },
      "status": {
        "QUEUED": "Queued",
        "RUNNING": "Running",
        "COMPLETED": "Completed",
        "COMPLETED_WITH_ISSUES": "Completed with issues",
        "FAILED": "Failed"
      },
      "panelTitle": "Pull orders for {{name}}",
      "panelSubtitle": "Choose an optional order date range, then queue a background pull. Leave dates empty to use the provider default.",
      "dateFrom": "From date",
      "dateTo": "To date",
      "dateFromHint": "Optional. Includes orders from the start of this day.",
      "dateToHint": "Optional. Includes orders through the end of this day.",
      "queue": "Queue pull",
      "queueing": "Queueing…",
      "cancel": "Close",
      "activeForConnection": "An order pull is already active for this channel. Wait for it to finish before starting another one.",
      "rangeLabel": "Range: {{range}}",
      "rangeDefault": "Provider default range",
      "rangeFrom": "From {{from}}",
      "rangeTo": "Until {{to}}",
      "rangeBetween": "{{from}} – {{to}}"
    },
    "productPull": {
      "jobsTitle": "Recent product pulls",
      "dismiss": "Dismiss product pull for {{name}}",
      "status": {
        "QUEUED": "Queued",
        "RUNNING": "Running",
        "DEFERRED": "Deferred",
        "COMPLETED": "Completed",
        "COMPLETED_WITH_ISSUES": "Completed with issues",
        "FAILED": "Failed"
      },
      "title": {
        "QUEUED": "Product pull queued for {{name}}",
        "RUNNING": "Product pull running for {{name}}",
        "DEFERRED": "Product pull deferred for {{name}}",
        "COMPLETED": "Product pull completed for {{name}}",
        "COMPLETED_WITH_ISSUES": "Product pull completed with issues for {{name}}",
        "FAILED": "Product pull failed for {{name}}"
      },
      "deferredUntil": "The provider asked Tlaaq to wait. The pull will resume automatically after {{time}}.",
      "retainedProgress": "Progress from {{count}} completed pages is saved and will not be repeated.",
      "retry": "Retry from saved progress",
      "retrying": "Queueing retry…"
    },
    "table": {
      "channel": "Channel",
      "provider": "Provider",
      "status": "Status",
      "adapter": "Adapter",
      "source": "Source",
      "import": "Import",
      "webhooks": "Webhooks",
      "health": "Health",
      "activity": "Activity",
      "actions": "Actions"
    },
    "webhooks": {
      "unchecked": "Not checked",
      "registered": "Registered {{registered}}/{{expected}}",
      "missing": "Missing {{registered}}/{{expected}}",
      "missingCount": "{{count}} missing",
      "lastChecked": "Last checked {{checkedAt}}",
      "notApplicable": "—",
      "check": "Check",
      "checking": "Checking…",
      "reregister": "Re-register",
      "registering": "Registering…",
      "noonPending": "Webhooks are optional. Import sales from Excel now, or add service-account credentials later for FBPI webhook details.",
      "noonFbpiHelper": "Add an HTTPS destination in the Noon Partner Portal using the webhook URL and API key below. Noon notifications can then trigger FBPI order refresh in Tlaaq.",
      "noonManualOwnership": "These destination details are generated locally. Tlaaq does not create, register, or check the destination in Noon for you.",
      "noonTargetUrl": "Webhook URL",
      "noonApiKey": "API key",
      "copyUrl": "Copy URL",
      "copyApiKey": "Copy API key",
      "copied": "Copied"
    },
    "onboarding": {
      "none": "No import job yet",
      "notApplicable": "—",
      "retry": "Retry",
      "retrying": "Retrying…",
      "progress": "{{products}} products · {{orders}} orders",
      "issues": "{{count}} product issues",
      "status": {
        "QUEUED": "Import queued",
        "RUNNING": "Import running",
        "COMPLETED": "Import complete",
        "COMPLETED_WITH_ISSUES": "Complete with issues",
        "FAILED": "Import failed"
      }
    },
    "source": {
      "bannerTitle": "External source authority is active",
      "bannerBody": "Catalog source: {{catalog}}. Stock source: {{stock}}. A connected channel can be a source, but products are imported only when you pull them.",
      "catalogBadge": "Catalog source",
      "stockBadge": "Stock source",
      "notSource": "Not source",
      "noPushNote": "Tlaaq does not push stock back to its source store.",
      "amazonCatalogOnly": "Amazon is catalog/listings + order polling in this beta. Stock remains with the current stock source.",
      "panelTitle": "Set up {{name}}",
      "panelSubtitle": "Choose who owns products and stock for this workspace. Then pull products from this connected channel now, or save the source choice and import later.",
      "close": "Close",
      "choiceLabel": "Source authority",
      "owners": {
        "tlaaq": "Tlaaq",
        "channelFallback": "Connected channel",
        "inventoryFallback": "{{provider}} inventory"
      },
      "confirmSwitch": "Right now, {{current}} owns products and stock. Switch source of truth to {{next}}? Future syncs may overwrite conflicting local edits.",
      "choices": {
        "tlaaq": {
          "title": "Tlaaq is my system",
          "body": "Manage products and stock inside Tlaaq. Pulling from this channel can bootstrap missing products without making the channel authoritative."
        },
        "keepExisting": {
          "title": "Keep current source",
          "body": "Leave catalog and stock owned by {{catalog}} and {{stock}}. Tlaaq will refresh listings only and will not import products or stock from this channel."
        },
        "channel": {
          "title": "{{name}} is my system",
          "body": "Products and stock are managed in this store. Tlaaq mirrors them and can sync them to other connected systems."
        }
      },
      "import": {
        "title": "Product pull",
        "sourceSyncTitle": "Import products and stock from the source store",
        "sourceSyncBody": "Uses source-sync mode: creates missing products, updates provider-owned fields, and imports the latest stock snapshot.",
        "keepExistingTitle": "Refresh listings only",
        "keepExistingBody": "Keeps the current catalog and stock sources unchanged. Tlaaq will refresh provider listing links without importing products or stock.",
        "bootstrapTitle": "Import missing products as a starting point",
        "bootstrapBody": "Creates local products for safe unmatched SKUs. Future changes in the store will not overwrite Tlaaq because Tlaaq remains the source.",
        "listingsOnlyTitle": "Refresh listings only",
        "listingsOnlyBody": "Links provider listings to existing SKUs without creating products or importing stock."
      },
      "resultTitle": "Pull complete for {{name}}",
      "result": {
        "productsCreated": "New products",
        "mapped": "Matched listings",
        "productsSkipped": "Skipped products",
        "stockRowsImported": "Stock rows",
        "fetched": "Fetched {{count}} provider products",
        "listings": "Updated {{count}} listings"
      },
      "issues": {
        "title": "Import issues",
        "unknownSku": "unknown SKU",
        "unknownExternalProductId": "unknown product ID",
        "count": "Products: {{count}}",
        "context": "SKU: {{sku}} · ID: {{externalProductId}}",
        "codes": {
          "UNKNOWN": "Some products need review before they can be imported.",
          "MISSING_EXTERNAL_PRODUCT_ID": "Provider product ID is missing, so this item was skipped.",
          "MISSING_SKU": "No SKU on this product — add one in your store and we will pick it up next sync.",
          "INVALID_SKU": "SKU \"{{sku}}\" has unsupported characters. Update it in the store and sync again.",
          "DUPLICATE_PROVIDER_SKU": "Two products share the SKU \"{{sku}}\". We did not import either — please rename one.",
          "DUPLICATE_PROVIDER_SKU_STOCK_SKIPPED": "Stock was skipped because more than one provider product uses SKU \"{{sku}}\".",
          "MISSING_PRICE": "Price is missing for SKU \"{{sku}}\". We imported it with price 0 for review.",
          "SKU_CONFLICT": "SKU \"{{sku}}\" already exists in Tlaaq and needs review.",
          "INVALID_IMAGE_URL": "One image URL is invalid, so that image was skipped.",
          "MISSING_STOCK_QUANTITY": "Stock quantity unavailable — try refreshing in your store.",
          "INFINITE_STOCK_UNSUPPORTED": "This product has unlimited stock. Tlaaq does not support unlimited stock yet — set a quantity to sync.",
          "NEGATIVE_STOCK_CLAMPED": "Negative stock was set to 0.",
          "PRODUCT_SKU_CONFLICT": "SKU \"{{sku}}\" already exists in Tlaaq and needs review."
        }
      }
    },
    "loading": "Loading channels…",
    "confirmDelete": "Delete {{name}}?\n\nThis permanently deletes this channel, all orders associated with it, and every product linked to this channel—even products also mapped to another channel. Other channel listings for those products will become unmapped. This cannot be undone.",
    "empty": {
      "title": "No channel connections yet",
      "subtitle": "Add a provider and display name to create the first pending connection."
    },
    "errors": {
      "generic": "We could not update channels. Please try again.",
      "validation": "Choose a provider and enter a display name.",
      "codes": {
        "REQUEST_FAILED": "We could not update channels. Please try again.",
        "UNAUTHORIZED": "Your session expired. Sign in again to manage channels.",
        "VALIDATION_FAILED": "Choose a provider and enter a display name.",
          "CHANNEL_CREDENTIALS_REQUIRED": "Enter the required seller credentials for this provider.",
          "CHANNEL_CREDENTIALS_WAREHOUSE_REQUIRED": "Enter the Noon FBPI warehouse code used for order pulls.",
          "CHANNEL_CREDENTIALS_JSON_INVALID": "Paste a valid Noon service-account JSON file.",
          "CHANNEL_CREDENTIALS_JSON_FIELDS_REQUIRED": "Noon service-account JSON must include private_key, key_id, project_code, and channel_identifier.",
        "CHANNEL_PROVIDER_UNSUPPORTED": "This provider is not supported for channel connections yet.",
        "CHANNEL_CONNECTION_EXISTS": "A connection for this provider already exists.",
        "CHANNEL_CONNECTION_NOT_FOUND": "This channel connection was not found.",
        "CHANNEL_DISCONNECT_FAILED": "The provider disconnect failed. Try again later.",
        "CHANNEL_DELETE_FAILED": "We could not delete this channel. Please try again.",
        "CHANNEL_DELETE_CONFIRMATION_REQUIRED": "Confirm that associated products and orders will be deleted before deleting this channel.",
        "CHANNEL_ADAPTER_NOT_REGISTERED": "The adapter for this channel is not available yet.",
        "CHANNEL_CONNECT_FAILED": "We could not start the channel connect flow. Try again later.",
        "CHANNEL_OAUTH_STATE_INVALID": "This OAuth session expired or was already used. Start the connect flow again.",
        "CHANNEL_OAUTH_CALLBACK_FAILED": "The channel provider rejected the connection. Try again later.",
        "CHANNEL_AUTH_EXPIRED": "Channel authorization expired. Reconnect the channel to continue.",
        "CHANNEL_EXTERNAL_ACCOUNT_CONFLICT": "This seller account conflicts with this channel's saved partner or another existing connection.",
        "CHANNEL_ONBOARDING_JOB_NOT_FOUND": "We could not find an import job for this channel yet.",
        "CHANNEL_ONBOARDING_INCOMPLETE": "The import job is not ready to retry yet.",
        "CHANNEL_ONBOARDING_SCHEDULE_FAILED": "We could not schedule the import job. Try again.",
        "CHANNEL_ORDER_PULL_FORBIDDEN": "The provider refused order access for this channel. Check the seller permissions and marketplace settings.",
        "CHANNEL_ORDER_PULL_RATE_LIMITED": "The provider rate-limited the order pull. Wait a few minutes and try again.",
        "CHANNEL_ORDER_PULL_PROVIDER_REJECTED": "The provider rejected the order request. Check this channel's marketplace/region settings and try again.",
        "CHANNEL_ORDER_PULL_PROVIDER_UNAVAILABLE": "The provider orders API is temporarily unavailable. Try again later.",
        "CHANNEL_ORDER_PULL_FAILED": "The order pull failed before it could finish. Try again.",
        "CHANNEL_SOURCE_AUTHORITY_ACTIVE": "This channel is a source of truth. Switch products and stock back to Tlaaq before disconnecting it.",
        "CHANNEL_PRODUCT_PULL_ACTIVE": "A product pull is already active for this channel. Wait for it to finish before starting another one.",
        "CHANNEL_PRODUCT_PULL_JOB_NOT_FOUND": "We could not find this product pull job.",
        "CHANNEL_PRODUCT_PULL_RETRY_NOT_ALLOWED": "Only failed product pulls can be retried.",
        "CHANNEL_PRODUCT_PULL_SCHEDULE_FAILED": "We could not schedule the background product pull. Retry from saved progress.",
        "CHANNEL_PRODUCT_PULL_CURSOR_STALLED": "The provider repeated the same page. Retry from saved progress or contact support.",
        "CHANNEL_PRODUCT_PULL_PAGE_LIMIT": "The product pull reached its safety page limit before finishing.",
        "CHANNEL_PRODUCT_PULL_RATE_LIMITED": "The provider rate-limited this product pull. Tlaaq will resume it automatically.",
        "CHANNEL_PRODUCT_PULL_RATE_LIMIT_RETRY_EXHAUSTED": "The provider kept rate-limiting this product pull. Retry from saved progress later.",
        "NOON_LISTING_REFRESH_PROVIDER_ERROR": "Noon could not complete the refresh. Retry from saved progress; previously saved listing data is unchanged.",
        "NOON_LISTING_REFRESH_INVALID_RESPONSE": "Noon returned invalid warehouse data. Retry the refresh later.",
        "CHANNEL_PRODUCT_PULL_SOURCE_MISMATCH": "This pull mode requires the selected channel to be the catalog source.",
        "CHANNEL_STOCK_PULL_SOURCE_MISMATCH": "Stock import requires the selected channel to be the stock source.",
        "SOURCE_AUTHORITY_CONFLICT": "Another source is already active. Confirm the switch and try again.",
        "SOURCE_AUTHORITY_INVALID_DOMAIN": "Choose a valid source domain.",
        "SOURCE_AUTHORITY_INVALID_OWNER": "Choose a valid source owner.",
        "SOURCE_AUTHORITY_CHANNEL_CONNECTION_NOT_FOUND": "We could not find that connected channel.",
        "SOURCE_AUTHORITY_CHANNEL_NOT_CONNECTED": "Connect the channel before making it a source of truth.",
        "SOURCE_AUTHORITY_INVENTORY_CONNECTION_NOT_FOUND": "We could not find that inventory connection.",
        "CHANNEL_INVALID_DATE_RANGE": "End date must be on or after start date.",
        "CHANNEL_ORDER_PULL_ACTIVE": "An order pull is already active for this channel. Wait for it to finish before starting another one."
      }
    }
  },
  "billing": {
    "notice": {
      "title": "You're not billed by Tlaaq directly today",
      "body": "Tlaaq is paid for through your storefront's app marketplace. You'll see Tlaaq listed as an installed app inside Zid and Salla, and your charges are bundled there."
    },
    "status": {
      "active": "Active",
      "free": "Free"
    },
    "plan": {
      "label": "Plan",
      "zidName": "Growth · 299 SAR/mo",
      "zidRenews": "Renews 14 May 2026",
      "sallaName": "Special · 199 SAR/mo",
      "sallaRenews": "Renews 02 Jun 2026"
    },
    "actions": {
      "manageZid": "Manage in Zid ↗",
      "manageSalla": "Manage in Salla ↗"
    },
    "free": {
      "title": "Free to connect",
      "body": "These channels don't carry a Tlaaq subscription today. We'll let you know if that changes."
    },
    "stores": {
      "zid": "Zid · Fitneeds Zid",
      "zidDomain": "fitneeds.zid.sa",
      "salla": "Salla · Beanzi Coffee",
      "sallaDomain": "beanzi.salla.sa"
    }
  },
  "warehouses": {
    "description": {
      "zoho": "Your warehouses come from Zoho Inventory and are read-only here. Add or edit warehouses in Zoho — Tlaaq will pick up the changes.",
      "tlaaq": "Tlaaq is your inventory source, so you manage warehouses here. Connect Zoho or another source to sync them automatically."
    },
    "actions": {
      "syncZoho": "Sync from Zoho",
      "openZoho": "Open in Zoho ↗",
      "new": "New warehouse",
      "edit": "Edit warehouse",
      "delete": "Delete warehouse",
      "save": "Save warehouse",
      "saving": "Saving…",
      "cancel": "Cancel"
    },
    "banner": {
      "synced": "Synced from Zoho · last 4 minutes ago",
      "managed": "Managed in Tlaaq",
      "autoRefresh": "Auto-refresh every 5 min"
    },
    "table": {
      "warehouse": "Warehouse",
      "code": "Code",
      "location": "Location",
      "skus": "SKUs",
      "units": "Units",
      "source": "Source"
    },
    "form": {
      "titleCreate": "New warehouse",
      "titleEdit": "Edit warehouse",
      "name": "Name",
      "code": "Code",
      "location": "Location"
    },
    "empty": {
      "title": "No warehouses yet",
      "body": "Create your first warehouse to start tracking stock per location."
    },
    "loading": "Loading warehouses…",
    "confirmDelete": "Delete the warehouse \"{{name}}\"? This cannot be undone.",
    "errors": {
      "codes": {
        "REQUEST_FAILED": "We could not load warehouses. Please try again.",
        "UNAUTHORIZED": "Your session expired. Sign in again to continue.",
        "VALIDATION_FAILED": "Enter a code and a name to continue.",
        "WAREHOUSE_NOT_FOUND": "Warehouse not found.",
        "WAREHOUSE_CODE_CONFLICT": "A warehouse with this code already exists.",
        "WAREHOUSE_HAS_STOCK": "This warehouse still holds stock and cannot be deleted."
      }
    },
    "readOnly": "read-only"
  },
  "team": {
    "description": "Invite teammates to help run your store. Every invited teammate gets full store access in this version; there is no roles picker yet.",
    "invite": "Invite teammate",
    "loading": "Loading team…",
    "inviteForm": {
      "title": "Invite a teammate",
      "helper": "We will email a secure invitation link so they can set a password and join this workspace.",
      "fullName": "Full name",
      "fullNamePlaceholder": "Omar Bader",
      "email": "Work email",
      "emailPlaceholder": "teammate@company.com",
      "submit": "Send invitation",
      "submitting": "Sending invitation…",
      "cancel": "Cancel"
    },
    "sections": {
      "members": "Active members",
      "pendingInvites": "Pending invitations"
    },
    "table": {
      "member": "Member",
      "access": "Access",
      "status": "Status",
      "lastSeen": "Last seen",
      "expires": "Expires",
      "invitedBy": "Invited by",
      "actions": "Actions"
    },
    "access": {
      "owner": "Owner",
      "full": "Full access"
    },
    "status": {
      "active": "Active",
      "pending": "Pending"
    },
    "actions": {
      "remove": "Remove",
      "cancelInvite": "Cancel invite"
    },
    "confirm": {
      "remove": "Remove {{name}} from this workspace?",
      "cancelInvite": "Cancel the invitation for {{email}}?"
    },
    "empty": {
      "members": "No active teammates yet.",
      "invites": "No pending invitations.",
      "lastSeen": "Never",
      "notAvailable": "—"
    },
    "errors": {
      "load": "We could not load the team. Please try again.",
      "inviteFields": "Enter the teammate's name and email.",
      "emailAlreadyUser": "This email already has an account. Ask them to sign in, or use a different email.",
      "invite": "We could not send the invitation. Please try again.",
      "remove": "We could not remove this teammate. Please try again.",
      "cancelInvite": "We could not cancel this invitation. Please try again.",
      "ownerRequired": "Only workspace owners can manage team invitations."
    }
  },
  "pages": {
    "orderRouting": {
      "orderFacts": "Order facts",
      "resolvedMapping": "Resolved Zoho mapping",
      "policyStatus": {
        "DRAFT": "Draft",
        "ACTIVE": "Active",
        "ARCHIVED": "Archived"
      },
      "design": {
        "defaults": "Default Zoho route",
        "inheritHelp": "Each output resolves independently. The first matching decision wins; Default is checked last.",
        "lifecycleHelp": "Map incoming order statuses to the next Zoho operation. Configure routing values in the mapping matrix.",
        "lifecycleNotice": "Existing Zoho state still applies. Previewing a policy does not send an order or create a document.",
        "internalOrderId": "Internal Tlaaq order ID (not the marketplace order number)",
        "previewError": "Could not preview this order. Check its internal ID and that it belongs to this policy’s channels."
      },
      "picker": { "selected": "Selected:",
        "title": "Select a fee product",
        "empty": "No matching products found.",
        "help": "Choose an existing product. Saving validates its Zoho item mapping; no product is created here.",
        "cancel": "Cancel",
        "apply": "Use selected product"
      },
      "disabled": "Order Routing is not enabled for this organization. Existing policies continue running unchanged.",
      "observed": {
        "count": "{{count}} observed orders",
        "empty": "No observed values. Enter an exact value if known.",
        "error": "Observed values could not be loaded. Reopen this step to retry."
      },
      "title": "Order Routing",
      "back": "Back",
      "retry": "Try again",
      "copy": "Copy to a new draft",
      "previous": "Previous",
      "next": "Next",
      "loading": "Loading routing policy…",
      "noConnection": "Choose a Zoho Inventory connection first.",
      "locked": "Locked version",
      "sourceOrder": "Started from order #{{id}}. Predicates are never saved automatically.",
      "steps": {
        "label": "Routing setup steps",
        "scope": "Scope",
        "lifecycle": "Lifecycle",
        "segments": "Segments",
        "matrix": "Matrix",
        "review": "Review"
      },
      "scope": {
        "title": "Policy scope",
        "name": "Policy name",
        "invoiceSource": "Invoice source",
        "localOrder": "Local order facts",
        "zohoSnapshot": "Zoho sales order snapshot"
      },
      "lifecycle": {
        "title": "Lifecycle actions",
        "raw": "Optional raw statuses, comma separated",
        "moveUp": "Move action earlier",
        "moveDown": "Move action later"
      },
      "segments": {
        "title": "Segments",
        "add": "Add segment",
        "default": "Default",
        "values": "Values, comma separated",
        "addPredicate": "Add predicate",
        "pinned": "Always last",
        "selected": "Editing",
        "editor": "Segment conditions",
        "editorHelp": "Choose the order facts that define this segment. Set its Zoho outputs in the routing matrix.",
        "matchHelp": "All conditions must match (AND). Outputs resolve independently in segment order; Default supplies values when no earlier decision applies."
      },
      "source": {
        "title": "Create a segment from this order",
        "help": "Select only the non-personal routing facts you intend to save. Customer details are never offered.",
        "name": "New unsaved segment name",
        "add": "Create unsaved segment"
      },
      "matrix": {
        "title": "Routing matrix",
        "segment": "Segment",
        "productSearch": "Search fee products",
        "productsLoading": "Searching products…",
        "productsError": "Products could not be loaded. Change the search to retry.",
        "mode": "mode",
        "inherit": "Inherit",
        "set": "Set",
        "clear": "Clear",
        "choose": "Choose a real value", "productId": "Product #{{id}}"
      },
      "review": {
        "title": "Review and save",
        "summary": "{{channels}} channels · {{actions}} actions · {{segments}} segments · {{cells}} decisions",
        "feeNotice": "Fee calculation remains in legacy Zid mode. Tax settings are managed by the server.",
        "invalid": "Complete the policy name, scope, lifecycle, and every segment predicate.",
        "save": "Save draft",
        "saving": "Saving…",
        "saved": "Draft saved."
      },
      "preview": {
        "resolutions": {
          "SET": "Set",
          "CLEAR": "Cleared",
          "UNRESOLVED": "Unresolved"
        },
        "noSource": "No matching decision",
        "title": "Preview saved draft",
        "help": "Preview uses the persisted draft, not unsaved edits.",
        "orderId": "Order ID",
        "run": "Run preview",
        "loading": "Previewing…",
        "result": "Preview for order #{{id}}",
        "action": "Lifecycle action",
        "none": "No action",
        "segmentCount": "{{count}} matched segments",
        "blockers": "{{count}} blocking errors",
        "warnings": "{{count}} warnings"
      },
      "compatibility": {
        "badge": "Version 1",
        "title": "Legacy policy",
        "available": "Convert a draft or create a new draft copy using the server's compatibility mapping. Active policies and existing order documents remain unchanged.",
        "convert": "Convert this draft",
        "dormant": "{{count}} historical exception rules remain inactive and are not converted.",
        "unavailable": "Safe conversion is not available yet. Use the legacy Sync Rules editor; this policy has not been changed."
      },
      "actions": {
        "CREATE_SALES_ORDER": "Create sales order",
        "CONFIRM_SALES_ORDER": "Confirm sales order",
        "CREATE_INVOICE": "Create invoice",
        "VOID_SALES_ORDER": "Void sales order",
        "CREATE_CREDIT_NOTE": "Create credit note"
      },
      "statuses": {
        "NEW": "New",
        "IN_PROGRESS": "In progress",
        "COMPLETED": "Completed",
        "CANCELLED": "Cancelled",
        "UNKNOWN": "Unknown"
      },
      "operators": {
        "EQUALS": "Equals",
        "ONE_OF": "One of",
        "PREFIX": "Starts with",
        "SUFFIX": "Ends with",
        "CONTAINS": "Contains"
      },
      "lineScope": {
        "ANY_LINE": "Any line",
        "ALL_LINES": "All lines",
        "NO_LINE": "No line"
      },
      "fields": {
        "CHANNEL_PROVIDER": "Channel provider",
        "CHANNEL_CONNECTION_ID": "Channel connection",
        "ORDER_STATUS": "Order status",
        "RAW_STATUS": "Raw status",
        "PAYMENT_STATUS": "Payment status",
        "PAYMENT_METHOD_CODE": "Payment method code",
        "PAYMENT_METHOD_NAME": "Payment method name",
        "PAYMENT_METHOD_TYPE": "Payment method type",
        "PAYMENT_METHOD_EXTERNAL_ID": "Payment method ID",
        "SHIPPING_METHOD_EXTERNAL_ID": "Shipping method ID",
        "SHIPPING_METHOD_CODE": "Shipping method code",
        "SHIPPING_COMPANY": "Shipping company",
        "SHIPPING_METHOD": "Shipping method",
        "FULFILLMENT_CHANNEL": "Fulfillment channel",
        "FULFILLMENT_STATUS": "Fulfillment status",
        "LINE_ITEM_SKU": "Line item SKU"
      },
      "outputs": {
        "CUSTOMER": "Customer",
        "WAREHOUSE": "Warehouse",
        "SALES_PERSON": "Sales person",
        "PAYMENT_TERMS": "Payment terms",
        "DELIVERY_METHOD": "Delivery method",
        "REPORTING_TAG": "Reporting tag",
        "PAYMENT_FEE_ITEM": "Payment fee item",
        "SHIPPING_FEE_ITEM": "Shipping fee item"
      },
      "errors": {
        "REQUEST_FAILED": "Order routing could not be loaded or saved. Try again."
      },
      "defaults": {
        "complete": "Default route is complete. Every order can resolve a customer and a warehouse.",
        "required": "The default route must set a customer and a warehouse before this policy can be activated."
      }
    },
    "salesAnalytics": {
      "title": "Sales analytics",
      "subtitle": "Explore persisted orders and stored sales totals for the period you choose.",
      "timeZone": "Time zone: {{zone}}",
      "generatedAt": "Updated {{value}}",
      "sundayWeek": "Weekly presets run from Sunday through today. The API returns the exact reporting boundaries.",
      "sundayWeekShort": "Sunday-based week",
      "filters": {
        "channel": "Channel",
        "allChannels": "All channels",
        "channelsError": "Could not load channels.",
        "range": "Reporting period",
        "from": "From",
        "to": "To",
        "apply": "Apply dates",
        "granularity": "Trend grouping",
        "compare": "Compare period",
        "compareHint": "Show the equivalent preceding period"
      },
      "ranges": {
        "TODAY": "Today",
        "YESTERDAY": "Yesterday",
        "THIS_WEEK": "This week",
        "THIS_MONTH": "This month",
        "THIS_YEAR": "This year",
        "CUSTOM": "Custom"
      },
      "granularities": {
        "AUTO": "Automatic",
        "DAY": "Daily",
        "MONTH": "Monthly"
      },
      "comparison": {
        "new": "New",
        "percent": "{{value}}%"
      },
      "summary": {
        "totalOrders": "Total orders",
        "salesOrders": "Sales orders",
        "cancelledOrders": "Cancelled orders",
        "unknownOrders": "Unknown-status orders",
        "storedSalesTotal": "Stored sales total · {{currency}}",
        "averageOrderValue": "Average {{value}} across {{count}} amount-bearing orders",
        "noMoney": "Sales orders in this period do not contain a usable amount and currency."
      },
      "trend": {
        "title": "Order and sales trend",
        "subtitle": "Dense local-calendar buckets from the API; zero-activity periods remain visible.",
        "currency": "Sales currency",
        "noCurrency": "No currency",
        "caption": "Order volume for {{period}}",
        "chartAria": "Bar chart of total orders by reporting bucket",
        "pointTitle": "{{date}}: {{count}} total orders",
        "tableCaption": "Tabular equivalent of the order and stored-sales trend",
        "columns": {
          "date": "Period",
          "totalOrders": "Total",
          "salesOrders": "Sales",
          "cancelledOrders": "Cancelled",
          "storedSales": "Stored sales · {{currency}}"
        }
      },
      "bestSellers": {
        "title": "Best-selling items",
        "subtitle": "Top 10 by known positive units; provider snapshots are not linked to catalog products.",
        "empty": "No identifiable sales line items were available for this period.",
        "approximate": "Name-only match",
        "units": "Units sold",
        "orders": "Orders",
        "noMoney": "No usable item total",
        "columns": {
          "item": "Item",
          "units": "Units",
          "orders": "Orders",
          "storedSales": "Stored item totals"
        }
      },
      "breakdowns": {
        "title": "Order breakdowns",
        "subtitle": "Each list is bounded to named leaders plus explicit unknown and other buckets.",
        "payment": "Payment methods",
        "shipping": "Shipping methods",
        "channels": "Channels",
        "unknown": "Unknown",
        "other": "Other",
        "empty": "No orders to break down.",
        "orderCount": "{{count}} orders"
      },
      "dataQuality": {
        "title": "Some provider data is incomplete",
        "body": "The report keeps incomplete persisted orders visible and identifies where coverage affects interpretation.",
        "items": {
          "fallbackTimestamp": "{{count}} orders use an update or last-seen timestamp.",
          "missingMoney": "{{count}} sales orders lack a usable amount or currency.",
          "missingPayment": "{{count}} orders lack a payment identity.",
          "missingShipping": "{{count}} orders lack a shipping identity.",
          "excludedLines": "{{count}} sales line items were excluded from ranking."
        }
      },
      "states": {
        "loading": "Loading sales analytics…",
        "refreshing": "Updating the report; the previous result remains visible.",
        "staleError": "The latest update failed. The previous result remains visible.",
        "retry": "Try again",
        "emptyTitle": "No orders in this period",
        "emptyBody": "Choose another reporting period to inspect persisted sales activity."
      },
      "errors": {
        "requestFailed": "Sales analytics could not be loaded.",
        "customRequired": "Choose both a start date and an end date.",
        "customOrder": "The end date must be on or after the start date.",
        "customFuture": "The end date cannot be in the future.",
        "customTooLarge": "Choose a period of 366 days or fewer.",
        "codes": {
          "INVALID_ANALYTICS_RANGE": "The selected reporting period is not supported.",
          "ANALYTICS_RANGE_PARAMETERS_INVALID": "The selected date combination is invalid.",
          "ANALYTICS_RANGE_TOO_LARGE": "Choose a period of 366 days or fewer.",
          "INVALID_ANALYTICS_TIME_ZONE": "The browser time zone is not supported.",
          "INVALID_ANALYTICS_GRANULARITY": "The selected trend grouping is not supported."
        }
      }
    },
    "channelInventoryVariance": {
      "back": "Back to channels",
      "title": "Channel inventory variance",
      "description": "Review mapped listings where the channel stock snapshot conflicts with source availability. This report is read-only and never pushes stock to providers.",
      "loading": "Loading inventory variance report…",
      "generatedAt": "Generated {{value}}",
      "neverSeen": "Never",
      "noSku": "No SKU",
      "lastSeen": "Last seen {{value}}",
      "locations": "{{count}} location",
      "locations_plural": "{{count}} locations",
      "summary": {
        "total": "Total variances",
        "danger": "Danger rows",
        "warning": "Warning rows",
        "excluded": "Excluded snapshots",
        "excludedSub": "∞ {{infinite}} · unknown {{unknown}}",
        "live": "Live report"
      },
      "severity": {
        "WARNING": "Warning",
        "DANGER": "Danger"
      },
      "types": {
        "NEGATIVE_CHANNEL_QUANTITY": "Negative channel quantity",
        "ZERO_OR_NEGATIVE_SOURCE_POSITIVE": "Channel is zero while source has stock",
        "CHANNEL_EXCEEDS_SOURCE_AVAILABILITY": "Channel exceeds source availability"
      },
      "remediation": {
        "title": "Read-only remediation guidance",
        "body": "Use this report to inspect the product, confirm source stock, and review allocation rules. This screen does not update source stock or push provider inventory."
      },
      "filters": {
        "query": "Search",
        "queryPlaceholder": "SKU, product, listing, or provider ID…",
        "provider": "Provider",
        "allProviders": "All providers",
        "connection": "Channel",
        "allChannels": "All channels",
        "warehouse": "Source warehouse",
        "allWarehouses": "All warehouses",
        "loadError": "Could not load channel and warehouse filters."
      },
      "actions": {
        "applyFilters": "Apply filters",
        "clearFilters": "Clear",
        "retry": "Retry",
        "viewProduct": "View product",
        "stockAllocation": "Stock allocation"
      },
      "empty": {
        "title": "No inventory variances",
        "body": "No mapped channel listings match the current variance filters."
      },
      "table": {
        "product": "Product",
        "channelListing": "Channel listing",
        "source": "Source",
        "channel": "Channel",
        "difference": "Delta",
        "variance": "Variance",
        "lastSeen": "Last seen",
        "actions": "Actions"
      },
      "sort": {
        "none": "{{column}} is not sorted. Activate to sort descending.",
        "ascending": "{{column}} is sorted ascending. Activate to sort descending.",
        "descending": "{{column}} is sorted descending. Activate to sort ascending."
      },
      "paginationRange": "Showing {{start}}–{{end}} of {{total}}",
      "previous": "Previous",
      "next": "Next",
      "errors": {
        "REQUEST_FAILED": "We could not load the inventory variance report. Please try again.",
        "UNAUTHORIZED": "Your session expired. Sign in again to view the variance report.",
        "CHANNEL_INVENTORY_VARIANCE_REPORT_FAILED": "We could not calculate the variance report right now. Please try again."
      },
      "export": {
        "action": "Export Excel",
        "exporting": "Exporting…",
        "error": "We could not export the variance report. Please try exporting again."
      }
    },
    "channelConnectionDetail": {
      "back": "Back to channels",
      "loading": "Loading channel connection…",
      "retry": "Retry",
      "notFoundTitle": "Channel connection unavailable",
      "notFoundBody": "This channel connection was not found or is no longer available. Return to Channels to choose another connection.",
      "identityTitle": "Connection health",
      "connectionId": "Connection ID {{id}}",
      "statusLabel": "Status",
      "adapterLabel": "Adapter",
      "orderRefreshLabel": "Order refresh",
      "available": "Available",
      "unavailable": "Unavailable",
      "safeguardsTitle": "Zoho submission safeguards",
      "preSendRefreshLabel": "Refresh order before Zoho submission",
      "preSendRefreshDescription": "When enabled, every manual submission and every enabled automatic, retry, and reconciliation attempt fetches the order from the channel first. Disabled automatic tasks skip without fetching, and any refresh failure blocks the Zoho submission.",
      "unavailableWarning": "Pre-send refresh is currently unavailable because this connection is not connected, its adapter is unavailable, or order refresh is disabled. You can save this setting now, but Zoho submissions will be blocked until the connection can refresh orders.",
      "save": "Save",
      "saving": "Saving…",
      "saved": "Channel safeguards saved.",
      "errors": {
        "generic": "We could not load or save this channel connection. Please try again."
      }
    },
    "channelUnmappedListings": {
      "back": "Back to channels",
      "total": "{{count}} unmapped listing",
      "total_plural": "{{count}} unmapped listings",
      "noChannelTitle": "Choose a channel first",
      "noChannelSubtitle": "Open Channels and choose Review unmapped on a connected channel.",
      "externalSourceTitle": "External catalog source is active",
      "externalSourceBody": "Mapping here adds a local Tlaaq matching alias only. Your source inventory is not changed.",
      "listTitle": "Unmapped channel listings",
      "listSubtitle": "Pick one listing, then choose the main product it belongs to.",
      "searchListings": "Search SKU, title, or provider ID…",
      "search": "Search",
      "loading": "Loading unmapped listings…",
      "emptyTitle": "No unmapped listings",
      "emptySubtitle": "This channel has no listings waiting for manual mapping.",
      "table": {
        "product": "Channel product",
        "sku": "SKU",
        "stock": "Stock",
        "lastSeen": "Last seen"
      },
      "untitled": "Untitled listing",
      "noSku": "No SKU",
      "neverSeen": "Never",
      "infiniteStock": "Unlimited stock",
      "unknownStock": "Stock unknown",
      "finiteStock": "{{count}} units",
      "locations": "{{count}} location",
      "locations_plural": "{{count}} locations",
      "paginationRange": "Showing {{start}}–{{end}} of {{total}}",
      "previous": "Previous",
      "next": "Next",
      "resolveTitle": "Resolve listing",
      "resolveSubtitle": "Selected listing SKU: {{sku}}",
      "selectListing": "Select an unmapped listing first.",
      "modes": {
        "existing": "Map existing product",
        "create": "Create new product"
      },
      "searchProducts": "Search products or SKU…",
      "searchingProducts": "Searching products…",
      "noProductsYet": "Search for a product to map this listing.",
      "productAliases": "{{count}} additional SKU",
      "productAliases_plural": "{{count}} additional SKUs",
      "mapAction": "Map with SKU alias",
      "mapping": "Mapping…",
      "successWithAlias": "Added SKU alias {{sku}} and mapped {{count}} listing.",
      "successWithAlias_plural": "Added SKU alias {{sku}} and mapped {{count}} listings.",
      "successExisting": "Mapped {{count}} listing using an existing SKU.",
      "successExisting_plural": "Mapped {{count}} listings using an existing SKU.",
      "createHelp": "Creates a Tlaaq product only. Channel stock is not imported.",
      "createFields": {
        "sku": "Product SKU",
        "name": "Product name",
        "price": "Price",
        "status": "Status"
      },
      "createAction": "Create product and map listing",
      "creatingProduct": "Creating product…",
      "createMissingSku": "This listing has no SKU. Add a SKU in the channel first, then create a product from it.",
      "createSourceLoading": "Checking product catalog source before product creation…",
      "createSourceFailed": "We could not verify the product catalog source. Existing mapping is still available, but product creation is disabled for now.",
      "createDisabledExternal": "Product creation is disabled because product catalog source of truth is external.",
      "createInvalidForm": "Enter a SKU, product name, and non-negative price to create a product.",
      "createSuccessWithAlias": "Created product {{productSku}}, added channel SKU alias {{listingSku}}, and mapped {{count}} listing.",
      "createSuccessWithAlias_plural": "Created product {{productSku}}, added channel SKU alias {{listingSku}}, and mapped {{count}} listings.",
      "createSuccess": "Created product {{productSku}} and mapped {{count}} listing.",
      "createSuccess_plural": "Created product {{productSku}} and mapped {{count}} listings.",
      "errors": {
        "REQUEST_FAILED": "We could not update unmapped listings. Please try again.",
        "UNAUTHORIZED": "Your session expired. Sign in again to map listings.",
        "CHANNEL_CONNECTION_NOT_FOUND": "This channel connection was not found.",
        "CHANNEL_LISTING_NOT_FOUND": "This listing or product was not found.",
        "CHANNEL_LISTING_ALREADY_MAPPED": "This listing is already mapped.",
        "CHANNEL_LISTING_SKU_REQUIRED": "This listing has no valid SKU, so it cannot be mapped with a SKU alias.",
        "CHANNEL_LISTING_SKU_CONFLICT": "This SKU already belongs to another product. Choose that product or fix the SKU first.",
        "CHANNEL_LISTING_RESOLVE_FAILED": "We could not map this listing. Please choose a product and try again.",
        "PRODUCT_CATALOG_EXTERNAL_SOURCE": "Product creation is disabled because product catalog source of truth is external.",
        "PRODUCT_SKU_CONFLICT": "This SKU already belongs to another product. Choose a different product SKU or map to the existing product.",
        "PRODUCT_INVALID_STATUS": "Choose a valid product status."
      }
    },
    "inventory": {
      "description": "Choose where Tlaaq should read product and warehouse stock from. Zoho can stay connected, or Tlaaq can own inventory directly.",
      "sourceLabel": "Source of truth",
      "sourceDescription": "Choose separately where Tlaaq reads product catalog data and stock from.",
      "changeSource": "Change source",
      "source": {
        "catalog": "Product catalog",
        "catalogDescription": "Names, descriptions, prices, cost, and images.",
        "stock": "Stock",
        "stockDescription": "Warehouse/location quantities and availability.",
        "useZoho": "Use Zoho",
        "useTlaaq": "Use Tlaaq",
        "saving": "Saving…",
        "error": "Could not update the source. Try again."
      },
      "connectedSources": "Connected sources",
      "zoho": "Zoho Inventory",
      "connected": "Connected",
      "location": "Riyadh · Jeddah · Dammam",
      "stats": {
        "products": "Products",
        "syncRules": "Sync rules",
        "lastRun": "Last run",
        "lastRunValue": "4 min ago",
        "notAvailable": "—",
        "productsPending": "Available after the first Zoho product pull",
        "productsImported": "Local products in this workspace",
        "rulesPending": "Sync-rule APIs are not implemented yet",
        "rulesDeferred": "Sync-rule APIs are deferred for a later PR",
        "lastRunPending": "No Zoho run has been recorded yet"
      },
      "runStatus": {
        "QUEUED": "Queued",
        "RUNNING": "Running",
        "RATE_LIMITED": "Rate limited",
        "SUCCEEDED": "Succeeded",
        "SUCCEEDED_WITH_ISSUES": "Succeeded with issues",
        "FAILED": "Failed"
      },
      "requestTitle": "Need another source?",
      "requestBody": "Tell us if you want NetSuite, Odoo, or a custom ERP connector in this workspace.",
      "request": "Request connector",
      "viewApiDocs": "View API docs",
      "tlaaq": "Tlaaq",
      "tlaaqInventory": "Tlaaq Inventory",
      "tlaaqInventoryHint": "Local inventory, channel allocation, and seller-fulfilled order deduction.",
      "currentSource": "Current source",
      "openTlaaq": "Open Tlaaq Inventory →",
      "loading": "Loading",
      "pending": "Pending",
      "notConnected": "Not connected",
      "connectZohoHint": "Connect Zoho to pull products, warehouses, stock, and send orders."
    },
    "tlaaqInventory": {
      "back": "Inventory",
      "title": "Tlaaq Inventory",
      "description": "Control how local stock is published to channels and where seller-fulfilled orders deduct it.",
      "manageWarehouses": "Manage warehouses",
      "loading": "Loading Tlaaq inventory settings…",
      "loadError": "We could not load warehouse mappings. Try again.",
      "allocation": {
        "title": "Stock allocation",
        "body": "Decides how much available stock is published to each connected channel.",
        "action": "View stock allocation"
      },
      "deduction": {
        "title": "Order deduction",
        "body": "Decides which local warehouse seller-fulfilled orders reserve and deduct stock from.",
        "needsAttention": "{{count}} needs attention"
      },
      "mappings": {
        "title": "Fulfillment warehouse mappings",
        "body": "Every supported channel requires one default warehouse. Reported provider locations can override it.",
        "locationCount": "{{count}} location mapping",
        "locationCount_other": "{{count}} location mappings",
        "defaultOnly": "Uses the default warehouse",
        "default": "Default warehouse",
        "notConfigured": "Default required",
        "noDeduction": "Orders will not deduct stock",
        "providerUnknown": "Waiting for a reliable fulfillment signal from this provider",
        "edit": "Edit mapping",
        "configure": "Set default",
        "empty": "Connect a sales channel to configure order deduction."
      },
      "editor": {
        "title": "Warehouse mapping",
        "close": "Close mapping",
        "defaultLabel": "Default fulfillment warehouse",
        "defaultHelp": "Required. Used whenever the provider sends no location or a reported location has no override.",
        "chooseWarehouse": "Choose a Tlaaq warehouse",
        "defaultRequired": "Choose one default before order deduction can start.",
        "locations": "Reported provider locations",
        "useDefault": "Use the default warehouse",
        "providerFulfilled": "Provider-fulfilled orders are excluded. Amazon AFN and Noon FBN do not deduct local Tlaaq stock.",
        "cancel": "Cancel",
        "save": "Save mapping",
        "saving": "Saving…",
        "saveError": "We could not save this mapping. Try again."
      }
    },
    "inventoryZoho": {
      "actions": {
        "openZoho": "Open in Zoho ↗",
        "runAll": "Run all rules",
        "manageConnection": "Manage connection",
        "newRule": "Order policy",
        "viewDetails": "View details →",
        "editRule": "Edit rule",
        "connect": "Connect Zoho",
        "reconnect": "Reconnect Zoho",
        "reauthorize": "Reauthorize Zoho",
        "connecting": "Connecting…",
        "disconnect": "Disconnect",
        "disconnecting": "Disconnecting…",
        "pullMissingProducts": "Pull products & stock",
        "pullingProducts": "Pulling products…",
        "startingPull": "Starting pull…",
        "pullActive": "Pull in progress",
        "orderAudit": "Audit synced Zid orders",
        "setStockSource": "Set Zoho as stock source",
        "settingStockSource": "Setting source…",
        "editDraft": "Edit draft",
        "activateDraft": "Activate draft",
        "activating": "Activating…",
        "enablePolicy": "Enable policy",
        "enablingPolicy": "Enabling…",
        "viewPolicy": "View policy",
        "copyToDraft": "Create draft copy",
        "copyingPolicy": "Creating copy…",
        "disablePolicy": "Disable policy",
        "disablingPolicy": "Disabling…",
        "archivePolicy": "Delete policy",
        "archivingPolicy": "Deleting…"
      },
      "connection": {
        "connected": "Connected",
        "organization": "Organization",
        "connectedBy": "Connected by Lubna · 2 weeks ago",
        "loading": "Loading",
        "notConnected": "Not connected",
        "connectHint": "Connect with Zoho OAuth before running product pulls or order sync.",
        "status": {
          "PENDING": "Pending",
          "CONNECTED": "Connected",
          "DISCONNECTED": "Disconnected",
          "AUTH_EXPIRED": "Auth expired",
          "ERROR": "Error"
        }
      },
      "source": {
        "loading": "Checking stock source…",
        "loadingBody": "Tlaaq is checking who owns stock before enabling Zoho stock imports.",
        "loadFailed": "Could not check stock source",
        "loadFailedBody": "Refresh the page or try again before importing Zoho stock.",
        "zohoActive": "Zoho is the stock source",
        "zohoActiveBody": "Stock pulls can import Zoho locations and quantities into Tlaaq warehouses.",
        "tlaaqActive": "Tlaaq is currently the stock source",
        "tlaaqActiveBody": "Set Zoho as stock source before importing stock snapshots and locations.",
        "externalActive": "Another source is currently the stock source",
        "externalActiveBody": "Switching to Zoho will replace the current stock source for future stock imports.",
        "confirmReplace": "Another connected source currently owns stock. Switch the stock source to Zoho? Future stock imports may overwrite conflicting local quantities."
      },
      "singleImport": {
        "action": "Import one item",
        "closeAction": "Close item import",
        "title": "Import one Zoho item",
        "subtitle": "Fetch one newly created item by exact SKU or Zoho item ID without starting a full catalog pull.",
        "bounded": "Bounded Zoho lookup",
        "lookup": { "sku": "Exact SKU", "itemId": "Zoho item ID" },
        "field": {
          "skuLabel": "Exact SKU",
          "skuPlaceholder": "Enter the complete SKU",
          "skuHelp": "Matches the complete SKU only. A unique match uses one filtered list request and one detail request.",
          "itemIdLabel": "Zoho item ID",
          "itemIdPlaceholder": "Enter the Zoho item ID",
          "itemIdHelp": "The most API-efficient option: normally one Zoho item lookup request."
        },
        "authority": {
          "loading": "Checking catalog and stock authority…",
          "loadingBody": "Import stays disabled until Tlaaq confirms which source owns each domain.",
          "loadFailed": "Could not check import authority",
          "loadFailedBody": "No ownership is assumed in the browser. Retry before importing this item.",
          "retry": "Retry authority check",
          "serverRevalidates": "The backend rechecks current authority immediately before importing.",
          "behavior": {
            "productAndStock": { "title": "Zoho controls product details and stock", "body": "This item can be created or refreshed, including its image, mapping, warehouses, and stock snapshot." },
            "productOnly": { "title": "Zoho controls product details only", "body": "This item can be created or refreshed with its image and mapping. Local stock and warehouses stay unchanged." },
            "createMissingAndStock": { "title": "Create missing products and import Zoho stock", "body": "A missing product can be created. Existing Tlaaq product fields are preserved while mapping and Zoho stock are imported." },
            "stockOnly": { "title": "Import stock for an existing local product", "body": "Another source controls product details. The exact item must already match a local product; only its Zoho mapping and stock can change." },
            "createMissingOnly": { "title": "Create a missing product and preserve local data", "body": "A missing product can be created, while existing Tlaaq product fields, stock, and warehouses remain unchanged." },
            "blocked": { "title": "This connection cannot import the item", "body": "Another source controls product details and Zoho does not control stock, so this request has no authorized effect." }
          }
        },
        "cancel": "Cancel",
        "submit": "Import item",
        "submitting": "Importing…",
        "outcomes": {
          "CREATED": "Zoho item created as a product",
          "REFRESHED": "Existing product refreshed from Zoho",
          "MATCHED": "Zoho item matched to an existing product"
        },
        "resultSummary": "Stock rows imported: {{stock}} · warehouses created: {{warehouses}} · issues: {{issues}}.",
        "errors": {
          "REQUEST_FAILED": "We could not import this Zoho item. Try again.",
          "INVENTORY_ITEM_LOOKUP_INVALID": "Enter either one exact SKU or one Zoho item ID.",
          "INVENTORY_ITEM_NOT_FOUND": "No Zoho item matched that exact identifier.",
          "INVENTORY_ITEM_LOOKUP_AMBIGUOUS": "Multiple Zoho items use that exact SKU. Resolve the duplicate in Zoho, then try again.",
          "INVENTORY_ITEM_IMPORT_NOT_ALLOWED": "Current catalog and stock authority does not allow this Zoho item to change anything.",
          "INVENTORY_ITEM_LOCAL_PRODUCT_NOT_FOUND": "This authority setup can import stock only after the Zoho item matches an existing local product.",
          "INVENTORY_ITEM_MAPPING_CONFLICT": "The Zoho item mapping conflicts with a different local product. Review the existing mapping before retrying.",
          "INVENTORY_ITEM_PRODUCT_CONFLICT": "The SKU is already used by another product or additional SKU in this workspace.",
          "INVENTORY_ITEM_INVALID_PROVIDER_ITEM": "Zoho returned an item whose ID or SKU cannot be imported safely.",
          "INVENTORY_ITEM_IMPORT_FAILED": "Zoho returned the item, but Tlaaq could not finish the import safely.",
          "INVENTORY_CONNECTION_NOT_CONFIGURED": "Zoho is not connected yet.",
          "INVENTORY_CONNECTION_NOT_FOUND": "We could not find this Zoho connection.",
          "INVENTORY_ADAPTER_NOT_REGISTERED": "Zoho item import is not available in this deployment.",
          "INVENTORY_AUTH_EXPIRED": "Zoho authorization expired. Reconnect Zoho and try again.",
          "INVENTORY_RATE_LIMITED": "Zoho rate limited this lookup. Wait a moment, then try again.",
          "INVENTORY_PULL_FAILED": "Zoho item lookup failed. Try again or check provider-call history."
        }
      },
      "stats": {
        "products": "Products",
        "productsSub": "↑ 4 today",
        "warehouses": "Warehouses",
        "syncRules": "Sync rules",
        "syncRulesValue": "3 active",
        "syncRulesSub": "0 paused",
        "lastActivity": "Last activity",
        "lastActivitySub": "Stock push · OK",
        "notAvailable": "—",
        "loading": "Loading",
        "productsPending": "Run Pull products & stock to create missing Zoho products and import stock locations.",
        "productsImported": "Local products in this workspace",
        "productsPulled": "Fetched {{fetched}} · updated {{updated}} existing",
        "warehousesPending": "Available after stock is imported from Zoho locations",
        "warehousesMapped": "Mapped Zoho warehouses",
        "syncRulesPending": "Sync-rule APIs are not implemented yet",
        "syncRulesDeferred": "Sync-rule configuration is deferred for a later PR",
        "syncRulesLoading": "Loading order policies",
        "syncRulesConfigured": "{{active}} active · {{draft}} draft · {{disabled}} disabled",
        "lastActivityPending": "No Zoho activity has been recorded yet"
      },
      "pull": {
        "successTitle": "Pull complete",
        "summary": "Fetched {{fetched}} Zoho products. Created {{created}}, updated {{updated}}, skipped {{skipped}}.",
        "issues": "{{count}} issue needs review.",
        "issues_plural": "{{count}} issues need review.",
        "nextCursor": "Zoho returned another page. Run the pull again to continue from the next cursor.",
        "progressTitle": "Product pull progress",
        "progressDeterminate": "Fetched {{fetched}} of {{total}} items across {{pages}} pages.",
        "progressIndeterminate": "Fetched {{fetched}} items across {{pages}} pages.",
        "rateLimited": "Zoho rate limited item pulls. Tlaaq will retry automatically.",
        "rateLimitedWithTime": "Zoho rate limited item pulls. Tlaaq will retry around {{retryAt}}.",
        "failed": "Product pull failed with code {{code}}.",
        "unknownError": "UNKNOWN_ERROR",
        "finalCounters": "Fetched {{fetched}}. Created {{created}}, updated {{updated}}, skipped {{skipped}}. Issues: {{issues}}.",
        "status": {
          "QUEUED": "Queued",
          "RUNNING": "Running",
          "RATE_LIMITED": "Rate limited",
          "SUCCEEDED": "Succeeded",
          "SUCCEEDED_WITH_ISSUES": "Succeeded with issues",
          "FAILED": "Failed"
        },
        "viewDetails": "View pull details"
      },
      "rules": {
        "title": "Sync rules",
        "subtitle": "Create and activate the policy used when Tlaaq sends channel orders to Zoho.",
        "trigger": "Trigger",
        "entity": "Entity",
        "lastRun": "Last run",
        "ok": "OK",
        "issues": "Issues",
        "pullProducts": {
          "name": "Pull product master from Zoho"
        },
        "pushStock": {
          "name": "Push stock changes to Zoho"
        },
        "pushOrders": {
          "name": "Push paid orders to Zoho as sales orders",
          "error": "1 order missing tax code"
        },
        "emptyTitle": "No sync rules yet",
        "emptyBody": "Use the order policy builder to create defaults and simple payment or shipping mappings for Zoho orders.",
        "connectFirstBody": "Connect Zoho before creating the order policy used for sales orders and invoices.",
        "loading": "Loading order policies…",
        "version": "Version {{version}}",
        "noDefaults": "No Zoho defaults selected",
        "invoiceSource": "Invoice source: {{source}}",
        "copyName": "{{name}} copy",
        "confirmDisableActive": "Disable the active policy \"{{name}}\"? Zoho order sync will use the default payload until another policy is activated.",
        "autoSend": {
          "title": "Auto-send orders to Zoho",
          "enabled": "Auto-send on",
          "disabled": "Auto-send off",
          "toggleLabel": "Toggle auto-send for {{name}}",
          "help": "Applies only to future imported or updated orders. Manual Send to Zoho remains available when auto-send is off.",
          "activeOnlyHelp": "Activate this policy before enabling auto-send. Manual Send to Zoho remains separate from this automation.",
          "saving": "Updating auto-send…"
        },
        "confirmArchiveDraft": "Delete the draft policy \"{{name}}\"? This draft will no longer be listed.",
        "confirmArchiveDisabled": "Delete the disabled policy \"{{name}}\"? It will no longer be available to enable."
      },
      "cadence": {
        "realtime": "Real-time",
        "every15": "Every 15 minutes",
        "hourly": "Hourly",
        "daily0200": "Daily 02:00 KSA",
        "paymentCaptured": "On payment captured"
      },
      "entities": {
        "products": "Products",
        "stock": "Stock",
        "orders": "Sales orders"
      },
      "scopes": {
        "allWarehouses": "All warehouses",
        "riyadhJeddahDammam": "Riyadh · Jeddah · Dammam",
        "exceptTrendyol": "All channels except Trendyol"
      },
      "times": {
        "thirtyTwoSecondsAgo": "32s ago",
        "eightMinutesAgo": "8m ago",
        "twelveMinutesAgo": "12m ago",
        "oneHourAgo": "1h ago",
        "twoHoursAgo": "2h ago"
      },
      "locations": {
        "riyadh": "Riyadh",
        "jeddah": "Jeddah",
        "dammam": "Dammam"
      },
      "activity": {
        "title": "Recent activity",
        "headers": {
          "time": "Time",
          "rule": "Rule",
          "direction": "Direction",
          "entity": "Entity",
          "result": "Result"
        },
        "results": {
          "fourItems": "4 items pushed",
          "twentyFourProducts": "24 products updated",
          "missingTaxCode": "9 of 10 pushed · 1 missing tax code",
          "elevenItems": "11 items pushed",
          "thirtyOneProducts": "31 products updated"
        },
        "emptyTitle": "No Zoho activity yet",
        "emptyBody": "Provider-call audit and order sync history are stored in the backend, but this summary feed is not wired to an API yet."
      },
      "drawer": {
        "untitledRule": "Untitled rule",
        "newSyncRule": "New sync rule",
        "editSyncRule": "Edit sync rule",
        "setupStream": "Set up a new data stream",
        "close": "Close sync rule editor",
        "rulePreview": "Rule preview",
        "previewSentence": "{{cadence}}, {{action}} {{entity}} {{preposition}} Zoho Inventory.",
        "send": "send",
        "pull": "pull",
        "to": "to",
        "from": "from",
        "nameStatus": "Name & status",
        "ruleName": "Rule name",
        "enabled": "Enabled",
        "enabledHint": "When off, the rule won't trigger but history is preserved.",
        "direction": "Direction",
        "pullFromZoho": "Pull from Zoho",
        "pullFromZohoDesc": "Zoho is the master. Updates flow into Tlaaq.",
        "pushToZoho": "Push to Zoho",
        "pushToZohoDesc": "Tlaaq is the master. Updates flow out to Zoho.",
        "whatToSync": "What to sync",
        "productsDesc": "SKUs, names, prices, descriptions.",
        "stockDesc": "Quantities per warehouse.",
        "ordersDesc": "Pushed when payment is captured.",
        "when": "When",
        "realtimeDesc": "Triggered on every change.",
        "every15Desc": "Best for product master.",
        "hourlyDesc": "For background reconciliation.",
        "dailyDesc": "Quiet hours batch.",
        "scope": "Scope",
        "scopeHint": "Limit which warehouses or channels this rule applies to.",
        "warehouses": "Warehouses",
        "allWarehouses": "All warehouses",
        "channels": "Channels",
        "allChannels": "All channels",
        "fieldMapping": "Field mapping",
        "deleteRule": "Delete rule",
        "cancel": "Cancel",
        "createRule": "Create rule",
        "saveChanges": "Save changes"
      },
      "fieldMapping": {
        "tlaaqField": "Tlaaq field",
        "zohoField": "Zoho field",
        "sku": "SKU",
        "name": "Name",
        "price": "Price (SAR)",
        "quantity": "Quantity",
        "tax": "Tax",
        "noMapping": "No mapping yet"
      },
      "title": "Zoho Inventory",
      "errors": {
        "codes": {
          "REQUEST_FAILED": "The request failed. Try again.",
          "INVENTORY_CONNECTION_EXISTS": "A Zoho connection already exists for this workspace.",
          "INVENTORY_CONNECT_FAILED": "Could not start Zoho connection. Check Zoho client configuration.",
          "INVENTORY_ADAPTER_NOT_REGISTERED": "Zoho adapter is not available in this deployment.",
          "INVENTORY_PRODUCT_PULL_SOURCE_MISMATCH": "This pull mode would overwrite local catalog data. Use Pull missing products while Tlaaq remains the source, or switch catalog source to Zoho first.",
          "INVENTORY_STOCK_PULL_SOURCE_MISMATCH": "Zoho must be the stock source before importing stock snapshots.",
          "INVENTORY_NOT_CONFIGURED": "Zoho is not connected yet.",
          "INVENTORY_PULL_FAILED": "Zoho item pull failed. Try again or check provider-call history.",
          "INVENTORY_RATE_LIMITED": "Zoho rate limited item pulls. Tlaaq will retry automatically for async runs.",
          "INVENTORY_SOURCE_AUTHORITY_ACTIVE": "Move product and stock source authority away from Zoho before disconnecting it.",
          "SOURCE_AUTHORITY_CONFLICT": "Another source is already active. Confirm the switch and try again.",
          "SOURCE_AUTHORITY_INVALID_DOMAIN": "Choose a valid source domain.",
          "SOURCE_AUTHORITY_INVALID_OWNER": "Choose a valid source owner.",
          "SOURCE_AUTHORITY_INVENTORY_CONNECTION_NOT_FOUND": "We could not find that inventory connection.",
          "SOURCE_AUTHORITY_INVENTORY_NOT_CONNECTED": "Connect Zoho before making it the stock source.",
          "ZOHO_ORDER_POLICY_INVALID": "Check the policy fields and try again."
        }
      }
    },
    "inventoryZohoOrderAudit": {
      "back": "Back to Zoho Inventory",
      "title": "Zoho order audit",
      "subtitle": "Read-only comparison of recent synced Zid orders against the current expected Zoho sales-order and invoice payloads. No Zoho documents are created, deleted, or repaired from this page.",
      "readOnly": "Read-only audit",
      "loading": "Loading audit…",
      "loadingShort": "…",
      "notAvailable": "—",
      "yes": "Yes",
      "no": "No",
      "orderNumber": "Order #{{id}}",
      "orderId": "Tlaaq order #{{id}}",
      "policyVersion": "Policy #{{id}} · v{{version}}",
      "filters": {
        "days": "Window",
        "daysOption": "Last {{count}} days",
        "limit": "Limit",
        "limitOption": "{{count}} orders"
      },
      "summary": {
        "scanned": "Scanned",
        "since": "Since {{since}}"
      },
      "results": {
        "title": "Audit results",
        "subtitle": "Generated {{generatedAt}}"
      },
      "empty": {
        "title": "No candidate orders found",
        "body": "No recently synced Zid orders matched the audit window and shipping-related candidate rules."
      },
      "missing": {
        "title": "Choose a Zoho connection first",
        "body": "Open Zoho Inventory and choose the audit action from a connected Zoho setup."
      },
      "fields": {
        "salesOrder": "Sales order",
        "invoice": "Invoice",
        "syncedAt": "Synced at",
        "policy": "Policy"
      },
      "documents": {
        "expected": "Expected",
        "found": "Found",
        "remoteStatus": "Remote status"
      },
      "documentTypes": {
        "SALES_ORDER": "Sales order",
        "INVOICE": "Invoice"
      },
      "differences": {
        "title": "Order-level differences",
        "expected": "Expected",
        "actual": "Actual",
        "delta": "Delta",
        "none": "No differences captured for this document."
      },
      "classifications": {
        "OK": "OK",
        "MISSING_SHIPPING_SERVICE_LINE": "Missing shipping line",
        "WRONG_SHIPPING_SERVICE_AMOUNT": "Wrong shipping amount",
        "WRONG_ENTITY_DISCOUNT": "Wrong entity discount",
        "TOTAL_MISMATCH": "Total mismatch",
        "ZOHO_DOCUMENT_NOT_FOUND": "Zoho document not found",
        "UNSAFE_MANUAL_DIFFERENCE": "Manual review needed"
      },
      "errors": {
        "REQUEST_FAILED": "We could not load the order audit. Try again.",
        "UNAUTHORIZED": "Your session expired. Sign in again to view the audit.",
        "INVENTORY_CONNECTION_NOT_FOUND": "This Zoho connection was not found.",
        "INVENTORY_NOT_CONFIGURED": "Zoho is not connected yet.",
        "INVENTORY_ADAPTER_NOT_REGISTERED": "Zoho adapter is not available in this deployment.",
        "ZOHO_ORDER_AUDIT_FAILED": "Zoho order audit failed. Try again or reduce the window."
      },
      "actions": {
        "fetchLatest": "Fetch latest",
        "fetchNextPage": "Fetch next page"
      },
      "notRun": {
        "title": "Audit not run yet",
        "body": "Choose the window and limit, then fetch the latest Zoho comparison."
      }
    },
    "orders": {
      "searchLabel": "Search orders",
      "searchPlaceholder": "Search orders, customers, phone…",
      "currencyFallback": "SAR",
      "summaryLoading": "Loading summary…",
      "summaryTotal": "{{count}} total orders",
      "loading": "Loading orders…",
      "emptyFiltered": "No orders match this search or filter.",
      "filters": {
        "dateFrom": "Order date from",
        "dateTo": "Order date to",
        "status": "Status",
        "channel": "Channel",
        "zoho": "Zoho status",
        "allChannels": "All channels",
        "allStatuses": "All statuses",
        "last7Days": "Last 7 days",
        "zohoAny": "Zoho: any"
      },
      "actions": {
        "refresh": "Refresh list",
        "refreshing": "Refreshing…",
        "export": "Export orders XLSX",
        "exporting": "Exporting orders…",
        "openDetail": "Open order {{order}}",
        "closeDetail": "Close detail",
        "refreshFromChannel": "Refresh from channel",
        "refreshingFromChannel": "Refreshing from channel…",
        "previewZoho": "Preview Zoho payload",
        "openOrderRouting": "Use order in routing",
        "previewingZoho": "Previewing…",
        "sendToZoho": "Send to Zoho",
        "sendingZoho": "Sending…",
        "resetZohoInvoice": "Reset invoice sync",
        "resettingZohoInvoice": "Resetting…",
        "resetZohoInvoiceConfirm": "This only resets Tlaaq's local invoice sync state. Delete or void the wrong invoice in Zoho first if needed. Continue?",
        "resetZohoSync": "Reset Zoho sync",
        "resettingZohoSync": "Resetting…",
        "resetZohoSyncConfirm": "Only continue after deleting the sales order and its related invoice or credit note in Zoho. Tlaaq will forget all linked Zoho document IDs and allow this order to be sent again. Resetting while those documents still exist may create duplicates. Continue?",
        "sendZoho": {
          "NONE": "No Zoho action",
          "CREATE_SALES_ORDER": "Create sales order",
          "CONFIRM_SALES_ORDER": "Confirm sales order",
          "CREATE_INVOICE": "Create invoice",
          "VOID_SALES_ORDER": "Void sales order",
          "CREATE_CREDIT_NOTE": "Create credit note",
          "RETRY": "Retry Zoho send"
        }
      },
      "pullNew": "Pull new",
      "pending": "Pending",
      "table": {
        "order": "Order",
        "channel": "Channel",
        "date": "Date",
        "status": "Status",
        "payment": "Payment",
        "customer": "Customer",
        "total": "Total",
        "zoho": "Zoho",
        "carrier": "Carrier"
      },
      "status": {
        "NEW": "New",
        "IN_PROGRESS": "In progress",
        "COMPLETED": "Completed",
        "CANCELLED": "Cancelled",
        "UNKNOWN": "Unknown",
        "new": "New",
        "processing": "Processing",
        "ready": "Ready",
        "shipped": "Shipped",
        "cancelled": "Cancelled"
      },
      "zoho": {
        "NOT_CONFIGURED": "Not configured",
        "READY": "Ready",
        "SALES_ORDER_CREATED": "Sales order created",
        "SALES_ORDER_CONFIRMED": "Sales order confirmed",
        "INVOICE_CREATED": "Invoice created",
        "SALES_ORDER_VOIDED": "Sales order voided",
        "CREDIT_NOTE_APPLIED": "Credit note applied",
        "FAILED": "Failed",
        "handoffHelp": "Send to Zoho follows the active policy action matched to this order's channel status.",
        "reconnectHelp": "Zoho Inventory is not connected. Existing sync records are read-only. Reconnect Zoho from Inventory to resume order sending.",
        "notConfiguredHelp": "Zoho order sending is not configured yet. This action is disabled until the integration is available.",
        "nextActions": {
          "NONE": "No Zoho action",
          "CREATE_SALES_ORDER": "Create sales order",
          "CONFIRM_SALES_ORDER": "Confirm sales order",
          "CREATE_INVOICE": "Create invoice",
          "VOID_SALES_ORDER": "Void sales order",
          "CREATE_CREDIT_NOTE": "Create credit note",
          "RETRY": "Retry Zoho send"
        },
        "reasons": {
          "NONE": "Ready",
          "ZOHO_INTEGRATION_NOT_AVAILABLE": "Zoho Inventory is not connected.",
          "ZOHO_ORDER_POLICY_NOT_FOUND": "No active Zoho order policy matches this channel.",
          "ZOHO_ORDER_POLICY_NO_ACTION_MAPPING": "The active policy has no action mapping for this status.",
          "ZOHO_ORDER_POLICY_INVALID": "The active Zoho order policy has blocking issues.",
          "ZOHO_ORDER_POLICY_CHANNEL_NOT_SCOPED": "This channel is not included in the active policy.",
          "ZOHO_ORDER_POLICY_REFERENCE_STALE": "A selected Zoho policy reference is stale or inactive.",
          "ZOHO_SALES_ORDER_ID_REQUIRED_FOR_VOID": "Voiding requires an existing Zoho sales order ID.",
          "ZOHO_INVOICE_ID_REQUIRED_FOR_CREDIT_NOTE": "Creating a credit note requires an existing Zoho invoice ID.",
          "ZOHO_CREDIT_NOTE_SOURCE_INVALID": "The Zoho invoice cannot be used to create a credit note.",
          "ZOHO_CREDIT_NOTE_ID_MISSING": "Zoho did not return a credit note ID.",
          "ZOHO_INVOICE_ALREADY_CREATED": "This order already has a Zoho invoice.",
          "ZOHO_ORDER_ALREADY_INVOICED": "This order already has a Zoho invoice and cannot be voided.",
          "ZOHO_ORDER_ALREADY_VOIDED": "This Zoho sales order is already voided."
        }
      },
      "zohoPreview": {
        "policyId": "Policy ID",
        "policySource": "Policy source",
        "policyVersion": "Policy version",
        "action": "Planned action",
        "actionMappingId": "Action mapping ID",
        "paymentMappingId": "Payment mapping ID",
        "shippingMappingId": "Shipping mapping ID",
        "warehouseOverrideRuleId": "Warehouse override ID",
        "warnings": "Warnings",
        "blockingErrors": "Blocking errors",
        "noWarnings": "No warnings for this payload.",
        "noBlockingErrors": "No blocking errors for this payload.",
        "field": "Field",
        "externalId": "External ID",
        "salesOrderPayload": "Sales-order payload",
        "invoicePayload": "Invoice payload",
        "sources": {
          "ACTIVE_POLICY": "Active policy",
          "IMPLICIT_DEFAULT": "Implicit default"
        },
        "codes": {
          "ZOHO_ORDER_POLICY_REFERENCE_STALE": "A Zoho policy reference is stale or inactive.",
          "ZOHO_ORDER_POLICY_NOT_FOUND": "No active Zoho order policy matches this channel.",
          "ZOHO_ORDER_POLICY_NO_ACTION_MAPPING": "The active policy has no action mapping for this status.",
          "ZOHO_ORDER_POLICY_INVALID": "Check the active Zoho order policy, then try again.",
          "ZOHO_ORDER_POLICY_CHANNEL_NOT_SCOPED": "This channel is not included in the active policy.",
          "ZOHO_SALES_ORDER_ID_PENDING": "An invoice payload will include the Zoho sales order ID after the sales order is created.",
          "ZOHO_ORDER_POLICY_VOID_ORDER_UNSUPPORTED": "This void action cannot be completed for this order."
        }
      },
      "detail": {
        "title": "Order detail",
        "back": "Back to orders",
        "tabs": { "overview": "Overview", "noon": "Noon fulfillment", "zoho": "Zoho handoff", "activity": "Activity" },
        "loading": "Loading order detail…",
        "externalId": "External ID",
        "lastUpdated": "Last updated",
        "customer": "Customer",
        "email": "Email",
        "phone": "Phone",
        "placedAt": "Placed at",
        "payment": "Payment",
        "paymentStatus": "Payment status",
        "paymentMethod": "Payment method",
        "paymentType": "Payment type",
        "paymentTransactionStatus": "Transaction status",
        "delivery": "Delivery",
        "shippingCompany": "Shipping company",
        "shippingMethod": "Shipping method",
        "fulfillmentChannel": "Fulfillment channel",
        "fulfillmentStatus": "Fulfillment status",
        "deliveryAddress": "Delivery address",
        "totals": "Totals",
        "subtotal": "Subtotal",
        "tax": "Tax",
        "shipping": "Shipping",
        "discount": "Discount",
        "total": "Total",
        "invoiceBreakdown": "Invoice breakdown",
        "invoiceDescription": "Description",
        "invoiceCode": "Code",
        "invoiceAmount": "Amount",
        "noInvoiceBreakdown": "No invoice breakdown is stored for this order yet.",
        "items": "Items",
        "lineItems": "Line items",
        "itemsSummary": "{{lines}} lines · {{units}} units",
        "pricesIn": "Prices in {{currency}}",
        "item": "Item",
        "sku": "SKU",
        "quantity": "Qty",
        "unitPrice": "Unit price",
        "lineTotal": "Line total",
        "lineReference": "Line ref",
        "noLineItems": "No line items are stored for this order yet.",
        "channelSku": "Channel partner SKU",
        "channelItem": "Channel item",
        "localSku": "Tlaaq product SKU",
        "zohoItem": "Zoho item",
        "openProduct": "Open product {{name}}",
        "unmappedHelp": "No local product is linked. Map this channel listing or create a matching product.",
        "mapping": { "LISTING_MATCH": "Listing matched", "SKU_MATCH": "SKU matched", "UNMAPPED": "Product not mapped", "localProduct": "Product not mapped", "zohoItem": "Zoho item not mapped" },
        "mappingHelp": { "localProduct": "No local product is linked. Map this channel listing or create a matching product.", "zohoItem": "This product is not linked to a Zoho item. Open its product mapping to repair the link." },
        "mappingError": {
          "title": "Zoho item mapping required",
          "body": "Zoho item mappings are missing for: {{skus}}. Tlaaq did not send this order to Zoho. Fix the mapping before sending again.",
          "nextAction": "Fix product mapping",
          "cardHelp": "This order cannot be sent until every product is linked to a Zoho item.",
          "viewSku": "View missing SKU",
          "openMapping": "Open product mapping"
        },
        "zohoAction": "Zoho handoff",
        "zohoDetails": "Zoho details",
        "zohoStatus": "Zoho status",
        "zohoNextAction": "Next action",
        "zohoReason": "Reason",
        "zohoLastError": "Last Zoho error",
        "zohoPolicyAction": "Policy action",
        "zohoSalesOrderId": "Sales order ID",
        "zohoInvoiceId": "Invoice ID",
        "zohoCreditNoteId": "Credit note ID",
        "zohoSyncedAt": "Synced at",
        "invoiceReportedBy": "Invoice breakdown · as reported by {{provider}}",
        "invoiceRows": "Invoice breakdown from {{provider}} · {{count}} rows",
        "recentActivity": "Recent activity",
        "viewAllActivity": "View all {{count}}",
        "providerCalls": "Provider-call history",
        "noProviderCalls": "No provider-call history is linked to this order yet.",
        "provider": "Provider",
        "method": "Method",
        "endpoint": "Endpoint",
        "result": "Result"
      },
      "noon": {
        "title": "Noon order operations", "help": "Review availability, associate a preprinted bag, then explicitly create the shipment.", "loading": "Loading Noon operations…", "retry": "Try again", "unsupported": "Noon fulfillment is not supported for this order.",
        "reviewTitle": "Confirm item availability", "reviewHelp": "Check the latest warehouse stock, then make an explicit decision for every item.", "available": "Available", "outOfStock": "Out of stock", "saveReview": "Save availability", "quantity": "Qty {{count}}", "localSku": "SKU", "noonItem": "Noon item",
        "stockTitle": "Warehouse stock", "stockScope": "Warehouse stock scope", "mappedWarehouse": "Noon warehouse", "allWarehouses": "All warehouses", "stockSource": "Source: {{source}}", "stockUpdated": "updated {{date}}", "stockSourceZoho": "Zoho", "stockSourceTlaaq": "Tlaaq", "availableUnits": "available", "noMappedWarehouse": "No local warehouse is mapped to this Noon channel.", "stockGuidance": "Stock is guidance only. You still decide whether the item is available for this order.",
        "fulfillmentSummary": "Fulfillment summary", "noonWarehouse": "Noon warehouse", "mappedTlaaqWarehouse": "Mapped Tlaaq warehouse", "notMapped": "Not mapped", "items": "Items", "itemsSummary": "{{lines}} lines · {{units}} units", "summaryHelp": "Warehouse balances are normalized in Tlaaq. Current stock source: {{source}}.",
        "bagTitle": "Associate preprinted bag", "bagHelp": "Scan the QR code with a connected camera scanner, or enter the AWB manually. Saving this draft does not create a shipment.", "bagCode": "Bag QR / AWB", "bagPlaceholder": "Scan or enter bag code", "saveBag": "Save bag draft",
        "draftTitle": "Shipment draft", "draftNote": "Draft saved. No shipment has been created yet.", "ambiguousNote": "Noon returned an ambiguous result. Reconcile using this same AWB and shipment number; do not scan another bag.", "successNote": "Shipment created. Manifest it in Seller Lab; no label printing is required.", "shipment": "Shipment number", "create": "Create shipment", "reconcile": "Reconcile result", "cancel": "Cancel operation",
        "confirmCreateTitle": "Create Noon shipment?", "confirmCreateBody": "This final action creates the shipment using the saved preprinted bag.", "confirmCreate": "Create shipment", "confirmCancelTitle": "Cancel Noon operation?", "confirmCancelBody": "The saved fulfillment operation will be cancelled.", "confirmCancel": "Cancel operation", "keepEditing": "Go back",
        "states": { "REVIEW": "Availability review", "BAG_REQUIRED": "Bag required", "DRAFT": "Draft saved", "CREATED": "Created", "SUCCESS": "Created", "MANIFESTED": "Manifested", "AMBIGUOUS": "Reconciliation required", "RECONCILIATION_REQUIRED": "Reconciliation required", "CANCELLED": "Cancelled" },
        "errors": { "REQUEST_FAILED": "Noon operation failed. Try again.", "NOON_FBPI_BAG_CODE_INVALID": "This bag QR or AWB is invalid.", "NOON_FBPI_AWB_DUPLICATE": "This AWB is already associated with another shipment." }
      },
      "history": {
        "title": "Order history",
        "empty": "No status history is stored for this order yet.",
        "orderReceived": "Order received from {{provider}}",
        "statusReported": "{{provider}} reported status: {{status}}",
        "paymentReported": "{{provider}} reported payment: {{status}}",
        "orderUpdated": "{{provider}} reported an order update"
      },
      "empty": {
        "title": "No orders yet",
        "body": "Connected channel orders will appear here after they are pulled or received by webhook."
      },
      "pagination": "Showing {{from}}–{{to}} of {{total}} orders",
      "paginationPrev": "Previous",
      "paginationNext": "Next",
      "export": {
        "errors": {
          "codes": {
            "REQUEST_FAILED": "We could not export orders. Please try again.",
            "UNAUTHORIZED": "Your session expired. Sign in again before exporting orders.",
            "ORDER_INVALID_STATUS": "Choose a valid order status before exporting.",
            "ORDER_INVALID_PROVIDER": "Choose a valid order provider before exporting.",
            "ORDER_INVALID_ZOHO_SYNC_STATUS": "Choose a valid Zoho status before exporting.",
            "ORDER_EXPORT_TOO_LARGE": "This export is too large. Narrow the filters to 5,000 orders or 25,000 line items or fewer."
          }
        }
      },
      "errors": {
        "codes": {
          "REQUEST_FAILED": "We could not load orders. Please try again.",
          "UNAUTHORIZED": "Your session expired. Sign in again to continue.",
          "ORDER_NOT_FOUND": "Order not found.",
          "ORDER_INVALID_STATUS": "Choose a valid order status.",
          "ORDER_INVALID_PROVIDER": "Choose a valid order provider.",
          "ORDER_INVALID_ZOHO_SYNC_STATUS": "Choose a valid Zoho status.",
          "ORDER_REFRESH_UNAVAILABLE": "This order cannot be refreshed because its channel connection is not connected.",
          "ORDER_REFRESH_FAILED": "We could not refresh this order from its channel. Please try again.",
          "CHANNEL_AUTH_EXPIRED": "The channel authorization expired. Reconnect the channel, then try again.",
          "ZOHO_ORDER_PRE_SEND_REFRESH_UNAVAILABLE": "Zoho submission was blocked because this channel cannot refresh the order right now. Check the connection and try again.",
          "ZOHO_ORDER_PRE_SEND_REFRESH_AUTH_EXPIRED": "Zoho submission was blocked because the channel authorization expired. Reconnect the channel and try again.",
          "ZOHO_ORDER_PRE_SEND_REFRESH_FAILED": "Zoho submission was blocked because the latest order could not be fetched from the channel. Try again.",
          "PROVIDER_RATE_LIMITED": "Zoho's rate limit was reached. Wait a moment, then try again.",
          "ZOHO_ORDER_ITEM_MAPPING_NOT_FOUND": "One or more order products are not mapped to Zoho items. Fix the highlighted product mappings before sending again.",
          "ZOHO_INTEGRATION_NOT_AVAILABLE": "Connect Zoho Inventory before previewing this order.",
          "ZOHO_ORDER_POLICY_REFERENCE_STALE": "A Zoho policy reference is stale or inactive.",
          "ZOHO_ORDER_POLICY_NOT_FOUND": "No active Zoho order policy matches this channel.",
          "ZOHO_ORDER_POLICY_NO_ACTION_MAPPING": "The active policy has no action mapping for this status.",
          "ZOHO_ORDER_POLICY_INVALID": "Check the active Zoho order policy, then try again.",
          "ZOHO_ORDER_POLICY_CHANNEL_NOT_SCOPED": "This channel is not included in the active policy.",
          "ZOHO_SALES_ORDER_ID_REQUIRED_FOR_VOID": "Voiding requires an existing Zoho sales order ID.",
          "ZOHO_ORDER_ALREADY_INVOICED": "This order already has a Zoho invoice and cannot be voided.",
          "ZOHO_ORDER_ALREADY_VOIDED": "This Zoho sales order is already voided.",
          "ZOHO_INVOICE_RESET_NOT_ALLOWED": "Invoice sync can only be reset after this order has both a Zoho sales order and invoice ID.",
          "ZOHO_SYNC_RESET_NOT_ALLOWED": "Zoho sync can only be reset after this order has a linked Zoho document.",
          "ZOHO_SALES_ORDER_RECONCILIATION_AMBIGUOUS": "More than one Zoho sales order matches this order. Resolve it in Zoho, then try again.",
          "ZOHO_INVOICE_RECONCILIATION_AMBIGUOUS": "More than one Zoho invoice matches this order. Resolve it in Zoho, then try again.",
          "ZOHO_INVOICE_RECONCILIATION_REQUIRED": "Zoho indicates this sales order is already invoiced, but Tlaaq could not identify the invoice. Link or resolve it in Zoho, then try again.",
          "ZOHO_ORDER_POLICY_VOID_ORDER_UNSUPPORTED": "This void action cannot be completed for this order."
        }
      },
      "payment": {
        "card": "Card",
        "cod": "COD"
      },
      "dates": {
        "apr24": "Apr 24",
        "apr25": "Apr 25",
        "apr26": "Apr 26"
      }
    },
    "products": {
      "description": "Master catalog for product records, pricing, images, and mapped channel listings.",
      "searchPlaceholder": "Search products or SKU…",
      "actions": {
        "resync": "Re-sync selected",
        "export": "Export stock XLSX",
        "newProduct": "New product",
        "openDetail": "Open product {{name}}"
      },
      "filters": {
        "category": "Category",
        "channel": "Channel",
        "syncStatus": "Sync status",
        "status": "Status",
        "allStatuses": "All statuses",
        "allChannels": "All channels"
      },
      "stats": {
        "total": "Total products",
        "inSync": "In sync",
        "attention": "Need attention",
        "outOfStock": "Out of stock",
        "active": "Active",
        "draft": "Draft",
        "activeOnPage": "Active on this page",
        "draftOnPage": "Draft on this page"
      },
      "table": {
        "product": "Product",
        "sku": "SKU",
        "stock": "Stock",
        "listings": "Listings",
        "sync": "Sync",
        "price": "Price",
        "status": "Status",
        "channelSync": "Channel sync",
        "updated": "Updated",
        "select": "Select",
        "selectRow": "Select {{name}}"
      },
      "pagination": "Showing {{from}}–{{to}} of {{total}} products",
      "price": "{{value}} SAR",
      "categories": {
        "racquets": "Racquets",
        "supplements": "Supplements"
      },
      "items": {
        "pureDrive": {
          "name": "Babolat Pure Drive · G3"
        },
        "pureDriveLite": {
          "name": "Babolat Pure Drive Lite · G2"
        },
        "evoDrive": {
          "name": "Babolat Evo Drive · G3"
        },
        "evoStrike": {
          "name": "Babolat Evo Strike · G2"
        },
        "proteinBar": {
          "name": "Low Sugar Protein Bar · Box of 12"
        },
        "lowSugar": {
          "name": "Low Sugar Protein Bar · Single"
        }
      },
      "sync": {
        "synced": "Synced",
        "drift": "Drift",
        "error": "Error"
      },
      "lastSync": {
        "2s": "2s ago",
        "5s": "5s ago",
        "8s": "8s ago",
        "11s": "11s ago",
        "1m": "1m ago",
        "12m": "12m ago"
      },
      "warnings": {
        "lowStockJeddah": "Low stock in Jeddah",
        "amazonDraft": "Amazon listing still draft"
      },
      "errors": {
        "outOfStockRelisting": "Out of stock; prevent relisting",
        "codes": {
          "REQUEST_FAILED": "We could not load products. Please try again.",
          "UNAUTHORIZED": "Your session expired. Sign in again to continue.",
          "VALIDATION_FAILED": "Check the highlighted fields and try again.",
          "PRODUCT_SKU_CONFLICT": "A product with this SKU already exists.",
          "PRODUCT_IMAGE_TOO_LARGE": "The image is larger than the allowed upload size.",
          "PRODUCT_IMAGE_TYPE_UNSUPPORTED": "Use a JPEG, PNG, or WebP image.",
          "PRODUCT_IMAGE_STORAGE_DISABLED": "Image storage is not enabled yet.",
          "PRODUCT_IMAGE_STORAGE_NOT_CONFIGURED": "Image storage is not configured.",
          "PRODUCT_IMAGE_KEY_FORBIDDEN": "This image key is not allowed for your organization.",
          "PRODUCT_IMAGE_LIMIT_EXCEEDED": "You can attach up to 10 images per product.",
          "PRODUCT_IMAGE_IN_USE": "This image is already attached to a product.",
          "PRODUCT_IMAGE_DELETE_FAILED": "We could not clean up the uploaded image.",
          "PRODUCT_NOT_FOUND": "Product not found.",
          "PRODUCT_INVALID_STATUS": "Choose a valid product status.",
          "PRODUCT_INVALID_LISTED_PROVIDER": "Choose a valid listed provider.",
          "PRODUCT_CATALOG_EXTERNAL_SOURCE": "Product details are managed by your connected catalog source. You can still update additional SKUs."
        }
      },
      "export": {
        "exporting": "Exporting…",
        "errors": {
          "codes": {
            "REQUEST_FAILED": "We could not export product stock. Please try again.",
            "UNAUTHORIZED": "Your session expired. Sign in again to export product stock.",
            "PRODUCT_INVALID_STATUS": "Choose a valid product status before exporting.",
            "PRODUCT_INVALID_LISTED_PROVIDER": "Choose a valid listed provider before exporting."
          }
        }
      },
      "searchLabel": "Search products",
      "phaseOne": "Phase 1",
      "status": {
        "ACTIVE": "Active",
        "INACTIVE": "Inactive",
        "DRAFT": "Draft"
      },
      "loading": "Loading products…",
      "emptyFiltered": "No products match this search or filter.",
      "paginationPrev": "Previous",
      "paginationNext": "Next",
      "imageCount": "{{count}} images",
      "options": {
        "count": "{{count}} options",
        "withoutSku": "options without SKU",
        "totalAcross": "total · {{count}} options",
        "available": "available",
        "availableCount": "{{quantity}} available",
        "show": "Show options for {{name}}",
        "hide": "Hide options for {{name}}",
        "loading": "Loading options…",
        "loadError": "We could not load the options.",
        "retry": "Try again",
        "rowLabel": "{{parent}} option {{option}}",
        "linkHint": "No SKU · linked by Salla option",
        "title": "Options",
        "subtitleEditable": "Stock lives on each option. Saving an option pushes its stock to the matching Salla option.",
        "subtitleReadOnly": "{{source}} owns stock for these options. Tlaaq shows what it last pulled — change stock in {{source}}.",
        "totalSummary": "Total {{total}} across {{count}} options",
        "stockSource": "Stock source: {{source}}",
        "tlaaq": "Tlaaq",
        "note": "These options have no SKU in Salla, so Tlaaq links each one by its Salla option ID. They sync with Salla only — Zoho and other channels match by SKU and can't see them. Add a SKU in Salla and the option moves to its own product on the next pull, keeping its stock and links.",
        "loadingDetail": "Loading options and stock…",
        "loadErrorDetail": "We could not load this product's options. Please try again.",
        "wasCommitted": "was {{was}} · {{committed}} committed",
        "committed": "{{quantity}} committed",
        "editOption": "Edit option · {{option}}",
        "saveChanges": "Save changes",
        "activationHint": "Activating this option queues its stock using your allocation rules. The parent and other options stay unchanged.",
        "statusFor": "Status for {{option}}",
        "noSku": "No SKU",
        "retryPush": "Retry push",
        "parentSkuNone": "— Options below have no SKU",
        "headers": {
          "option": "Option",
          "onHandCode": "On hand · {{code}}",
          "salla": "Salla",
          "sallaSource": "Salla (source)"
        },
        "sync": {
          "blocked": "Not syncing: {{status}}",
          "inSync": "In sync · {{quantity}}",
          "matchesSalla": "Matches Salla",
          "sallaShows": "Salla shows {{quantity}}",
          "notPushed": "Not pushed yet",
          "willPush": "Next push sends {{quantity}}",
          "pushedAt": "Pushed {{date}}",
          "pulledAt": "Pulled {{date}}",
          "pushing": "Pushing {{quantity}} to Salla…",
          "startedNow": "Started just now",
          "pushFailed": "Push failed",
          "stillShows": "Salla still shows {{quantity}}"
        },
        "parentStock": {
          "warning": "This product had stock of its own before its options were linked. That stock isn't pushed to Salla. Move it to the options or set it to 0.",
          "notSynced": "on hand · not synced",
          "setToZero": "Set to 0"
        },
        "released": {
          "message": "All options of this product now have their own SKU and moved to separate products. This product no longer has options.",
          "archive": "Archive product",
          "dismiss": "Dismiss"
        }
      },
      "channelSyncTooltip": "Mapped channel listings for this product.",
      "channelSync": {
        "empty": "No mapped listings",
        "listingCount": "{{channel}} · {{count}} listing",
        "listingCount_plural": "{{channel}} · {{count}} listings",
        "multiCount": "{{count}} mapped listings",
        "quantity": "{{quantity}} available",
        "infinite": "∞ available"
      }
    },
    "productsEmpty": {
      "title": "Your catalog is empty",
      "body": "Create your first product manually, or connect a channel and explicitly pull products when you are ready.",
      "startPrompt": "How would you like to start?",
      "recommended": "Recommended",
      "zoho": {
        "title": "Connect Zoho Inventory",
        "body": "Pull products, warehouses, and stock levels from Zoho in a later phase.",
        "cta": "Connect Zoho"
      },
      "csv": {
        "title": "Import CSV",
        "body": "CSV import is deferred to a separate release.",
        "cta": "Upload CSV"
      },
      "channel": {
        "title": "Import from channel",
        "body": "Connect a store, choose source authority, then pull products from the Channels page.",
        "cta": "Go to channels"
      },
      "or": "or",
      "manual": "Create one product manually",
      "comingSoon": "Coming soon"
    },
    "productDetail": {
      "product": {
        "name": "Babolat Pure Drive · G3",
        "category": "Racquets",
        "description": "Competition tennis racquet with 300g frame, 16x19 string pattern, and Cortex dampening. Bestseller across Salla and Noon."
      },
      "breadcrumbProducts": "Products",
      "zoho": "Zoho",
      "inStock": "In stock",
      "lastSync": "Last sync",
      "lastSyncValue": "2s ago",
      "price": "{{value}} SAR",
      "actions": {
        "resync": "Re-sync now",
        "edit": "Edit product",
        "back": "Back to products"
      },
      "tabs": {
        "master": "Master data"
      },
      "master": {
        "title": "Master product",
        "fields": {
          "sku": "SKU",
          "altSkus": "Additional SKUs",
          "name": "Name",
          "category": "Category",
          "masterPrice": "Master price",
          "barcode": "Barcode",
          "weight": "Weight",
          "dimensions": "Dimensions",
          "description": "Description",
          "status": "Status",
          "cost": "Cost",
          "salePrice": "Sale price",
          "taxRate": "Tax rate",
          "updated": "Updated"
        },
        "sourcePrefix": "Source:",
        "sourceSuffix": "Zoho Inventory · item 190027",
        "phaseOneNote": "This master data is editable in Phase 1. Mapped channel listings show provider data; publishing actions remain preview-only."
      },
      "stock": {
        "title": "Source warehouse stock",
        "subtitle": "Available units after reserved channel orders.",
        "readOnly": "Owned by {{source}} · Read-only in Tlaaq. Change stock in the source; channel quantities are separate.",
        "channelHint": "This is source stock for this catalog item. Open a store tab to inspect its mapped listing and channel stock observations.",
        "source": "Inventory source",
        "sourceUnknown": "Loading or unavailable",
        "ownership": "Inventory source: {{source}}. Only Tlaaq-owned inventory is editable here; external-source inventory is read-only.",
        "loading": "Loading stock…",
        "empty": "No warehouses yet. Create one from the Warehouses page to manage stock per location.",
        "headers": {
          "warehouse": "Warehouse",
          "onHand": "On hand",
          "committed": "Committed",
          "available": "Available"
        },
        "actions": {
          "edit": "Edit",
          "save": "Save",
          "cancel": "Cancel"
        },
        "errors": {
          "generic": "We could not update stock. Please try again.",
          "REQUEST_FAILED": "We could not load stock. Please try again.",
          "PRODUCT_NOT_FOUND": "Product not found.",
          "PRODUCT_STOCK_VERSION_CONFLICT": "Stock changed since you started editing. We refreshed the row — try again.",
          "PRODUCT_STOCK_INVALID_QUANTITY": "Enter a non-negative whole number not less than committed stock."
        }
      },
      "zohoRefresh": {
        "action": "Refresh from Zoho",
        "refreshing": "Refreshing…",
        "success": "Product refreshed from Zoho.",
        "successWithIssues": "Product refreshed from Zoho with {{count}} issue.",
        "successWithIssues_plural": "Product refreshed from Zoho with {{count}} issues.",
        "errors": {
          "REQUEST_FAILED": "We could not refresh this product from Zoho. Try again.",
          "PRODUCT_ZOHO_REFRESH_SOURCE_MISMATCH": "Zoho must be the product source before refreshing this product.",
          "PRODUCT_ZOHO_REFRESH_NOT_FOUND": "We could not find the matching Zoho item for this product.",
          "PRODUCT_ZOHO_REFRESH_AMBIGUOUS": "Multiple Zoho items match this product SKU. Resolve the duplicate SKU in Zoho, then try again.",
          "INVENTORY_CONNECTION_NOT_CONFIGURED": "Zoho is not connected.",
          "INVENTORY_ADAPTER_NOT_REGISTERED": "Zoho refresh is not available in this deployment.",
          "INVENTORY_AUTH_EXPIRED": "Zoho authorization expired. Reconnect Zoho and try again.",
          "INVENTORY_PULL_FAILED": "Zoho refresh failed. Try again or check provider-call history.",
          "INVENTORY_RATE_LIMITED": "Zoho rate limited this refresh. Try again later."
        }
      },
      "singleImportNotice": {
        "outcomes": {
          "CREATED": "Product created from the Zoho item",
          "REFRESHED": "Product refreshed from the Zoho item",
          "MATCHED": "Zoho item matched to this product"
        },
        "subtitle": "Product Detail loaded the canonical saved product. This import summary is temporary.",
        "dismiss": "Dismiss import summary",
        "catalogLabel": "Catalog behavior",
        "catalog": {
          "SOURCE_SYNC": "Zoho product details applied",
          "IMPORT_MISSING": "Missing product created; existing fields preserved",
          "LISTINGS_ONLY": "Mapping only; product details preserved"
        },
        "stockLabel": "Stock rows imported",
        "warehousesLabel": "Warehouses created",
        "issuesLabel": "Issues",
        "issueDetails": "Items to review",
        "issueCount": "{{count}} occurrence",
        "issueCount_plural": "{{count}} occurrences",
        "issueCount_other": "{{count}} occurrences"
      },
      "channel": {
        "listingTitle": "Channel listings",
        "empty": "No listing exists yet for this channel.",
        "createListing": "Create listing",
        "listing": "{{channel}} listing",
        "mappedSubtitle": "Mapped listing from {{channel}}.",
        "mappedCount": "{{count}} mapped listing",
        "mappedCount_plural": "{{count}} mapped listings",
        "live": "Live",
        "notListed": "Not listed",
        "viewOn": "View on {{channel}} ↗",
        "unlist": "Unlist",
        "fieldsTitle": "Listing fields",
        "stockRowsTitle": "Provider branch quantities",
        "stockRowsEmpty": "No warehouse quantity rows were returned by {{channel}}.",
        "variantStockScope": "Stock observations belong to this listing’s variant ID {{variantId}}. SKU alone does not identify an option.",
        "listingStockScope": "Channel stock observations are separate from source warehouse stock.",
        "branch": "Branch / location",
        "observedIn": "Observed in {{channel}}",
        "submittedTarget": "Last submitted target",
        "unknownQuantity": "Unknown",
        "notFetched": "Not fetched for this location",
        "notSubmitted": "Not submitted",
        "pendingBody": "Submitted — awaiting confirmation. Refresh channel stock to fetch the latest quantities. No automatic polling.",
        "confirmedBody": "A newer stock fetch reports the submitted target for this listing and location. Other options and locations are not confirmed.",
        "observedAt": "Last stock fetched",
        "submittedQuantity": "Submitted quantity",
        "submittedAt": "Last submitted",
        "confirmed": "Confirmed after fetch",
        "awaitingConfirmation": "Awaiting confirmation",
        "noonRefresh": "Refresh channel stock",
        "noonRefreshing": "Refreshing channel stock…",
        "noonRefreshFailed": "Could not refresh channel stock. Previously displayed data is unchanged. Try again.",
        "quantityInfinite": "∞",
        "fields": {
          "title": "Title",
          "priceOverride": "Price override",
          "category": "Category",
          "status": "Status",
          "channelId": "Channel ID",
          "lastPublished": "Last published",
          "externalProductId": "External product ID",
          "externalVariantId": "External variant ID",
          "sku": "Listing SKU",
          "lastSeen": "Listing last fetched",
          "lastStockPushed": "Last stock submitted",
          "warehouse": "Warehouse",
          "externalLocationId": "External location ID",
          "quantity": "Observed quantity"
        },
        "defaultCategory": "Sports / Tennis",
        "amazonCategory": "Sports & Outdoors",
        "liveAt": "Live at {{price}} SAR",
        "recentOn": "Recent activity on {{channel}}",
        "notListedSubtitle": "This product is not listed on {{channel}}.",
        "notListedTitle": "Product not listed on {{channel}}",
        "notListedBody": "No mapped {{channel}} listing exists for this product. Map or import the channel listing before syncing stock or publishing updates.",
        "noonNotListedBody": "No imported Noon listing exists yet. You can still push stock using this product's SKU; Noon will reject the update if that SKU is not listed.",
        "stockPush": {
          "title": "Manual stock push",
          "titleForBranch": "Manual stock push · {{location}}",
          "body": "Push an absolute available quantity from Tlaaq to this {{channel}} listing.",
          "bodyForBranch": "This listing and {{location}} only. Other options and locations are unchanged.",
          "variantScope": "Only {{title}}, variant {{variantId}}, in this location.",
          "absoluteTarget": "Retry sets the same absolute target; it does not add that quantity again.",
          "setOptionQuantity": "Set selected option stock to {{quantity}}",
          "setListingQuantity": "Set listing stock to {{quantity}}",
          "noonBody": "Push an absolute available quantity to Noon using the local product SKU and configured warehouse.",
          "noonSku": "SKU:",
          "noonWarehouse": "Warehouse:",
          "action": "Push stock",
          "actionForBranch": "Push {{location}}",
          "loadingStock": "Loading local stock…",
          "quantityLabel": "Available quantity",
          "localAvailable": "Current local available stock: {{quantity}}",
          "exceedsLocalWarning": "This quantity is higher than current local availability. You can still push it if this is intentional.",
          "submit": "Push to channel",
          "submitting": "Pushing…",
          "cancel": "Cancel",
          "success": "Request accepted: submitted {{quantity}} units to {{channel}}. Check the latest channel stock observation for confirmation.",
          "unsupportedProvider": "Manual stock push is not enabled for {{channel}}.",
          "capabilityReasons": {
            "CHANNEL_OPERATION_NOT_IMPLEMENTED": "Manual stock push is not supported for {{channel}} yet.",
            "CHANNEL_OPERATION_FEATURE_DISABLED": "Manual stock push for {{channel}} is disabled by configuration.",
            "CHANNEL_CONNECTION_NOT_READY": "Connect {{channel}} before pushing stock.",
            "CHANNEL_SOURCE_AUTHORITY_REQUIRED": "{{channel}} is the stock source authority, so Tlaaq will not push stock back to it.",
            "NOON_FBPI_WAREHOUSE_REQUIRED": "Configure the Noon FBPI warehouse before pushing stock."
          },
          "sourceOwned": "{{channel}} is the stock source authority, so Tlaaq will not push stock back to it.",
          "noStockLocations": "This listing has no provider stock locations. Pull listings with stock rows from {{channel}} before pushing quantity.",
          "itemReasons": {
            "NO_PRODUCT_MAPPING": "This listing is no longer mapped to a product.",
            "NO_STOCK_LOCATIONS": "No provider stock locations were available for this listing.",
            "EXCLUDED_BY_ALLOCATION_RULE": "Stock allocation automation skipped this product because it is excluded from the rule.",
            "PROVIDER_ERROR": "The channel rejected the stock update. Check the channel connection and try again.",
            "UNEXPECTED_ERROR": "The channel stock update failed unexpectedly. Try again."
          },
          "errors": {
            "CHANNEL_STOCK_PUSH_SOURCE_CONNECTION": "This channel owns stock for the organization, so Tlaaq cannot push stock back to it.",
            "CHANNEL_STOCK_PUSH_UNSUPPORTED": "Manual stock push is not supported for this provider yet.",
            "CHANNEL_STOCK_PUSH_INVALID_QUANTITY": "Enter a non-negative whole number.",
            "CHANNEL_STOCK_PUSH_FEATURE_DISABLED": "Manual Noon stock push is disabled by configuration.",
            "CHANNEL_STOCK_PUSH_PRODUCT_SKU_REQUIRED": "This product needs a SKU before stock can be pushed to Noon.",
            "NOON_FBPI_WAREHOUSE_REQUIRED": "Configure the Noon FBPI warehouse before pushing stock.",
            "CHANNEL_CONNECTION_NOT_FOUND": "This channel connection was not found.",
            "PRODUCT_NOT_FOUND": "This product was not found.",
            "CHANNEL_AUTH_EXPIRED": "The channel authorization expired. Reconnect the channel, then try again.",
            "CHANNEL_LISTING_NOT_FOUND": "This listing or product was not found.",
            "REQUEST_FAILED": "We could not push stock to the channel. Try again."
          }
        }
      },
      "activity": {
        "2s": "2s ago",
        "8m": "8m ago",
        "1h": "1h ago",
        "yesterday": "Yesterday",
        "saleOne": "Sale reserved 1 unit from Riyadh",
        "revalidated": "Listing revalidated successfully",
        "saleTwo": "Sale reserved 2 units from Jeddah",
        "priceUpdate": "Price override updated"
      },
      "emptyValue": "—",
      "loading": "Loading product…",
      "lastUpdated": "Updated",
      "imageCount": "{{count}} images",
      "weightValue": "{{value}} g",
      "taxValue": "{{value}}%",
      "images": {
        "title": "Images",
        "empty": "No product images yet."
      },
      "channelTabs": {}
    },
    "onboarding": {
      "signup": {
        "title": "Create your workspace",
        "subtitle": "Start with your account, then connect the first channel.",
        "fullName": "Full name",
        "fullNamePlaceholder": "Lubna Al Qahtani",
        "email": "Work email",
        "emailPlaceholder": "lubna@yourstore.sa",
        "storeName": "Store name",
        "storeNamePlaceholder": "Fitneeds",
        "storeNameHint": "This becomes your Tlaaq workspace name.",
        "password": "Password",
        "createAccount": "Create account",
        "continueGoogle": "Continue with Google",
        "terms": "By continuing you agree to Tlaaq terms and privacy policy."
      },
      "common": {
        "back": "Back",
        "continue": "Continue"
      },
      "steps": {
        "createAccount": "Account",
        "connectStore": "Connect store",
        "sourceOfTruth": "Source and import",
        "youreSet": "Ready"
      },
      "connect": {
        "title": "Connect your first store",
        "subtitle": "Pick the marketplace or storefront you want Tlaaq to watch first.",
        "popular": "Popular",
        "connect": "Connect",
        "skip": "Skip for now"
      },
      "channels": {
        "salla": "Salla",
        "zid": "Zid",
        "amazon": "Amazon",
        "noon": "Noon",
        "trendyol": "Trendyol"
      },
      "source": {
        "title": "Where do you manage products and stock?",
        "subtitle": "You connected {{channel}}. Choose whether that store or Tlaaq owns your catalog and stock before anything is imported.",
        "recommended": "Recommended",
        "almostDone": "Almost done",
        "options": {
          "tlaaq": {
            "title": "Use Tlaaq as my system",
            "sub": "Best for new operations",
            "body": "Manage products, warehouses, and stock directly inside Tlaaq. You can still import missing {{channel}} products as a starting point.",
            "meta": "Fastest setup"
          },
          "channel": {
            "title": "Use my {{channel}} store",
            "sub": "Mirror the store",
            "body": "Products and stock already live in {{channel}}. Tlaaq will pull them in and sync them to other channels.",
            "meta": "Recommended if the store is live"
          },
          "zoho": {
            "title": "Connect Zoho Inventory",
            "sub": "For existing Zoho users",
            "body": "Keep Zoho as master and let Tlaaq sync channels.",
            "meta": "Recommended if Zoho is live"
          },
          "skip": {
            "title": "Decide later",
            "sub": "Explore first",
            "body": "Open the workspace and configure inventory from Settings."
          }
        },
        "pull": {
          "title": "Pull products now?",
          "channelBody": "We will import products, prices, and current stock from {{channel}}. You can also run this later from Channels.",
          "tlaaqBody": "We will create local product entries for safe missing {{channel}} SKUs. Future store changes will not overwrite Tlaaq.",
          "now": "Import now",
          "later": "Import later"
        }
      },
      "welcome": {
        "title": "You are ready to sell everywhere",
        "body": "Tlaaq will now keep products, orders, and stock moving across your channels.",
        "dashboard": "Open dashboard"
      },
      "signOut": "Sign out"
    },
    "settings": {
      "groups": {
        "workspace": "Workspace",
        "operations": "Operations",
        "system": "System"
      },
      "sections": {
        "workspace": {
          "title": "Workspace profile",
          "description": "Organization name, domain, and default locale."
        },
        "branding": {
          "title": "Branding",
          "description": "Logo, colors, and invoice identity."
        },
        "members": {
          "title": "Members & roles",
          "description": "Invite teammates and tune access."
        },
        "inventory": {
          "title": "Inventory rules",
          "description": "Source of truth, stock buffers, and reconciliation."
        },
        "orders": {
          "title": "Order rules",
          "description": "Routing, fraud holds, and fulfillment preferences."
        },
        "shipping": {
          "title": "Shipping",
          "description": "Carrier defaults and delivery promises."
        },
        "tax": {
          "title": "Tax & invoices",
          "description": "VAT IDs, tax codes, and invoice numbering."
        },
        "notifications": {
          "title": "Notifications",
          "description": "Email, Slack, and WhatsApp alerts."
        },
        "api": {
          "title": "API keys",
          "description": "Manage integrations and webhook secrets."
        },
        "audit": {
          "title": "Audit log",
          "description": "Review security and configuration changes."
        },
        "danger": {
          "title": "Danger zone",
          "description": "Export or delete workspace data."
        }
      },
      "inventoryRules": {
        "title": "Inventory rules",
        "description": "Configure how Tlaaq reads, protects, and reconciles stock.",
        "source": {
          "title": "Source of truth",
          "caption": "Current source",
          "zoho": "Zoho Inventory",
          "detail": "Products and stock are read from Zoho before publishing to channels.",
          "switch": "Switch source"
        },
        "buffer": {
          "title": "Stock buffer",
          "caption": "Keep units unavailable to channels to reduce overselling.",
          "row": "Reserve buffer per SKU",
          "units": "units",
          "applyTo": "Apply to every warehouse"
        },
        "outOfStock": {
          "title": "When product is out of stock",
          "caption": "Choose what Tlaaq does on each channel.",
          "delist": {
            "title": "Delist from marketplaces",
            "description": "Hide products from Amazon, Noon, and Trendyol when stock hits zero."
          },
          "zero": {
            "title": "Keep listing, push zero stock",
            "description": "Recommended for Salla and Zid storefronts."
          }
        },
        "reconciliation": {
          "title": "Reconciliation",
          "caption": "Catch drift between Tlaaq, Zoho, and each channel.",
          "schedule": "Schedule",
          "scheduleValue": "Every 15 minutes",
          "threshold": "Alert threshold",
          "thresholdUnits": "units difference",
          "lastRun": "Last run",
          "lastRunValue": "4 minutes ago",
          "checked": "3,289 SKUs checked",
          "noDrift": "No drift detected"
        }
      },
      "actions": {
        "save": "Save changes",
        "discard": "Discard"
      },
      "genericComingSoon": "This settings section is coming soon."
    },
    "syncRuleWizard": {
      "breadcrumb": {
        "inventory": "Inventory",
        "zoho": "Zoho Inventory",
        "orderPolicy": "Order policy"
      },
      "title": "Zoho order policy builder",
      "subtitle": "Scope a Zoho order policy to channels, set common defaults, map channel statuses to lifecycle actions, and add payment, shipping, and warehouse rules.",
      "loading": "Loading…",
      "emptyValue": "—",
      "noConnection": {
        "title": "Connect Zoho first",
        "body": "Open Zoho setup and connect an inventory account before creating an order policy."
      },
      "actions": {
        "refreshMasterData": "Refresh Zoho master data",
        "refreshingMasterData": "Refreshing…",
        "refreshChannelMethods": "Refresh channel methods",
        "refreshingChannelMethods": "Refreshing methods…",
        "add": "Add",
        "createDraft": "Create draft policy",
        "creatingDraft": "Creating draft…",
        "saveDraft": "Save draft policy",
        "savingDraft": "Saving draft…",
        "activateDraft": "Activate created policy",
        "activating": "Activating…",
        "backToZoho": "Back to Zoho setup",
        "resetDefaultActions": "Reset default actions",
        "addActionMapping": "Add action mapping",
        "fbnPreset": "Use FBN fulfillment",
        "flexPreset": "Use Flex SKU prefix F-",
        "addAdvancedRule": "Add advanced rule",
        "addWarehouseOverride": "Add warehouse override",
        "remove": "Remove",
        "clear": "Clear",
        "searchProducts": "Search products",
        "removeCondition": "Remove {{condition}} condition",
        "removePaymentMapping": "Remove payment mapping",
        "removeShippingMapping": "Remove shipping mapping"
      },
      "notices": {
        "masterDataRefreshed": "Zoho master data refreshed.",
        "channelMethodsRefreshed": "Channel methods refreshed.",
        "draftCreated": "Draft policy created.",
        "draftUpdated": "Draft policy saved.",
        "policyActivated": "Policy activated."
      },
      "defaults": {
        "policyName": "Default Zoho order policy"
      },
      "placeholders": {
        "selectOptional": "Use Zoho default",
        "allPolicyChannels": "All policy channels",
        "selectRequired": "Choose a Zoho value",
        "manualOrObserved": "Manual / observed value",
        "noShippingCondition": "No shipping condition",
        "addCondition": "Add condition…",
        "allConditionsAdded": "All conditions added",
        "paymentMethod": "Card, COD, wallet…",
        "paymentStatus": "paid, captured, pending…",
        "paymentMethodType": "COD, CARD, BNPL…",
        "paymentMethodExternalId": "Provider payment ID…",
        "shippingCompany": "Aramex, SMSA…",
        "shippingMethod": "Express, same day…",
        "shippingMethodExternalId": "Provider delivery ID…",
        "shippingMethodCode": "redbox, aramex…",
        "rawStatus": "Unmapped channel status…",
        "rawStatuses": "delivered, shipped…",
        "priority": "100",
        "paymentMethodCode": "COD, CARD…",
        "fulfillmentChannel": "FBN, MFN, FLEX…",
        "fulfillmentStatus": "ready, shipped…",
        "skuPrefix": "F-",
        "searchServiceItems": "Search service products by SKU or name…"
      },
      "fields": {
        "name": "Policy name",
        "invoiceSourceMode": "Invoice source",
        "customer": "Customer",
        "warehouse": "Warehouse",
        "defaultWarehouse": "Default warehouse",
        "defaultPaymentTerms": "Default payment terms",
        "defaultDeliveryMethod": "Default delivery method",
        "salesPerson": "Sales person",
        "paymentTerms": "Payment terms",
        "zohoPaymentTerms": "Zoho payment terms",
        "paymentFeeServiceItem": "COD/payment fee service item",
        "deliveryMethod": "Delivery method",
        "zohoDeliveryMethod": "Zoho delivery method",
        "shippingFeeServiceItem": "Shipping fee service item",
        "createInvoice": "Create invoice",
        "confirmOrder": "Confirm sales order",
        "voidOrder": "Void unsupported cancelled orders",
        "serviceItemSearch": "Search service items",
        "paymentMethod": "Payment method text",
        "paymentStatus": "Payment status",
        "paymentMethodCode": "Payment method code",
        "paymentMethodType": "Payment method type",
        "paymentMethodExternalId": "Payment method ID",
        "channelPaymentMethod": "Channel payment method",
        "shippingCondition": "Shipping condition",
        "channelDeliveryOption": "Channel delivery option",
        "shippingMethodExternalId": "Shipping method ID",
        "shippingMethodCode": "Shipping method code",
        "shippingCompany": "Shipping company",
        "shippingMethod": "Shipping method",
        "addPaymentCondition": "Add payment condition",
        "addShippingCondition": "Add shipping condition",
        "reportingTag": "Reporting tag",
        "reportingTagOption": "Reporting tag option",
        "rulePriority": "Rule priority",
        "mappingPriority": "Priority",
        "lifecycleAction": "Zoho action",
        "orderStatuses": "Order statuses",
        "rawStatuses": "Raw statuses",
        "channelProvider": "Channel provider",
        "channelConnectionId": "Channel connection ID",
        "channelConnection": "Channel",
        "mappingChannelScope": "Limit to channel",
        "orderStatus": "Order status",
        "rawStatus": "Raw status",
        "fulfillmentChannel": "Fulfillment channel",
        "fulfillmentStatus": "Fulfillment status",
        "skuMatchScope": "SKU match scope",
        "skuMatchOperator": "SKU match operator",
        "skuMatchValue": "SKU match value",
        "overrideCustomer": "Override customer",
        "overrideWarehouse": "Override warehouse",
        "targetWarehouse": "Target warehouse",
        "overrideSalesPerson": "Override sales person",
        "overridePaymentTerms": "Override payment terms",
        "overrideDeliveryMethod": "Override delivery method",
        "overrideReportingTag": "Override reporting tag",
        "overrideReportingTagOption": "Override reporting tag option",
        "createInvoiceOverride": "Create invoice override",
        "confirmOrderOverride": "Confirm order override",
        "voidOrderOverride": "Void order override"
      },
      "base": {
        "title": "Base defaults",
        "body": "These Zoho values apply unless a payment or shipping mapping overrides them."
      },
      "channels": {
        "title": "Channels",
        "body": "Choose the channel connections this Zoho policy owns. A channel can have only one active policy per Zoho connection.",
        "empty": "No channel connections are available yet."
      },
      "invoiceSource": {
        "modes": {
          "LOCAL_ORDER": "Use Tlaaq local order lines",
          "ZOHO_SALES_ORDER_SNAPSHOT": "Use latest Zoho sales order snapshot"
        },
        "help": {
          "LOCAL_ORDER": "Invoices are created from the line items stored on the Tlaaq order. Manual edits made directly in Zoho are ignored.",
          "ZOHO_SALES_ORDER_SNAPSHOT": "Before creating an invoice, Tlaaq fetches the latest Zoho sales order and creates the invoice from that snapshot without changing the local order."
        },
        "scopeHelp": "This setting applies to every channel selected in this policy. Use a separate policy for channels that need a different invoice source."
      },
      "commonDefaults": {
        "title": "Common Zoho defaults",
        "body": "These master-data values apply to every mapped action unless payment, shipping, or warehouse rules choose a more specific value."
      },
      "actionMappings": {
        "title": "Status action mappings",
        "body": "Map normalized channel order statuses, and optional raw statuses, to the Zoho lifecycle action that Send to Zoho should execute."
      },
      "paymentMappings": {
        "title": "Payment definitions",
        "body": "Define which channel order payment facts should map to a Zoho payment terms value. Leave channel scope empty to use every channel selected above.",
        "empty": "No payment mappings yet."
      },
      "shippingMappings": {
        "title": "Shipping definitions",
        "body": "Define which channel order shipping facts should map to a Zoho delivery method. Leave channel scope empty to use every channel selected above.",
        "empty": "No shipping mappings yet."
      },
      "mappingSections": {
        "orderConditionsTitle": "Order match conditions",
        "paymentOrderConditionsBody": "These fields come from the channel order payload. Limit to channel only when one selected store needs a more specific rule.",
        "shippingOrderConditionsBody": "These fields come from the channel order payload. Limit to channel only when one selected store needs a more specific rule.",
        "noConditions": "No conditions selected yet. Add only the fields this rule should match.",
        "definitionsCount": "{{count}} saved",
        "zohoResultTitle": "Zoho result",
        "paymentResultBody": "When the order conditions match, Tlaaq sends this payment terms value to Zoho.",
        "shippingResultBody": "When the order conditions match, Tlaaq sends this delivery method value to Zoho."
      },
      "channelMethods": {
        "emptyPayment": "No cached payment methods for the selected Zid channels yet. Refresh methods or enter observed values manually.",
        "emptyShipping": "No cached delivery options for the selected Zid channels yet. Refresh methods or enter observed values manually.",
        "missingShippingScope": "Delivery option discovery needs the Zid shipping.read scope. Existing policies still save with manual shipping ID, code, company, or method values."
      },
      "serviceItems": {
        "empty": "No service item selected.",
        "paymentHelper": "Optional. For Zid/Mazeed COD or payment fees, Tlaaq sends this pulled Zoho service product as a taxable line item instead of a native adjustment.",
        "shippingHelper": "Optional. For Zid/Mazeed shipping fees, Tlaaq sends this pulled Zoho service product as a taxable line item instead of Zoho shipping_charge.",
        "searching": "Searching…",
        "noResults": "No products found.",
        "error": "Could not search products. Try again.",
        "selectedProduct": "Selected product #{{id}}"
      },
      "advancedRules": {
        "title": "Advanced exception rules",
        "body": "Add condition-based overrides for channel, order status, fulfillment, or SKU patterns before falling back to the base defaults.",
        "empty": "No advanced exception rules yet.",
        "summary": "Priority {{priority}} · status {{status}} · SKU {{sku}}"
      },
      "warehouseOverrides": {
        "title": "Warehouse overrides",
        "body": "Route matching orders to a specific Zoho warehouse using channel, status, payment, shipping, fulfillment, or SKU predicates such as FBN and Flex prefixes.",
        "empty": "No warehouse overrides yet.",
        "summary": "Priority {{priority}} · status {{status}} · warehouse {{warehouse}}"
      },
      "skuScopes": {
        "ANY_LINE": "Any line matches",
        "ALL_LINES": "All lines match",
        "NO_LINE": "No line matches"
      },
      "skuOperators": {
        "EXACT": "Equals",
        "PREFIX": "Starts with",
        "SUFFIX": "Ends with",
        "CONTAINS": "Contains"
      },
      "actionOverrides": {
        "INHERIT": "Inherit base action",
        "YES": "Yes",
        "NO": "No"
      },
      "lifecycleActions": {
        "CREATE_SALES_ORDER": "Create sales order",
        "CONFIRM_SALES_ORDER": "Confirm sales order",
        "CREATE_INVOICE": "Create invoice",
        "VOID_SALES_ORDER": "Void sales order",
        "CREATE_CREDIT_NOTE": "Create credit note"
      },
      "orderStatuses": {
        "NEW": "New",
        "IN_PROGRESS": "In progress",
        "COMPLETED": "Completed",
        "CANCELLED": "Cancelled",
        "UNKNOWN": "Unknown"
      },
      "active": {
        "title": "Active policy",
        "summary": "{{channels}} channel(s) · default warehouse {{warehouse}}",
        "emptyTitle": "No active policy",
        "emptyBody": "Create and activate a policy before testing Zoho order previews."
      },
      "autoSend": {
        "title": "Auto-send orders to Zoho",
        "enabled": "Auto-send on",
        "disabled": "Auto-send off",
        "toggleLabel": "Toggle auto-send for {{name}}",
        "help": "Applies only to future imported or updated orders. Manual Send to Zoho remains available when auto-send is off.",
        "activeOnlyHelp": "Activate this policy before enabling auto-send. Manual Send to Zoho remains separate from this automation.",
        "saving": "Updating auto-send…"
      },
      "draft": {
        "title": "Draft policies",
        "createTitle": "Draft policy",
        "createBody": "Save this form as a draft, then activate it from the Zoho setup page.",
        "editTitle": "Editing draft policy",
        "editBody": "Changes update version {{version}} in place until it is activated.",
        "empty": "No draft policies yet.",
        "version": "Version {{version}}",
        "viewTitle": "Viewing policy",
        "viewBody": "This {{status}} version {{version}} is read-only. To change it, create a draft copy from the Zoho setup page."
      },
      "deferred": {
        "title": "Send behavior",
        "body": "Send to Zoho uses the matched channel order status to create, confirm, invoice, or void the Zoho sales order according to these mappings."
      },
      "validation": {
        "channelsRequired": "Choose at least one channel before saving.",
        "actionsRequired": "Keep at least one status action mapping before saving.",
        "paymentMappingNeedsCriteria": "Add at least one payment match value, or use Default payment terms above.",
        "shippingMappingNeedsCriteria": "Add at least one shipping match value, or use Default delivery method above.",
        "paymentMappingsInvalid": "Every payment definition needs payment terms and at least one payment match value.",
        "shippingMappingsInvalid": "Every shipping definition needs a delivery method and at least one shipping match value."
      },
      "status": {
        "DRAFT": "Draft",
        "ACTIVE": "Active",
        "DISABLED": "Disabled",
        "ARCHIVED": "Archived"
      },
      "errors": {
        "codes": {
          "REQUEST_FAILED": "The request failed. Try again.",
          "UNAUTHORIZED": "Your session expired. Sign in again.",
          "ZOHO_ORDER_POLICY_NOT_FOUND": "No active policy exists yet.",
          "ZOHO_ORDER_POLICY_INVALID": "Check the policy fields and try again.",
          "ZOHO_ORDER_POLICY_REFERENCE_NOT_FOUND": "One selected Zoho value was not found. Refresh master data and try again.",
          "ZOHO_ORDER_POLICY_REFERENCE_STALE": "One selected Zoho value is stale. Refresh master data and choose an active value.",
          "ZOHO_ORDER_POLICY_VOID_ORDER_UNSUPPORTED": "This void action cannot be completed for this policy.",
          "ZOHO_MASTER_DATA_REFRESH_FAILED": "Zoho master data refresh failed. Try again.",
          "ZOHO_MASTER_DATA_CATEGORY_INVALID": "Choose a supported Zoho master data category.",
          "INVENTORY_CONNECTION_NOT_CONFIGURED": "Zoho is not connected yet.",
          "INVENTORY_CONNECTION_NOT_FOUND": "We could not find this Zoho connection.",
          "INVENTORY_PROVIDER_UNSUPPORTED": "This inventory provider is not supported for this action.",
          "INVENTORY_NOT_CONFIGURED": "Zoho is not connected yet.",
          "INVENTORY_AUTH_EXPIRED": "Zoho authorization expired. Reconnect Zoho and try again.",
          "INVENTORY_PULL_FAILED": "Zoho master data refresh failed. Try again."
        }
      }
    },
    "zidOAuth": {
      "submitting": {
        "title": "Finishing the Zid connection",
        "body": "We are exchanging the authorization code with Zid. This usually takes a few seconds."
      },
      "error": {
        "title": "We could not finish connecting Zid",
        "back": "Back to channels"
      },
      "errors": {
        "codes": {
          "REQUEST_FAILED": "We could not finish the Zid connection. Try again later.",
          "UNAUTHORIZED": "Your session expired. Sign in again to finish connecting Zid.",
          "CHANNEL_OAUTH_STATE_INVALID": "This connect link expired or was already used. Start a new connect flow from Channels.",
          "CHANNEL_OAUTH_CALLBACK_FAILED": "Zid rejected the connection. Try connecting again.",
          "CHANNEL_CONNECTION_NOT_FOUND": "We could not find the channel connection that started this flow.",
          "CHANNEL_AUTH_EXPIRED": "Zid authorization expired. Start a new connect flow.",
          "CHANNEL_EXTERNAL_ACCOUNT_CONFLICT": "This Tlaaq organization is already connected to a different Zid store.",
          "CHANNEL_ONBOARDING_JOB_NOT_FOUND": "We are still creating the import job. Keep this page open for a moment.",
          "CHANNEL_ONBOARDING_INCOMPLETE": "The import job is not ready to retry yet.",
          "CHANNEL_ONBOARDING_SCHEDULE_FAILED": "We could not schedule the import job. Try retrying from this page."
        }
      },
      "chain": {
        "backToZid": "Back to Zid",
        "installed": "Installed",
        "redirectedFrom": "Redirected from",
        "fillDetails": "Fill details",
        "configured": "Configured",
        "redirecting": "Redirecting",
        "next": "Next",
        "zidApps": "Zid Apps"
      },
      "demo": {
        "store": "Layali Home"
      },
      "form": {
        "fromZid": "From Zid",
        "eyebrow": "Zid OAuth",
        "title": "Finish connecting your Zid store",
        "description": "We pulled what Zid already shared. Confirm the workspace details and choose how inventory should be managed.",
        "connectedAs": "Connected as",
        "merchantId": "merchant ID",
        "workspaceName": "Workspace name",
        "ownerEmail": "Owner email",
        "phone": "Phone",
        "phonePlaceholder": "+966 5x xxx xxxx",
        "source": "Inventory source",
        "useTlaaq": "Use Tlaaq inventory",
        "simplest": "Simplest setup",
        "connectZoho": "Connect Zoho later",
        "fromSettings": "Available in Settings",
        "consent": "I allow Tlaaq to sync products, orders, and stock with Zid.",
        "readScopes": "Read scopes: products, orders, store profile",
        "finish": "Finish setup",
        "footer": "You can disconnect Zid anytime from Channels."
      },
      "success": {
        "title": "Zid is connected",
        "bodyShort": "Your Zid store is now linked to Tlaaq. You can manage it from Channels.",
        "bodyPrefix": "We are creating the workspace for",
        "bodySuffix": "and preparing the first sync.",
        "whatHappened": "What happened",
        "channelConnected": "Channel connected",
        "subscription": "Subscription detected",
        "workspacePrefix": "Workspace",
        "workspaceSuffix": "created",
        "seconds": "Redirecting to Tlaaq in a few seconds.",
        "back": "Back to dashboard"
      },
      "import": {
        "title": "First import from Zid",
        "subtitle": "Tlaaq is importing products, stock, and recent orders in the background.",
        "queuedTitle": "Import is being prepared",
        "queuedBody": "The connection is complete. We are waiting for the import job to appear and will update this screen automatically.",
        "products": "Products and stock",
        "orders": "Recent orders",
        "retry": "Retry import",
        "retrying": "Retrying…",
        "refreshFailed": "We could not refresh import progress. We will keep trying.",
        "issueCount": "{{count}} products need review after import.",
        "status": {
          "QUEUED": "Queued",
          "RUNNING": "Running",
          "COMPLETED": "Completed",
          "COMPLETED_WITH_ISSUES": "Completed with issues",
          "FAILED": "Failed"
        },
        "stepStatus": {
          "PENDING": "Pending",
          "RUNNING": "Running",
          "SUCCEEDED": "Done",
          "SUCCEEDED_WITH_ISSUES": "Done with issues",
          "FAILED": "Failed",
          "SKIPPED": "Skipped"
        },
        "counters": {
          "products": "Products",
          "stock": "Stock rows",
          "orders": "Orders"
        }
      },
      "footer": {
        "cancel": "Cancel",
        "security": "Secure OAuth handoff from Zid."
      }
    },
    "sallaInvitation": {
      "eyebrow": "Salla · Store connection",
      "continue": { "title": "Connect your Salla store", "body": "Create an account or log in to review this invitation. You’ll confirm the store and organization before anything is linked." },
      "confirm": { "title": "Confirm your connection", "body": "Review the verified Salla store and the organization that will receive this connection." },
      "loading": { "title": "Checking your invitation", "body": "We are checking the invitation before showing your store details." },
      "invalid": { "title": "This link is no longer valid", "body": "The invitation may have expired or already been used. Contact support for help with your invitation." },
      "nonowner": { "title": "An owner needs to confirm", "body": "Your current account cannot connect a store to this organization. Continue with an organization owner account." },
      "conflict": { "title": "This store is already connected", "body": "This store or organization already has a different connection. Contact support to resolve it. No connection has been transferred." },
      "unavailable": { "title": "We could not check your invitation", "body": "Try again to check its current status. No connection will be made without your confirmation." },
      "store": "Verified Salla store",
      "organization": "Destination organization · You are the owner",
      "register": "Create an account",
      "login": "Log in",
      "confirmAction": "Confirm connection",
      "confirming": "Connecting…",
      "cancel": "Cancel",
      "back": "Back to Tlaaq",
      "switchAccount": "Use another account",
      "support": "Contact support",
      "retry": "Try again",
      "importHint": "After confirmation, Tlaaq imports products and stock, then recent orders. You can follow progress before opening Channels.",
      "authHint": "Your invitation stays with you through sign-in. After an owner confirms, you can follow the first import.",
      "privacyHint": "For your security, store details are not shown here."
    },
    "sallaOAuth": {
      "submitting": {
        "title": "Finishing the Salla connection",
        "body": "We are exchanging the authorization code with Salla. This usually takes a few seconds."
      },
      "error": {
        "title": "We could not finish connecting Salla",
        "back": "Back to channels"
      },
      "errors": {
        "codes": {
          "REQUEST_FAILED": "We could not finish the Salla connection. Try again later.",
          "UNAUTHORIZED": "Your session expired. Sign in again to finish connecting Salla.",
          "CHANNEL_OAUTH_STATE_INVALID": "This connect link expired or was already used. Start a new connect flow from Channels.",
          "CHANNEL_OAUTH_CALLBACK_FAILED": "Salla rejected the connection. Try connecting again.",
          "CHANNEL_CONNECTION_NOT_FOUND": "We could not find the channel connection that started this flow.",
          "CHANNEL_CONNECT_FAILED": "We could not start the Salla connection. Try again from Channels.",
          "CHANNEL_AUTH_EXPIRED": "Salla authorization expired. Start a new connect flow.",
          "CHANNEL_EXTERNAL_ACCOUNT_CONFLICT": "This Salla store is already connected to another Tlaaq organization.",
          "CHANNEL_ONBOARDING_JOB_NOT_FOUND": "We are still creating the import job. Keep this page open for a moment.",
          "CHANNEL_ONBOARDING_INCOMPLETE": "The import job is not ready to retry yet.",
          "CHANNEL_ONBOARDING_SCHEDULE_FAILED": "We could not schedule the import job. Try retrying from this page."
        }
      },
      "success": {
        "title": "Salla is connected",
        "bodyShort": "Your store is linked. Follow the first import below, or continue to Channels.",
        "back": "Go to Channels"
      },
      "import": {
        "title": "First import from Salla",
        "subtitle": "Products and stock are imported first, followed by recent orders.",
        "queuedTitle": "Import is being prepared",
        "queuedBody": "The connection is complete. We are waiting for the import job to appear and will update this screen automatically.",
        "products": "Products and stock",
        "orders": "Recent orders",
        "retry": "Retry import",
        "retrying": "Retrying…",
        "refreshFailed": "We could not refresh import progress. We will keep trying.",
        "issueCount": "{{count}} products need review after import.",
        "errors": {
          "CHANNEL_APP_SUBSCRIPTION_INACTIVE": "Your store is connected, but Tlaaq could not confirm an active Salla app subscription, so the import cannot proceed yet. Please check your Salla subscription and try again.",
          "generic": "The import could not continue. Try again, or contact support if the problem continues."
        },
        "status": {
          "QUEUED": "Queued",
          "RUNNING": "Running",
          "COMPLETED": "Completed",
          "COMPLETED_WITH_ISSUES": "Completed with issues",
          "FAILED": "Failed"
        },
        "stepStatus": {
          "PENDING": "Pending",
          "RUNNING": "Running",
          "SUCCEEDED": "Done",
          "SUCCEEDED_WITH_ISSUES": "Done with issues",
          "FAILED": "Failed",
          "SKIPPED": "Skipped"
        },
        "counters": {
          "products": "Products",
          "stock": "Stock rows",
          "orders": "Orders"
        }
      },
      "footer": {
        "security": "Secure OAuth handoff from Salla."
      }
    },
    "amazonOAuth": {
      "submitting": {
        "title": "Finishing the Amazon connection",
        "body": "We are exchanging the SP-API authorization code with Amazon. This usually takes a few seconds."
      },
      "error": {
        "title": "We could not finish connecting Amazon",
        "back": "Back to channels"
      },
      "errors": {
        "codes": {
          "REQUEST_FAILED": "We could not finish the Amazon connection. Try again later.",
          "UNAUTHORIZED": "Your session expired. Sign in again to finish connecting Amazon.",
          "CHANNEL_PROVIDER_UNSUPPORTED": "Amazon beta access is not enabled for this workspace or seller.",
          "CHANNEL_OAUTH_STATE_INVALID": "This connect link expired or was already used. Start a new connect flow from Channels.",
          "CHANNEL_OAUTH_CALLBACK_FAILED": "Amazon rejected the connection. Try connecting again.",
          "CHANNEL_CONNECTION_NOT_FOUND": "We could not find the channel connection that started this flow.",
          "CHANNEL_CONNECT_FAILED": "We could not start the Amazon connection. Try again from Channels.",
          "CHANNEL_AUTH_EXPIRED": "Amazon authorization expired. Start a new connect flow.",
          "CHANNEL_EXTERNAL_ACCOUNT_CONFLICT": "This Amazon seller account is already connected to another Tlaaq organization.",
          "CHANNEL_ONBOARDING_JOB_NOT_FOUND": "We are still creating the import job. Keep this page open for a moment.",
          "CHANNEL_ONBOARDING_INCOMPLETE": "The import job is not ready to retry yet.",
          "CHANNEL_ONBOARDING_SCHEDULE_FAILED": "We could not schedule the import job. Try retrying from this page."
        }
      },
      "success": {
        "title": "Amazon is connected",
        "bodyShort": "Your Amazon seller account is now linked to Tlaaq. You can manage it from Channels.",
        "back": "Back to dashboard"
      },
      "import": {
        "title": "First Amazon import",
        "subtitle": "Tlaaq is importing listings and recent order headers in the background.",
        "queuedTitle": "Import is being prepared",
        "queuedBody": "The connection is complete. We are waiting for the import job to appear and will update this screen automatically.",
        "products": "Products and listings",
        "orders": "Recent orders",
        "retry": "Retry import",
        "retrying": "Retrying…",
        "refreshFailed": "We could not refresh import progress. We will keep trying.",
        "issueCount": "{{count}} products need review after import.",
        "status": {
          "QUEUED": "Queued",
          "RUNNING": "Running",
          "COMPLETED": "Completed",
          "COMPLETED_WITH_ISSUES": "Completed with issues",
          "FAILED": "Failed"
        },
        "stepStatus": {
          "PENDING": "Pending",
          "RUNNING": "Running",
          "SUCCEEDED": "Done",
          "SUCCEEDED_WITH_ISSUES": "Done with issues",
          "FAILED": "Failed",
          "SKIPPED": "Skipped"
        },
        "counters": {
          "products": "Listings",
          "orders": "Orders"
        }
      },
      "footer": {
        "security": "Secure SP-API OAuth handoff from Amazon."
      }
    },
    "sallaEmail": {
      "tabs": {
        "welcome": "Welcome",
        "reminder": "Reminder",
        "report": "Report"
      },
      "meta": {
        "welcome": {
          "subject": "🎉 Tlaaq is wired up — let's connect your other stores",
          "when": "Sent immediately on install"
        },
        "reminder": {
          "subject": "Your Salla store is live on Tlaaq, but it's lonely",
          "when": "Sent 48h after install if no other channels"
        },
        "report": {
          "subject": "Week one on Tlaaq: 247 orders, zero oversells",
          "when": "Sent 7 days after first sync"
        }
      },
      "previewMode": "Preview mode",
      "from": "From: {{email}}",
      "common": {
        "hiSara": "Hi Sara",
        "hiSaraPlain": "Hi Sara"
      },
      "actions": {
        "connect": "Connect →",
        "connectPlain": "Connect",
        "openTlaaq": "Open Tlaaq",
        "openOneClick": "Open Tlaaq · 1 click connect →",
        "fullReport": "See the full report →"
      },
      "channels": {
        "noonDesc": "Saudi Arabia · noon.com",
        "amazonDesc": "Saudi marketplace · amazon.sa",
        "zidDesc": "Saudi storefront · zid.sa",
        "trendyolDesc": "Saudi marketplace · trendyol.com"
      },
      "welcome": {
        "heroLine1": "Salla is wired up.",
        "heroLine2": "Let's add your other stores.",
        "heroBodyPrefix": "Tlaaq just finished syncing your Salla catalog.",
        "imported": "1,847 products imported",
        "heroBodySuffix": "and stock is now under our watch.",
        "next2Minutes": "Next 2 minutes",
        "connectSecondChannel": "Connect a second channel — one click each",
        "openWorkspace": "Open your Tlaaq workspace",
        "workspaceHint": "Pre-signed link · valid for 7 days · no password to set",
        "whatWeDid": "What we just did for you",
        "checks": {
          "imported": "Imported 1,847 products from Salla",
          "mapped": "Mapped all SKUs · auto-matched 100% on first pass",
          "watching": "Started watching Salla stock for changes",
          "bundled": "Bundled Tlaaq into your Salla bill — no extra invoice"
        }
      },
      "footer": {
        "help": "Need help connecting another store?",
        "reply": "Reply to this email",
        "walkthrough": "or book a 15-min walkthrough.",
        "riyadh": "Riyadh",
        "unsubscribe": "Unsubscribe"
      },
      "reminder": {
        "title": "Your Salla store is live on Tlaaq. But it's the only one.",
        "bodyPrefix": "Tlaaq's whole point is keeping your stock in sync across",
        "multiple": "multiple",
        "bodySuffix": "channels. Right now you've only connected Salla.",
        "pickChannel": "Pick the channel that bleeds the most cancellations:",
        "amazonDesc": "Highest oversell penalty",
        "noonDesc": "Fastest growing in KSA",
        "zidDesc": "If you have a second storefront",
        "trendyolDesc": "Strong in fashion & home",
        "headsUp": "Heads up:",
        "headsUpBody": "if you don't connect a second channel within 14 days, your Salla bundle continues but Tlaaq won't really earn its keep.",
        "tellUsWhy": "Tell us why",
        "improve": "that helps us improve.",
        "reason": "You are getting this because you installed Tlaaq from Salla 48 hours ago."
      },
      "report": {
        "title": "Week one: 247 orders, zero oversells.",
        "body": "Hi Sara, here's what Tlaaq did for you across Salla, Noon, and Amazon since Monday.",
        "stats": {
          "orders": "orders synced",
          "stock": "stock updates pushed",
          "oversells": "overselling incidents"
        },
        "byChannel": "By channel",
        "schedule": "Sent every Monday at 9 AM KSA.",
        "switchMonthly": "Switch to monthly"
      },
      "trigger": {
        "prefix": "Triggered by Salla webhook",
        "suffix": "No browser redirect; merchant stays on Salla"
      }
    },
    "productForm": {
      "createTitle": "Create product",
      "editTitle": "Edit product",
      "subtitle": "Save the master SKU, pricing, tax, weight, and image keys used by future channel sync.",
      "loading": "Loading product…",
      "sections": {
        "master": "Master data",
        "images": "Images"
      },
      "fields": {
        "sku": "SKU",
        "name": "Name",
        "description": "Description",
        "descriptionPlaceholder": "Describe the product for your internal catalog.",
        "status": "Status",
        "price": "Price",
        "cost": "Cost",
        "salePrice": "Sale price",
        "weightGrams": "Weight",
        "taxRate": "Tax rate"
      },
      "units": {
        "sar": "SAR",
        "grams": "g",
        "percent": "%"
      },
      "actions": {
        "cancel": "Cancel",
        "create": "Create product",
        "save": "Save changes",
        "saving": "Saving…"
      },
      "validation": {
        "required": "SKU and name are required.",
        "altSkuUnique": "Each SKU must be unique."
      },
      "altSkus": {
        "title": "Additional SKUs",
        "add": "Add another SKU",
        "remove": "Remove",
        "placeholder": "Alias SKU used by another channel"
      },
      "images": {
        "dropTitle": "Drag images here",
        "helper": "JPEG, PNG, or WebP up to 5 MB. Uploads go directly to storage.",
        "fileInput": "Upload product images",
        "chooseFiles": "Choose files",
        "uploading": "Uploading…",
        "empty": "No images uploaded yet.",
        "altText": "Alt text",
        "primary": "Primary",
        "setPrimary": "Set primary",
        "moveUp": "Move up",
        "moveDown": "Move down",
        "remove": "Remove",
        "errors": {
          "PRODUCT_IMAGE_TYPE_UNSUPPORTED": "Use a JPEG, PNG, or WebP image.",
          "PRODUCT_IMAGE_TOO_LARGE": "The image is larger than 5 MB.",
          "uploadFailed": "The image upload failed. Please try again."
        }
      }
    },
    "zohoOAuth": {
      "submitting": {
        "title": "Connecting Zoho Inventory",
        "body": "We are validating the Zoho authorization code and storing encrypted credentials."
      },
      "success": {
        "title": "Zoho Inventory connected",
        "body": "Tlaaq can now pull products, warehouses, and stock from Zoho and send sales orders or invoices.",
        "back": "Back to Zoho setup"
      },
      "error": {
        "title": "Zoho connection failed",
        "back": "Back to Zoho setup"
      },
      "footer": {
        "security": "OAuth tokens are encrypted at rest and never shown in the browser."
      },
      "errors": {
        "codes": {
          "REQUEST_FAILED": "The Zoho callback could not be completed. Try connecting again.",
          "INVENTORY_OAUTH_CALLBACK_FAILED": "Zoho rejected the callback or returned an incomplete response.",
          "INVENTORY_OAUTH_STATE_INVALID": "The Zoho connection session expired. Start the connection again.",
          "INVENTORY_CONNECT_FAILED": "Could not connect to Zoho. Check OAuth client settings.",
          "INVENTORY_EXTERNAL_ACCOUNT_CONFLICT": "This Tlaaq connection is already linked to a different Zoho organization."
        }
      }
    },
    "inventoryZohoPullRunDetail": {
      "back": "Back to Zoho",
      "title": "Zoho pull details",
      "subtitle": "Review item-level issues, skipped rows, and run-level failures from this product pull.",
      "runId": "Run #{{id}}",
      "loading": "Loading pull details…",
      "notAvailable": "—",
      "missing": {
        "title": "Choose a pull run first",
        "body": "Open Zoho Inventory and choose View pull details from a completed or failed product pull."
      },
      "stats": {
        "fetched": "Fetched",
        "products": "Products changed",
        "skipped": "Skipped rows",
        "issues": "Issues",
        "pages": "Pages: {{count}}",
        "productsBody": "{{created}} created · {{updated}} updated",
        "skippedBody": "{{products}} products · {{stock}} stock rows",
        "updated": "Last updated {{date}}"
      },
      "groups": {
        "title": "Issue reasons",
        "subtitle": "Grouped across the whole run. Select a reason to filter the rows below.",
        "allReasons": "All reasons",
        "reasonFilter": "{{reason}} ({{count}})",
        "empty": "No item-level reasons were captured for this run.",
        "sample": "Sample SKU {{sku}} · item {{external}}",
        "count": "Items: {{count}}"
      },
      "items": {
        "title": "Issue rows",
        "subtitle": "Rows are ordered by pull page and issue order from the Zoho result.",
        "searchPlaceholder": "Search SKU or Zoho item ID…",
        "search": "Search"
      },
      "table": {
        "reason": "Reason",
        "sku": "SKU",
        "externalProductId": "Zoho item ID",
        "page": "Page",
        "row": "Row"
      },
      "pagination": {
        "range": "Showing {{start}}–{{end}} of {{total}}",
        "page": "Page {{page}} of {{totalPages}}",
        "previous": "Previous",
        "next": "Next"
      },
      "empty": {
        "historicalTitle": "Details were not captured for this run",
        "historicalBody": "This older run has skipped or issue counters, but item-level capture was not available when it ran.",
        "cleanTitle": "No item-level issues",
        "cleanBody": "This run completed without captured issue rows.",
        "filteredTitle": "No matching issue rows",
        "filteredBody": "Change the reason filter or search term to see more rows.",
        "failedNoItemsTitle": "No item-level issues were captured",
        "failedNoItemsBody": "This run stopped before Zoho returned item rows with issue details. Use the failure guidance above, then start a new pull after the problem is fixed."
      },
      "errors": {
        "REQUEST_FAILED": "We could not load pull details. Please try again.",
        "UNAUTHORIZED": "Your session expired. Sign in again to view pull details.",
        "INVENTORY_CONNECTION_NOT_FOUND": "This Zoho connection was not found."
      },
      "issueCodes": {
        "INVALID_SKU": {
          "title": "Invalid SKU",
          "action": "Fix the SKU in Zoho so it normalizes to a valid Tlaaq SKU, then rerun the pull."
        },
        "MISSING_SKU": {
          "title": "Missing SKU",
          "action": "Add a SKU to the Zoho item before importing it into Tlaaq."
        },
        "MISSING_EXTERNAL_ITEM_ID": {
          "title": "Missing Zoho item ID",
          "action": "The Zoho item did not include a stable item ID. Refresh the source item and rerun the pull."
        },
        "DUPLICATE_PROVIDER_SKU": {
          "title": "Duplicate provider SKU",
          "action": "Two or more Zoho items share the same SKU. Make each SKU unique before importing."
        },
        "PRODUCT_UNMAPPED_LISTINGS_ONLY": {
          "title": "No matching product in listings-only mode",
          "action": "This run was configured to map existing products only. Create or import the product, then rerun."
        },
        "PRODUCT_MAPPING_CONFLICT": {
          "title": "Product mapping conflict",
          "action": "This Zoho item is already mapped to another product. Review the existing mapping before rerunning."
        },
        "PRODUCT_MAPPING_PRIMARY_SKU_CONFLICT": {
          "title": "Primary SKU mapping conflict",
          "action": "This Zoho item is mapped to a product with a different primary SKU. Review the mapping before rerunning."
        },
        "SKU_CONFLICT": {
          "title": "SKU already belongs to another product",
          "action": "Change the SKU or merge the local product records before rerunning the pull."
        },
        "ZOHO_IMAGE_NOT_FOUND": {
          "title": "Zoho image not found",
          "action": "Zoho returned an image link that no longer exists. Update the image in Zoho if it is still needed."
        },
        "ZOHO_IMAGE_NOT_ACCEPTABLE": {
          "title": "Zoho image not downloadable",
          "action": "Zoho rejected the image download. Replace the image in Zoho or import it manually in Tlaaq."
        },
        "PRODUCT_IMAGE_TOO_LARGE": {
          "title": "Product image too large",
          "action": "Use a smaller product image in Zoho or upload a compressed image in Tlaaq."
        },
        "ZOHO_IMAGE_EMPTY": {
          "title": "Empty Zoho image",
          "action": "Zoho returned an empty image file. Replace the image in Zoho and rerun the pull."
        },
        "STOCK_PRODUCT_UNMAPPED": {
          "title": "Stock product not mapped",
          "action": "Tlaaq could not import stock because the Zoho item is not mapped to a local product."
        },
        "DUPLICATE_PROVIDER_SKU_STOCK_SKIPPED": {
          "title": "Stock skipped for duplicate SKU",
          "action": "Resolve duplicate Zoho SKUs before importing stock for this item."
        },
        "DUPLICATE_PRODUCT_STOCK_SKIPPED": {
          "title": "Stock skipped for ambiguous product",
          "action": "Multiple local products matched this SKU. Resolve the product match before importing stock."
        },
        "MISSING_STOCK_LOCATION": {
          "title": "Missing stock location",
          "action": "A stock row did not include a Zoho location. Add the location in Zoho before rerunning."
        },
        "DUPLICATE_STOCK_LOCATION_SKIPPED": {
          "title": "Duplicate stock location skipped",
          "action": "Zoho sent more than one stock row for the same location. Keep one row per location."
        },
        "INFINITE_STOCK_UNSUPPORTED": {
          "title": "Infinite stock unsupported",
          "action": "Tlaaq imports finite quantities only. Replace unlimited stock with a quantity in Zoho."
        },
        "MISSING_STOCK_QUANTITY": {
          "title": "Missing stock quantity",
          "action": "Add an on-hand quantity to the Zoho stock row before importing it."
        },
        "NEGATIVE_STOCK_CLAMPED": {
          "title": "Negative stock clamped",
          "action": "Tlaaq imported the stock row but clamped negative quantities to zero."
        },
        "INVALID_ADDITIONAL_SKU": {
          "title": "Invalid additional SKU",
          "action": "Clean up the additional SKU value in Zoho before importing aliases."
        },
        "ADDITIONAL_SKU_PRODUCT_CONFLICT": {
          "title": "Additional SKU conflicts with a product",
          "action": "This alias already belongs to another product. Remove the conflict before rerunning."
        },
        "ADDITIONAL_SKU_AMBIGUOUS": {
          "title": "Additional SKU is ambiguous",
          "action": "More than one local product matched an additional SKU. Resolve the duplicate alias first."
        },
        "ADDITIONAL_SKU_CONFLICT": {
          "title": "Additional SKU conflict",
          "action": "Tlaaq could not save this additional SKU. Review existing aliases and rerun."
        },
        "UNKNOWN": {
          "title": "Unknown issue",
          "action": "Review the Zoho item and retry the pull. If this continues, contact support with the reason code."
        }
      },
      "failureCodes": {
        "INVENTORY_CONNECTION_NOT_FOUND": {
          "title": "Zoho connection was not found",
          "action": "Return to Inventory and reconnect Zoho before running another pull."
        },
        "INVENTORY_CONNECTION_NOT_CONFIGURED": {
          "title": "Zoho connection is not configured",
          "action": "Complete Zoho authorization before running the product pull again."
        },
        "INVENTORY_AUTH_EXPIRED": {
          "title": "Zoho authorization expired",
          "action": "Reauthorize Zoho, then start a new product and stock pull."
        },
        "INVENTORY_PRODUCT_PULL_SOURCE_MISMATCH": {
          "title": "Product source mismatch",
          "action": "Set Zoho as the product catalog source or choose a pull mode that matches the current source."
        },
        "INVENTORY_STOCK_PULL_SOURCE_MISMATCH": {
          "title": "Stock source mismatch",
          "action": "Set Zoho as the stock source before importing Zoho stock snapshots."
        },
        "INVENTORY_PULL_FAILED": {
          "title": "Zoho pull failed",
          "action": "Zoho did not complete the pull. Retry later, and check Zoho status if the failure repeats."
        },
        "INVENTORY_RATE_LIMITED": {
          "title": "Zoho rate limited the pull",
          "action": "Tlaaq will retry rate-limited pulls automatically. Start a new pull only after the retry window passes."
        },
        "INVENTORY_ADAPTER_NOT_REGISTERED": {
          "title": "Zoho adapter unavailable",
          "action": "The Zoho integration is not available in this environment. Contact support."
        },
        "INVENTORY_PROVIDER_UNSUPPORTED": {
          "title": "Inventory provider unsupported",
          "action": "This run references a provider that Tlaaq cannot pull inventory from."
        },
        "REQUEST_FAILED": {
          "title": "Could not load pull details",
          "action": "Refresh the page or try again in a few minutes."
        },
        "UNAUTHORIZED": {
          "title": "Session expired",
          "action": "Sign in again to view this pull run."
        },
        "UNKNOWN": {
          "title": "Pull failed",
          "action": "Review the error code and retry the pull. If it repeats, contact support.",
          "code": "UNKNOWN_ERROR"
        }
      }
    }
  },
  "stockAllocation": {
    "title": "Stock allocation rules",
    "description": "Choose which Tlaaq warehouses feed each connected Zid, Salla, or Noon FBPI store, how much of those warehouses should be published, and which products automation should skip. Manual product stock push stays available from Product Detail.",
    "workspaceTitle": "Stock allocation",
    "workspaceDescription": "Manage allocation rules and review every automated stock update.",
    "tabs": {
      "label": "Stock allocation sections",
      "rules": "Rules",
      "activity": "Activity"
    },
    "loading": "Loading stock allocation rules…",
    "emptyWarehouses": "No warehouses selected",
    "emptyPercent": "not set",
    "unknownWarehouse": "Warehouse #{{id}}",
    "noWarehouses": "No warehouses exist yet. Create warehouses before enabling allocation automation.",
    "summary": "Current draft: {{percent}}% from {{warehouses}}.",
    "saved": "Stock allocation rule saved for {{name}}.",
    "status": {
      "enabled": "Enabled",
      "disabled": "Disabled"
    },
    "actions": {
      "back": "Back to channels",
      "saveFor": "Save {{name}}",
      "saving": "Saving…"
    },
    "fields": {
      "enabled": "Automation",
      "enabledAria": "Toggle allocation for {{name}}",
      "percent": "Allocation percent",
      "percentAria": "Allocation percent for {{name}}",
      "percentSuffix": "%",
      "percentHint": "Tlaaq pushes floor(selected warehouse availability × this percentage).",
      "targetSallaBranch": "Target Salla branch",
      "targetSallaBranchAria": "Target Salla branch for {{name}}",
      "targetSallaBranchPlaceholder": "Choose a branch",
      "targetSallaBranchHint": "Choose a branch observed on Salla listings to receive stock from the selected Tlaaq warehouses. Allocation does not require an internal location mapping.",
      "targetSallaBranchEmpty": "No branches observed for this store. Fetch or refresh Salla listing stock, then reload this page.",
      "targetSallaBranchUnavailable": "Previously selected branch is unavailable — choose another branch",
      "warehouses": "Warehouses"
    },
    "availability": {
      "ready": "This connected channel can receive allocated stock from Tlaaq.",
      "noonReady": "Allocation sends all active local product SKUs to the FBPI warehouse configured in Noon channel settings. SKUs must match Noon partner SKUs. FBN warehouses are not supported.",
      "unsupported": "{{provider}} stock allocation is not supported yet. Supported providers are Zid, Salla, and Noon FBPI.",
      "disconnected": "Connect this channel before enabling stock allocation. Current status: {{status}}.",
      "sourceOwned": "This channel owns stock, so Tlaaq will not push stock back to it. Switch stock source to Tlaaq before enabling allocation."
    },
    "overAllocation": {
      "title": "Warehouse allocation is over 100%",
      "body": "These warehouses exceed the per-warehouse cap: {{warehouses}}. Adjust percentages before relying on automation.",
      "warehouseTotal": "Total selected allocation: {{total}}%",
      "selectedWarning": "One or more selected warehouses is over the 100% cap."
    },
    "exclusions": {
      "title": "Excluded products",
      "hint": "Automation will skip these channel-listed products. Manual stock push from Product Detail still works.",
      "noonHint": "Automation will skip these local products for this Noon connection. Manual stock push from Product Detail still works.",
      "noonSearchLabel": "Search local products",
      "noonNoResults": "No local products match this search.",
      "empty": "No products excluded from this channel yet.",
      "unknownProduct": "Product #{{id}}",
      "unknownSku": "SKU unavailable",
      "searchLabel": "Search channel products",
      "searchAria": "Search products to exclude for {{name}}",
      "searchPlaceholder": "Search by product name or SKU",
      "search": "Search",
      "searching": "Searching…",
      "searchError": "We could not search products for this channel. Please try again.",
      "noResults": "No channel-listed products match this search.",
      "add": "Add",
      "addAria": "Add {{name}} to excluded products",
      "selected": "Selected",
      "selectedAria": "{{name}} already selected for exclusion",
      "remove": "Remove",
      "removeAria": "Remove {{name}} from excluded products"
    },
    "empty": {
      "title": "No channel connections yet",
      "body": "Create and connect a Zid, Salla, or Noon FBPI channel before configuring stock allocation."
    },
    "activity": {
      "loading": "Loading stock allocation activity…",
      "error": "We could not load stock allocation activity.",
      "tryAgain": "Try again",
      "runLabel": "Sync run",
      "partialTitle": "Partially submitted to {{provider}}",
      "failedTitle": "Stock sync to {{provider}} failed",
      "successTitle": "Stock submitted to {{provider}}",
      "progress": "{{percent}}% submitted successfully. Accepted requests do not confirm remote stock. Fix rejected products, then retry only those items.",
      "download": "Download report",
      "retry": "Retry failed products",
      "retrying": "Retrying…",
      "retryAccepted": "Retry run #{{id}} completed. Its results are now selected.",
      "retryFailed": "The failed products could not be retried. Check the channel connection and try again.",
      "downloadFailed": "The report could not be downloaded. Try again.",
      "status": { "RUNNING": "Running", "SUCCEEDED": "Request accepted", "PARTIAL_FAILURE": "Needs attention", "FAILED": "Failed" },
      "trigger": { "RULE_SAVED": "Rule saved", "STOCK_UPDATED": "Stock updated", "CHANNEL_ORDER_STOCK_CHANGED": "Channel order changed stock", "INVENTORY_IMPORT": "Inventory import", "ZOHO_ORDER_STOCK_RECONCILIATION": "Zoho order reconciliation", "FAILED_ITEMS_RETRY": "Failed-products retry" },
      "metrics": { "attempted": "Attempted", "pushed": "Submitted", "failed": "Need attention", "skipped": "Skipped" },
      "empty": { "title": "No stock sync activity yet", "body": "Runs will appear here after an enabled allocation rule publishes stock." },
      "items": {
        "title": "Products that need attention", "count": "{{count}} failed product", "count_plural": "{{count}} failed products", "search": "Search by product or SKU", "reason": "Reason", "allReasons": "All reasons", "product": "Product", "sku": "SKU", "quantity": "Requested quantity", "action": "Action", "viewProduct": "View product", "noMatches": "No failed products match these filters.", "previous": "Previous", "next": "Next", "page": "Page {{page}} of {{pages}}"
      },
      "reasons": { "SKU_NOT_FOUND": "Not found on the connected channel", "PROVIDER_ERROR": "Provider rejected this update", "UNEXPECTED_ERROR": "Unexpected provider response", "UNKNOWN": "Unknown provider response" }
    },
    "errors": {
      "codes": {
        "NOON_FBPI_WAREHOUSE_REQUIRED": "Configure the FBPI warehouse in Noon channel settings before enabling allocation.",
        "REQUEST_FAILED": "We could not update stock allocation rules. Please try again.",
        "UNAUTHORIZED": "Your session expired. Sign in again to manage stock allocation.",
        "CHANNEL_STOCK_ALLOCATION_UNAVAILABLE": "This channel cannot be enabled for stock allocation.",
        "CHANNEL_STOCK_ALLOCATION_PERCENT_INVALID": "Enter an allocation percent from 0 to 100.",
        "CHANNEL_STOCK_ALLOCATION_WAREHOUSES_REQUIRED": "Choose at least one warehouse before enabling allocation.",
        "CHANNEL_STOCK_ALLOCATION_TARGET_LOCATION_REQUIRED": "Choose the target Salla branch before enabling allocation.",
        "CHANNEL_STOCK_ALLOCATION_CAP_EXCEEDED": "One warehouse is allocated above 100%. Reduce another rule or this percentage before saving.",
        "CHANNEL_STOCK_ALLOCATION_EXCLUDED_PRODUCT_NOT_FOUND": "One excluded product was not found. Remove it and search again before saving.",
        "CHANNEL_STOCK_ALLOCATION_EXCLUDED_PRODUCT_NOT_LISTED": "One excluded product is no longer listed on this channel. Remove it and search again before saving.",
        "CHANNEL_CONNECTION_NOT_FOUND": "This channel connection was not found.",
        "CHANNEL_AUTH_EXPIRED": "Channel authorization expired. Reconnect the channel to continue.",
        "CHANNEL_STOCK_PUSH_SOURCE_CONNECTION": "This channel owns stock, so Tlaaq cannot push stock back to it.",
        "CHANNEL_STOCK_PUSH_UNSUPPORTED": "Stock push is not supported for this provider yet."
      }
    }
  },
  "admin": {
    "common": {
      "actions": "Actions",
      "refresh": "Refresh",
      "retry": "Retry",
      "none": "None",
      "platform": "Platform",
      "allOrganizations": "All organizations"
    },
    "shell": {
      "badge": "Admin"
    },
    "nav": {
      "label": "Admin navigation",
      "home": "Dashboard",
      "organizations": "Organizations",
      "apiCalls": "API calls",
      "scheduledTasks": "Failed tasks",
      "providerProxy": "Provider proxy"
    },
    "meta": {
      "home": {
        "title": "Admin dashboard",
        "subtitle": "Internal support overview across organizations"
      },
      "organizations": {
        "title": "Organizations",
        "subtitle": "Safe directory metadata for support operations"
      },
      "organizationDetail": {
        "title": "Organization detail",
        "subtitle": "Users, connection metadata, provider health, and quotas"
      },
      "apiCalls": {
        "title": "API-call statistics",
        "subtitle": "Outbound provider volume, failures, quotas, and health"
      },
      "stockDiagnostics": {
        "title": "Stock-sync diagnostics",
        "subtitle": "Sanitized provider item results and scheduler context"
      },
      "scheduledTasks": {
        "title": "Failed scheduled tasks",
        "subtitle": "Inspect and retry failed db-scheduler executions"
      },
      "providerProxy": {
        "title": "Provider proxy workbench",
        "subtitle": "Re-issue provider calls through production adapters without exposing credentials"
      }
    },
    "severity": {
      "CRITICAL": "Critical",
      "HIGH": "High",
      "MEDIUM": "Medium",
      "LOW": "Low",
      "WARNING": "Warning"
    },
    "home": {
      "loading": "Loading admin dashboard…",
      "error": {
        "title": "Could not load admin dashboard",
        "body": "The admin summary endpoints did not respond. Retry or check your session."
      },
      "warning": {
        "pill": "Support-only workspace",
        "title": "Cross-tenant tools require care",
        "body": "Admin screens show operational metadata across organizations. Do not browse merchant orders, products, customers, credentials, tokens, or secrets from this workspace.",
        "cta": "Open organizations"
      },
      "stats": {
        "organizations": "Organizations",
        "users": "Users",
        "connections": "Connections",
        "failedTasks": "Failed tasks",
        "apiCalls": "API calls"
      },
      "attention": {
        "title": "Attention queue",
        "subtitle": "Prioritized operational signals from providers, quotas, connections, and scheduled tasks.",
        "emptyTitle": "No attention items",
        "emptyBody": "There are no current admin attention signals.",
        "count": "{{count}} item",
        "count_plural": "{{count}} items"
      },
      "tools": {
        "title": "Admin tools",
        "organizations": "Organizations and users",
        "apiCalls": "API-call statistics",
        "scheduledTasks": "Failed scheduled tasks",
        "providerProxy": "Provider proxy workbench"
      }
    },
    "attention": {
      "title": {
        "SCHEDULED_TASK_FAILED": "Scheduled task failed repeatedly",
        "PROVIDER_HEALTH_NEEDS_ATTENTION": "Provider health needs attention",
        "API_QUOTA_PRESSURE": "Provider API quota pressure",
        "CHANNEL_CONNECTION_NEEDS_ATTENTION": "Channel connection needs attention",
        "INVENTORY_CONNECTION_NEEDS_ATTENTION": "Inventory connection needs attention"
      },
      "detail": {
        "SCHEDULED_TASK_RETRY_AVAILABLE": "A scheduled task has failed several times and can be retried from the failed tasks page.",
        "API_QUOTA_EXCEEDED": "The provider quota has been reached for today.",
        "API_QUOTA_NEAR_LIMIT": "The provider quota is close to today’s limit.",
        "DEGRADED": "Provider health is degraded.",
        "DOWN": "Provider health is down.",
        "AUTH_EXPIRED": "Authorization expired and the connection must be reconnected.",
        "DISCONNECTED": "The provider connection is disconnected.",
        "ERROR": "The provider connection is in an error state."
      }
    },
    "organizations": {
      "loading": "Loading organizations…",
      "error": {
        "title": "Could not load organizations",
        "body": "The organization directory endpoint did not respond."
      },
      "filters": {
        "search": "Search",
        "searchPlaceholder": "Organization name or ID"
      },
      "empty": {
        "title": "No organizations found",
        "body": "No organizations match the current search."
      },
      "connectionSummary": "{{connected}} of {{total}} connected",
      "actions": {
        "open": "Open"
      },
      "table": {
        "organization": "Organization",
        "users": "Users",
        "connections": "Connections",
        "latestActivity": "Latest activity",
        "created": "Created"
      },
      "invitations": {
        "title": "Salla Easy Mode invitations",
        "subtitle": "Recover active invitations without changing their store or organization ownership.",
        "success": "A fresh invitation was sent for merchant #{{merchantId}}. The previous link no longer works.",
        "protectedRecipient": "Cleared after expiry",
        "unclaimed": "Not claimed",
        "empty": {
          "title": "No invitations need attention",
          "body": "Unclaimed Salla Easy Mode invitations will appear here."
        },
        "status": {
          "PENDING": "Pending",
          "EXPIRED": "Expired"
        },
        "table": {
          "store": "Store",
          "recipient": "Verified recipient",
          "organization": "Retained organization",
          "status": "Status",
          "expires": "Expires"
        },
        "actions": {
          "resend": "Resend invitation",
          "recovery": "Recovery steps"
        },
        "dialog": {
          "resendTitle": "Resend this invitation?",
          "resendBody": "Tlaaq will verify the current Salla account, invalidate the old link, and send a fresh link to the verified account email. Store and organization ownership cannot be changed here.",
          "expiredTitle": "Fresh Salla authorization required",
          "expiredBody": "This grant has expired and its sensitive data has been cleared. An admin cannot revive it or transfer the store.",
          "expiredStepOne": "Ask the merchant to authorize or reinstall Tlaaq from Salla.",
          "expiredStepTwo": "Wait for a new pending invitation to appear here.",
          "expiredStepThree": "Never request or paste invitation links, access tokens, or webhook payloads in a support ticket.",
          "confirm": "Verify and resend",
          "sending": "Verifying and sending…",
          "recentlySent": "Recently sent",
          "close": "Close",
          "error": "The invitation could not be resent. Refresh the list and confirm that the Salla authorization is still active."
        }
      }
    },
    "organizationDetail": {
      "loading": "Loading organization detail…",
      "back": "Back to organizations",
      "missing": {
        "title": "Organization not selected",
        "body": "Return to the directory and choose an organization."
      },
      "error": {
        "title": "Could not load organization detail",
        "body": "The admin directory endpoint did not respond for this organization."
      },
      "stats": {
        "users": "Users",
        "channels": "Channels",
        "inventory": "Inventory"
      },
      "users": {
        "title": "Users",
        "emptyTitle": "No users",
        "emptyBody": "This organization has no users.",
        "table": {
          "name": "Name",
          "role": "Role",
          "status": "Status",
          "locale": "Locale",
          "lastLogin": "Last login",
          "created": "Created"
        }
      },
      "channelConnections": {
        "title": "Channel connections",
        "emptyTitle": "No channel connections",
        "emptyBody": "This organization has no channel connections."
      },
      "inventoryConnections": {
        "title": "Inventory connections",
        "emptyTitle": "No inventory connections",
        "emptyBody": "This organization has no inventory connections."
      },
      "connections": {
        "openProxy": "Open proxy",
        "quotaEditor": {
          "label": "Daily {{provider}} limit",
          "save": "Save limit",
          "saving": "Saving…",
          "useDefault": "Use default",
          "error": "The provider quota limit could not be updated. Please try again."
        },
        "table": {
          "connection": "Connection",
          "status": "Status",
          "health": "Health",
          "quota": "Quota",
          "latestActivity": "Latest activity"
        }
      }
    },
    "apiCalls": {
      "loading": "Loading API-call statistics…",
      "error": {
        "title": "Could not load API-call statistics",
        "body": "The metrics endpoint did not respond."
      },
      "filters": {
        "organization": "Organization",
        "provider": "Provider",
        "providerPlaceholder": "ZID, SALLA, ZOHO…",
        "from": "From",
        "to": "To",
        "apply": "Apply filters",
        "retentionHint": "API-call audit data is available for the most recent 90 days.",
        "rangeError": "Choose a date range of 90 days or less within the retained audit history."
      },
      "summary": {
        "auditedAttempts": "Audited attempts",
        "successes": "Successful responses",
        "failures": "Failures",
        "localRejections": "Local rejections",
        "quotaUsage": "Quota calls used"
      },
      "trend": {
        "title": "7-day attempt trend",
        "dayLabel": "{{day}}: {{attempts}} audited attempts",
        "successes": "{{count}} successful responses",
        "failures": "{{count}} failures",
        "localRejections": "{{count}} known local rejections"
      },
      "quotaHealth": {
        "title": "Provider quota health",
        "emptyTitle": "No provider quota activity",
        "emptyBody": "No quota or provider health records match the current filters.",
        "quotaLabel": "Quota",
        "providerLabel": "Provider",
        "notRecorded": "No quota row was recorded in this period.",
        "usage": "{{used}} / {{limit}} · {{percent}}"
      },
      "attribution": {
        "title": "Order attribution",
        "coverage": "{{percent}} of audited attempts have a structured order parent.",
        "linkedAttempts": "Parent-linked attempts",
        "distinctOrders": "Distinct parent-linked orders",
        "limitation": "Distinct orders include only structured CHANNEL_ORDER parents. Historical and unlinked attempts remain unattributed; channel attribution is unavailable."
      },
      "operations": {
        "title": "Operation breakdown",
        "emptyTitle": "No operations",
        "emptyBody": "No audited operations match the current filters.",
        "orderCoverage": "Order attribution"
      },
      "calls": {
        "title": "Raw aggregate call data",
        "emptyTitle": "No provider calls",
        "emptyBody": "No provider API calls match the current filters.",
        "table": {
          "day": "Day",
          "organization": "Organization",
          "provider": "Provider",
          "endpoint": "Endpoint",
          "status": "Status",
          "count": "Calls",
          "failures": "Failures"
        }
      },
      "actions": {
        "organization": "Organization",
        "proxy": "Proxy",
        "stockDiagnostics": "Stock-sync diagnostics",
        "diagnostics": "Diagnostics"
      },
      "quotas": {
        "title": "Quota usage",
        "emptyTitle": "No quota rows",
        "emptyBody": "No quota usage rows match the current filters."
      },
      "health": {
        "title": "Provider health",
        "emptyTitle": "No health rows",
        "emptyBody": "No provider health rows match the current filters.",
        "failures": "{{count}} consecutive failures"
      },
      "providerHint": "Providers in this result: {{providers}}"
    },
    "scheduledTasks": {
      "loading": "Loading failed scheduled tasks…",
      "title": "Failed scheduled tasks",
      "subtitle": "Only failed task executions appear here. Retry with care; handlers must be idempotent.",
      "diagnostics": "Diagnostics",
      "error": {
        "title": "Could not load failed tasks",
        "body": "The scheduled-task endpoint did not respond."
      },
      "empty": {
        "title": "No failed scheduled tasks",
        "body": "All scheduled tasks are clear."
      },
      "table": {
        "task": "Task",
        "instance": "Instance",
        "lastFailure": "Last failure",
        "executionTime": "Execution time",
        "failures": "Failures"
      },
      "retry": {
        "action": "Retry",
        "retrying": "Retrying…",
        "confirm": "Retry {{taskName}} instance {{instanceId}}?",
        "accepted": "Retry accepted. The failed task list was refreshed.",
        "failed": "Retry request failed. Check the task state and try again."
      }
    },
    "stockDiagnostics": {
      "loading": "Loading stock-sync diagnostics…",
      "run": "Allocation run",
      "title": "{{provider}} stock-sync diagnostics",
      "inspectConnection": "Inspect organization",
      "transport": "Transport result",
      "transportCompleted": "Provider request completed; item results were parsed",
      "itemResult": "Item-level result",
      "itemRejected": "{{count}} rejected items",
      "itemAccepted": "All items accepted",
      "taskName": "Scheduler task",
      "taskInstance": "Task instance",
      "retry": "Retry failed items only",
      "retrying": "Retrying…",
      "retryFailed": "The failed items could not be retried. Check the connection and try again.",
      "codes": "Provider-code distribution",
      "metrics": { "attempted": "Attempted", "pushed": "Submitted", "failed": "Failed", "skipped": "Skipped" },
      "table": { "product": "Product", "sku": "SKU", "quantity": "Quantity", "code": "Provider code", "message": "Sanitized provider message" },
      "empty": { "title": "No allocation runs", "body": "Stock-allocation diagnostics will appear after the first run." },
      "error": { "title": "Could not load diagnostics", "body": "The stock-allocation diagnostics endpoint did not respond." }
    },
    "providerProxy": {
      "loading": "Loading provider proxy…",
      "error": {
        "title": "Could not load provider proxy",
        "body": "The admin directory endpoint did not respond."
      },
      "empty": {
        "title": "No connections for this selection",
        "body": "Choose another organization or surface with a connected provider."
      },
      "fields": {
        "surface": "Surface",
        "organization": "Organization",
        "connection": "Connection",
        "method": "Method",
        "path": "Path",
        "queryParams": "Query parameters",
        "headers": "Safe headers",
        "body": "Body"
      },
      "surface": {
        "channel": "Channel provider",
        "inventory": "Inventory provider"
      },
      "placeholders": {
        "path": "/api/path"
      },
      "hints": {
        "keyValue": "One key=value or key: value per line.",
        "headers": "Forbidden auth and secret headers are blocked client-side and server-side.",
        "body": "Raw upstream request body. Leave empty for GET requests."
      },
      "validation": {
        "pathSlash": "Path must start with /.",
        "pathAbsolute": "Path must be relative and cannot include ://.",
        "connection": "Choose a connection before sending.",
        "forbiddenHeader": "Header {{header}} is not allowed.",
        "keyValue": "Use one key=value or key: value entry per line.",
        "requestFailed": "Proxy request failed before an upstream response was returned.",
        "pathTraversal": "Path traversal segments are not allowed."
      },
      "confirmMutating": "Send a {{method}} provider proxy request?",
      "actions": {
        "send": "Send proxy request",
        "sending": "Sending…"
      },
      "response": {
        "title": "Upstream response",
        "status": "Status {{status}}",
        "header": "Header",
        "value": "Value",
        "emptyBody": "No response body captured."
      }
    }
  },
  "public": {
    "landing": {
      "nav": {
        "aria": "Landing navigation",
        "how": "How it works",
        "features": "Product",
        "billing": "Billing",
        "faq": "FAQ",
        "signIn": "Sign in",
        "getStarted": "Try it free",
        "mobileAria": "Mobile landing navigation",
        "menuOpen": "Open menu",
        "menuClose": "Close menu"
      },
      "skip": "Skip to main content",
      "social": {
        "eyebrow": "By the numbers",
        "title": "Built for the way Saudi merchants actually sell.",
        "items": {
          "channels": {
            "value": "5+",
            "label": "Sales channels",
            "body": "Salla, Noon, Amazon, Zid, and Trendyol stay in sync from one place."
          },
          "inbox": {
            "value": "1",
            "label": "Order inbox",
            "body": "Every channel's orders land in a single queue with full context."
          },
          "sync": {
            "value": "Seconds",
            "label": "Target sync",
            "body": "Stock changes push back out fast enough that the next buyer sees the truth."
          },
          "manual": {
            "value": "0",
            "label": "Spreadsheet hops",
            "body": "No manual exports and no reconciling stock by hand across dashboards."
          }
        }
      },
      "faq": {
        "eyebrow": "FAQ",
        "title": "Questions merchants ask before connecting.",
        "items": {
          "channels": {
            "question": "Which sales channels does Tlaaq support?",
            "answer": "Tlaaq connects Salla, Noon, Amazon, Zid, and Trendyol today, with the same sync model across every channel you link."
          },
          "sku": {
            "question": "Do my SKUs need to match across channels?",
            "answer": "Matching SKUs make setup faster, but Tlaaq also surfaces unmapped listings so you can review and correct channel mappings before relying on automated updates."
          },
          "billing": {
            "question": "How does billing work?",
            "answer": "For Salla and Zid the charge stays on the marketplace bill you already reconcile. Amazon, Noon, and Trendyol connections stay free in the initial offer."
          },
          "zoho": {
            "question": "Can I keep Zoho as my source of truth?",
            "answer": "Yes. If Zoho already owns your catalog and inventory, keep it there. If not, start with Tlaaq and connect Zoho later without rebuilding your channels."
          },
          "safety": {
            "question": "Will connecting Tlaaq change my stock immediately?",
            "answer": "Connecting authorizes access. Inventory updates depend on your product mappings and chosen source-of-truth settings, so you can review the setup before enabling automated sync."
          },
          "setup": {
            "question": "How long does setup take?",
            "answer": "Connect a channel securely, review the catalog mapping, and choose the inventory source. Tlaaq keeps those decisions visible before automated synchronization begins."
          },
          "support": {
            "question": "What happens when a sync fails?",
            "answer": "Tlaaq shows the exact row, system, and corrective action instead of failing silently, so the operator can fix the precise issue."
          }
        }
      },
      "mobileCta": {
        "aria": "Mobile sign-up",
        "caption": "Start with your first channel",
        "primary": "Get started"
      },
      "hero": {
        "eyebrow": "Built for multichannel growth",
        "titleLine1": "Sell everywhere.",
        "titleLine2": "Run it all",
        "titleAccent": "in sync.",
        "body": "Connect Salla, Zid, Noon, Amazon, and Trendyol. Keep inventory aligned, bring orders into one workspace, and expand without adding more manual work.",
        "primaryCta": "Start syncing",
        "secondaryCta": "See how it works",
        "connectsTo": "Connects to",
        "salesChannels": "Sales channels",
        "inventorySources": "Inventory sources",
        "visual": {
          "live": "Live",
          "time": "2s ago",
          "eyebrow": "New order",
          "order": "Noon · #SA-31840",
          "sku": "Cotton Hoodie · L · ×1",
          "syncTitle": "Stock just synced across",
          "syncValue": "−1 · 23 left",
          "miniTitle": "Oversell prevented",
          "miniBody": "37× this week"
        }
      },
      "problem": {
        "eyebrow": "The daily reality",
        "title": "Does this sound like your operation?",
        "body": "You sell in more than one place, but keeping every channel aligned still depends on someone checking dashboards, updating sheets, and hoping nothing was missed.",
        "before": {
          "title": "A day of chasing stock",
          "time1": "10:32",
          "time2": "10:34",
          "time3": "10:41",
          "time4": "11:12",
          "row1": "You open every sales channel to compare stock levels.",
          "row2": "A spreadsheet becomes the temporary source of truth.",
          "row3": "A cancellation reveals the mismatch only after the sale.",
          "row4": "No one knows whether the last update reached every channel."
        },
        "after": {
          "title": "A day that stays under control",
          "time1": "10:32",
          "time2": "10:34",
          "time3": "10:41",
          "time4": "—",
          "row1": "Orders from every channel appear in one inbox.",
          "row2": "One inventory source drives stock across every store.",
          "row3": "Updates move without exports or manual reconciliation.",
          "row4": "When a sync needs attention, the affected channel and next action are clear."
        }
      },
      "how": {
        "eyebrow": "How it works",
        "title": "Three steps from scattered stores to one synchronized operation.",
        "body": "Connect your sales channels, decide where inventory truth lives, and let Tlaaq keep orders and stock moving together.",
        "phases": {
          "connect": {
            "title": "Connect your first channel",
            "body": "Use OAuth to connect seller accounts without sharing passwords or copying API secrets by hand.",
            "cardTitle": "OAuth handoff",
            "cardBody": "Salla, Zid, Amazon, and the other channels keep their own authorization flow. Tlaaq stores the callback and continues after sign-in when needed."
          },
          "map": {
            "title": "Map your catalog by SKU",
            "body": "Tlaaq pulls products from every channel and highlights the SKUs that still need cleanup before automated stock updates are trustworthy.",
            "cardTitle": "Mismatch review",
            "cardBody": "You see the rows that disagree, fix the SKU once, and stop chasing the same inconsistency across multiple dashboards."
          },
          "source": {
            "title": "Choose a source of truth",
            "body": "If Zoho already owns your catalog, keep it there. If not, start with Tlaaq and connect Zoho later without rewriting the channel setup.",
            "cardTitle": "Ownership switch",
            "cardBody": "The product surface needs a clear answer to where catalog and stock live. Tlaaq then pushes that state outward."
          },
          "sync": {
            "title": "A sale lands and stock drops everywhere",
            "body": "One order should update every connected marketplace quickly enough that the next customer never sees stale stock.",
            "cardTitle": "Live sync trace",
            "cardBody": "Channel event in, inventory update in Tlaaq, stock pushed back out, and Zoho sales-order creation if the inventory connection is active."
          },
          "orders": {
            "title": "Work from one order inbox",
            "body": "Orders arrive with their channel identity, status, and money context so the team can ship from one workspace instead of tab-switching all day.",
            "cardTitle": "Unified queue",
            "cardBody": "The product already treats order status, channel, and sync state as first-class data, so the landing page should make that consolidation explicit."
          },
          "errors": {
            "title": "See failures clearly when they happen",
            "body": "When something fails, the useful detail is the row, the system, and the next corrective action. Silent sync failure is the real problem.",
            "cardTitle": "Actionable errors",
            "cardBody": "Tlaaq should show which downstream step failed and why, so the operator can fix the exact issue instead of retrying blind."
          }
        }
      },
      "features": {
        "eyebrow": "Inside Tlaaq",
        "title": "See the daily work that moves into one place.",
        "items": {
          "variance": {
            "title": "Find inventory differences before they become sales problems",
            "body": "When Zoho is the inventory source, Tlaaq compares its quantities with mapped sales channels and surfaces drift for review.",
            "visualTitle": "Inventory variance",
            "sourceLabel": "Source of truth",
            "comparison": "Compare mapped quantities across connected channels",
            "result": "Differences are surfaced for review"
          },
          "sync": {
            "title": "Real-time sync",
            "body": "Stock and order updates push across connected channels within seconds instead of waiting for manual refreshes."
          },
          "inbox": {
            "title": "One inbox for orders",
            "body": "Salla, Noon, Amazon, Zid, and Trendyol orders land in one place with the right context already attached."
          },
          "protection": {
            "title": "Oversell protection",
            "body": "The product is built around preventing impossible sales instead of cleaning them up after the marketplace already punished you."
          },
          "catalog": {
            "title": "One product, many channels",
            "body": "Define a product once, map it correctly, and keep the catalog aligned across marketplaces."
          },
          "zoho": {
            "title": "Choose the inventory source",
            "body": "Use Tlaaq as the source of truth, or keep Zoho in control when it already owns your inventory workflow."
          },
          "errors": {
            "title": "A failed sync never disappears silently",
            "body": "See the affected channel, product, and failed step together so the operator knows what needs attention."
          }
        }
      },
      "confidence": {
        "eyebrow": "Operational confidence",
        "title": "Automation should never leave you guessing.",
        "body": "When a channel needs attention, Tlaaq keeps the problem visible and gives the operator enough context to act.",
        "items": {
          "visible": {
            "title": "Nothing fails silently",
            "body": "See which channel or connection needs attention instead of discovering drift from a cancelled order."
          },
          "diagnose": {
            "title": "Understand the exact problem",
            "body": "Keep the affected product, channel, and failed step together instead of searching across separate logs."
          },
          "recover": {
            "title": "Fix only what needs fixing",
            "body": "Identify and correct the precise issue without repeating the investigation across the entire workflow."
          }
        }
      },
      "billing": {
        "eyebrow": "How billing works",
        "title": "You do not need a separate Tlaaq billing stack to get started.",
        "body": "For Salla and Zid, Tlaaq fits into the marketplace billing merchants already use. The other channels stay free while you connect and operate them.",
        "recommended": "Recommended",
        "cards": {
          "salla": {
            "badge": "Through marketplace",
            "title": "Salla",
            "price": "From 199 SAR/mo",
            "body": "Install Tlaaq from the Salla app store and keep the charge on the same Salla bill your team already reconciles.",
            "cta": "View on Salla store"
          },
          "zid": {
            "badge": "Through marketplace",
            "title": "Zid",
            "price": "From 299 SAR/mo",
            "body": "Install through the Zid market and keep subscription management inside the Zid workflow you already use.",
            "cta": "View on Zid market"
          },
          "free": {
            "badge": "Always free",
            "title": "Amazon, Noon, Trendyol",
            "price": "Free",
            "body": "Public seller APIs let these connections stay free in the initial offer while the merchant still gets the same sync model.",
            "cta": "See connected channels"
          }
        },
        "note": "Keep billing where merchants already expect it. No extra vendor setup just to test whether the workflow fits."
      },
      "cta": {
        "title": "Stop overselling. Start syncing.",
        "body": "Give the team one place to connect channels, decide catalog ownership, and keep inventory moving in the right direction.",
        "primary": "Get started",
        "secondary": "Sign in"
      },
      "proposal": {
        "hero": {
          "title": "Sync your inventory with your stores in real time",
          "body": "",
          "primary": "Connect your store",
          "secondary": "See how it works"
        },
        "integrations": {
          "sources": "Inventory sources",
          "channels": "Sales channels"
        },
        "preview": {
          "back": "← Back to stores",
          "title": "Inventory differences across stores",
          "subtitle": "Review quantity differences between your stores and inventory.",
          "noticeTitle": "Read-only remediation guidance",
          "noticeBody": "This screen does not change stock or push quantities. Inspect the product and review allocation rules.",
          "disclaimer": "Tlaaq interface · Illustrative data, not real store data",
          "search": "Search",
          "searchValue": "SKU, product, listing, or store ID…",
          "filterStores": "Stores",
          "filterStoresValue": "All stores⌄",
          "apply": "Apply filters",
          "shirt": "Cotton shirt · Blue",
          "shirtListing": "Blue cotton shirt",
          "mug": "Ceramic mug · White",
          "mugListing": "White ceramic mug",
          "danger": "Danger",
          "connected": "Connected",
          "store": "Demo store",
          "reason": "Store has no stock while the product is available",
          "source": "Inventory",
          "channel": "Store",
          "difference": "Difference",
          "lastSeen": "Last seen: 1 Jun · 10:30 AM",
          "date": "1 Jun",
          "view": "View product",
          "allocation": "Stock allocation",
          "columns": {
            "product": "Product",
            "listing": "Store",
            "source": "Inventory",
            "channel": "Store",
            "difference": "Difference",
            "variance": "Variance",
            "seen": "Last updated",
            "actions": "Actions"
          }
        },
        "operations": {
          "eyebrow": "ONE PLATFORM FOR ALL YOUR STORES",
          "title": "See every store as one operation",
          "body": "A live overview, one catalog, and one order queue across all your stores.",
          "demo": "Real demo account",
          "items": {
            "dashboard": {
              "mobileLabel": "DASHBOARD",
              "title": "A summary of the information that matters",
              "body": "Track sales, products, stores, and actions that need your attention.",
              "alt": "Tlaaq dashboard showing sales, products, stores, and actions"
            },
            "products": {
              "mobileLabel": "PRODUCTS · REAL DEMO ACCOUNT",
              "title": "One catalog across all your stores",
              "body": "See product status, pricing, inventory, and availability across stores.",
              "alt": "Tlaaq product catalog across connected stores"
            },
            "orders": {
              "mobileLabel": "ORDERS",
              "title": "Every order in one queue",
              "body": "Process orders from Zid, Salla, Amazon, Trendyol, and Noon without switching systems.",
              "alt": "Tlaaq unified order queue across connected stores"
            }
          }
        },
        "story": {
          "title": "Know why your stock differs.",
          "body": "Find products that weren’t distributed correctly across stores, then set an allocation schedule so every store reflects the right stock.",
          "example": "An example from the report.",
          "product": "Blue cotton shirt",
          "source": "Source",
          "salesChannel": "Channel",
          "stock": "Stock",
          "sourceStock": "Source stock",
          "channelStock": "Channel stock",
          "difference": "Difference"
        },
        "setup": {
          "title": "Start with one store. We’ll help with the rest.",
          "step1": "Connect a store.",
          "step2": "We import products and orders from the store.",
          "step3": "Choose your inventory source: the store, Zoho, or Tlaaq.",
          "step4": "Set inventory allocation percentages and enable automatic allocation.",
          "step5": "Optional: sync orders in real time with your external inventory system."
        },
        "faq": {
          "title": "Frequently asked questions",
          "zoho": {
            "question": "Do I need an external inventory system?",
            "answer": "Connecting grants access. Quantity updates depend on product mappings, your inventory source, and the sync settings you choose."
          },
          "stock": {
            "question": "Does connecting immediately change stock?",
            "answer": "No. You can use Tlaaq as your inventory source, or connect Zoho if you already manage inventory there."
          },
          "sync": {
            "question": "What happens if a sync fails?",
            "answer": "Review unmapped products and correct the mapping before relying on automated inventory updates."
          }
        }
      },
      "footer": {
        "copy": "A DevOcean Labs product · Riyadh",
        "privacy": "Privacy",
        "terms": "Terms",
        "contact": "Contact"
      }
    },
    "site": {
      "skip": "Skip to main content",
      "lastUpdated": "Last updated: 1 October 2026",
      "onThisPage": "On this page",
      "nav": {
        "aria": "Public information navigation",
        "home": "Tlaaq home",
        "privacy": "Privacy",
        "terms": "Terms",
        "faq": "FAQ",
        "support": "Support",
        "signIn": "Sign in"
      },
      "footer": {
        "aria": "Public information links",
        "description": "Inventory and order synchronization for merchants.",
        "identity": "Ocean Devs · مؤسسة محيط البرمجة · Unified number 7051193857",
        "location": "Al Narjis District, Riyadh, Saudi Arabia"
      },
      "privacy": {
        "title": "Privacy Policy",
        "sections": {
          "identity": {
            "title": "Who we are and our roles",
            "body": "Tlaaq is operated under the English trading name Ocean Devs by مؤسسة محيط البرمجة, a Saudi sole proprietorship with unified number 7051193857, based in Al Narjis District, Riyadh, Saudi Arabia.\n\nFor merchant account, support, security, and service-administration data, we act as controller. For personal data in orders that a merchant connects to Tlaaq, the merchant generally determines the purpose and acts as controller, while Tlaaq processes that information on the merchant’s instructions."
          },
          "information": {
            "title": "Information we process",
            "body": "We process merchant and team account details, login and security records including IP addresses, support communications, encrypted provider credentials, and configuration choices. Connected services may supply product, listing, warehouse, inventory, order, payment, fulfillment, customer contact, and delivery information.\n\nWe use essential browser storage to operate Tlaaq: HTTP-only cookies maintain signed-in sessions and protect Google sign-in, local storage remembers language and dismissed job notices, and session storage preserves temporary integration handoffs. Sentry may capture a replay when an error occurs; text is masked and media is blocked.\n\nWe also process technical diagnostics such as provider call outcomes, trace identifiers, device or browser information, and error events. Tlaaq’s current Amazon integration does not request or retain Amazon restricted buyer contact, tax, or delivery-address data."
          },
          "purposes": {
            "title": "Why we process information",
            "body": "We use information to create and secure accounts, connect services authorized by merchants, synchronize catalog and inventory data, process and reconcile orders, provide support, diagnose failures, prevent abuse, improve reliability, and comply with legal obligations.\n\nDepending on the activity, processing is necessary to perform our service agreement, meet a legal obligation, pursue a legitimate operational or security interest that does not override individual rights, or act on valid consent where consent is required."
          },
          "providers": {
            "title": "Service providers and international transfers",
            "body": "Primary application and database infrastructure is hosted by Hetzner in Falkenstein, Germany. Cloudflare R2 provides object and backup storage. We also use Sentry for error monitoring, Better Stack for logs, Resend for transactional email, and Google for optional sign-in. Connected channels and inventory systems—including Salla, Zid, Amazon, Noon, Trendyol, and Zoho—process data needed for their integrations.\n\nThese services may process information outside Saudi Arabia. We limit shared information to what is needed and use contractual, security, and transfer safeguards required by applicable law. We do not sell personal data."
          },
          "rights": {
            "title": "Your privacy rights",
            "body": "Subject to the Saudi Personal Data Protection Law and its conditions, individuals may ask to be informed about processing, access their personal data, receive a clear copy, correct or complete inaccurate data, request destruction when applicable, and withdraw consent where processing depends on consent.\n\nMerchants should normally handle requests from their shoppers because the merchant controls that order data. We will assist merchants and will handle requests concerning Tlaaq-controlled account or support data after verifying the requester’s identity."
          },
          "retention": {
            "title": "Retention, deletion, and contact",
            "body": "Provider API-call audit entries and completed webhook audit records are removed after 90 days. Other account and order records are retained while needed to provide the service and may be kept longer where required for security, disputes, accounting, marketplace obligations, or law. We assess account-closure and destruction requests under applicable law. Backup copies remain protected until they expire through the applicable backup lifecycle.\n\nTo request access, correction, a copy, account closure, or destruction where applicable, email support@tlaaq.com. We may ask for information needed to verify identity and authority before acting."
          }
        },
        "request": {
          "title": "Exercise a privacy right",
          "body": "Email support@tlaaq.com"
        }
      },
      "terms": {
        "title": "Terms of Service",
        "sections": {
          "account": {
            "title": "Accounts and authority",
            "body": "You must provide accurate account information, protect your credentials, and be legally able to bind the merchant organization you register. You are responsible for activity performed through your account and for promptly removing access from people who no longer need it."
          },
          "service": {
            "title": "The Tlaaq service",
            "body": "Tlaaq connects supported commerce channels and inventory systems to synchronize products, listings, stock, and orders. Available operations differ by provider, plan, permissions, and merchant configuration. You authorize Tlaaq to call connected providers and process the returned information only to provide and protect the service."
          },
          "subscriptions": {
            "title": "Subscriptions, renewal, and refunds",
            "body": "Paid Tlaaq subscriptions are currently purchased and administered through Salla or Zid. Prices, trial periods, renewal, cancellation, taxes, and refund eligibility are shown in the relevant marketplace and are governed by its billing rules and the plan selected there. Tlaaq does not currently collect subscription card payments directly."
          },
          "responsibilities": {
            "title": "Merchant responsibilities",
            "body": "You remain responsible for your products, prices, inventory decisions, orders, customer communications, legal notices, tax and invoicing duties, and compliance with each connected provider’s rules. Review mappings, source-of-truth settings, allocation rules, and proposed actions before relying on automation. Do not use Tlaaq to process information you are not authorized to access."
          },
          "availability": {
            "title": "Availability and third-party services",
            "body": "We work to keep Tlaaq reliable, but synchronization depends on third-party APIs, credentials, quotas, provider outages, and merchant configuration. We do not promise uninterrupted or error-free operation. Features may change when a provider changes its API or marketplace rules. Tlaaq is not responsible for a third-party platform’s independent acts or availability."
          },
          "termination": {
            "title": "Suspension and account closure",
            "body": "You may cancel through the marketplace that administers your subscription and may request account closure through support@tlaaq.com. We may restrict or suspend access to protect the service, comply with law or provider rules, address non-payment, or respond to material misuse. Data is handled after closure as described in the Privacy Policy and applicable legal requirements."
          },
          "liability": {
            "title": "Disclaimers and limitation of liability",
            "body": "To the maximum extent permitted by mandatory law, Tlaaq is provided as available and without implied warranties. Neither party is liable for indirect, incidental, special, or consequential loss. Ocean Devs’ aggregate liability arising from the service is limited to the subscription fees paid for Tlaaq during the 12 months preceding the event giving rise to the claim. Nothing in these terms excludes liability that cannot legally be excluded."
          },
          "law": {
            "title": "Governing law, language, and contact",
            "body": "These terms are governed by the laws of the Kingdom of Saudi Arabia, and disputes are subject to the competent courts in Riyadh unless mandatory law requires otherwise. The Arabic version controls if the Arabic and English versions conflict. Questions about these terms may be sent to support@tlaaq.com."
          }
        }
      },
      "faq": {
        "title": "Frequently Asked Questions",
        "subtitle": "Straightforward answers about accounts, integrations, synchronization, data, and billing.",
        "browse": "Browse by topic",
        "categoriesAria": "FAQ topics",
        "categories": {
          "all": "All",
          "account": "Account",
          "integrations": "Integrations",
          "sync": "Sync",
          "data": "Data",
          "billing": "Billing"
        },
        "questions": {
          "connect": { "question": "How do I connect a store?", "answer": "Open Channels after signing in, choose a supported provider, and complete its authorization flow. Tlaaq stores provider credentials encrypted and uses them only for authorized operations." },
          "providers": { "question": "Which services can I connect?", "answer": "Tlaaq supports Salla, Zid, Amazon, Noon, and Trendyol as commerce channels, with Tlaaq or Zoho available as inventory sources. Capabilities differ by provider." },
          "synchronize": { "question": "Which information does Tlaaq synchronize?", "answer": "Authorized connections can synchronize products, listings, warehouses, inventory, and orders. Available actions depend on the provider, permissions, and your configuration." },
          "failure": { "question": "What happens if a sync fails?", "answer": "Tlaaq records the operational result and shows actionable errors where possible. Correct expired authorization, missing mappings, provider limits, or configuration issues before retrying." },
          "stock": { "question": "Does connecting immediately change stock?", "answer": "No. Connecting grants access, but quantity updates depend on mappings, the selected inventory source, allocation rules, and the automation settings you enable." },
          "security": { "question": "How is connection data protected?", "answer": "Provider credentials are encrypted, access is tenant-scoped, and operational monitoring is limited to diagnostics needed to secure and maintain the service. No internet service can guarantee absolute security." },
          "rights": { "question": "How can I request access, correction, or deletion?", "answer": "Email support@tlaaq.com. We verify identity and authority, then handle Tlaaq-controlled data or assist the responsible merchant with connected order data." },
          "amazon": { "question": "Does Tlaaq access Amazon restricted buyer data?", "answer": "Not currently. The Amazon integration excludes restricted buyer contact, tax, and delivery-address information. Restricted access would only be added for an approved shipping or invoicing need." },
          "team": { "question": "Can several people use one merchant workspace?", "answer": "Yes. Owners can invite team members and should remove access when it is no longer required. Each person should use their own account." },
          "plans": { "question": "Where do I manage my subscription?", "answer": "Subscriptions, renewals, cancellation, and eligible refunds are currently managed through the Salla or Zid marketplace where the plan was purchased." }
        }
      },
      "support": {
        "title": "Support",
        "subtitle": "Get help with your account, connected services, or privacy requests.",
        "email": { "title": "Email support", "body": "For account, integration, subscription, and technical questions.", "address": "support@tlaaq.com" },
        "whatsapp": { "title": "WhatsApp", "body": "Chat with the Tlaaq support team on WhatsApp.", "action": "Open WhatsApp", "unavailable": "WhatsApp support is temporarily unavailable." },
        "privacy": { "title": "Privacy rights request", "body": "Request access, correction, a copy, account closure, or destruction where applicable under Saudi PDPL.", "action": "Read the Privacy Policy" }
      }
    }
  }
}
